import React, { useState, useEffect, useRef } from 'react';
import { supabase } from './lib/supabase';
import MuxPlayer from '@mux/mux-player-react';
import { PaywallModal } from './Paywall';
import AdminDashboard from './AdminDashboard';
import UploadScreen from './UploadScreen';
import LandingPage from './LandingPage';
import ApplyScreen from './ApplyScreen';


function redirectToPayFast(plan = "viewer") {
  const merchantId = process.env.REACT_APP_PAYFAST_MERCHANT_ID;
  const merchantKey = process.env.REACT_APP_PAYFAST_MERCHANT_KEY;
  const returnUrl = process.env.REACT_APP_PAYFAST_RETURN_URL;
  const cancelUrl = process.env.REACT_APP_PAYFAST_CANCEL_URL;
  const notifyUrl = process.env.REACT_APP_PAYFAST_NOTIFY_URL;

  const amount = plan === "viewer" ? "49.00" : "129.00";
  const itemName =
    plan === "viewer"
      ? "VAULTT Viewer Subscription"
      : "VAULTT Premium Subscription";

  const paymentId = `vaultt-${plan}-${Date.now()}`;

  const form = document.createElement("form");
  form.method = "POST";
  form.action = "https://sandbox.payfast.co.za/eng/process";

  const fields = {
    merchant_id: merchantId,
    merchant_key: merchantKey,
    return_url: returnUrl,
    cancel_url: cancelUrl,
    notify_url: notifyUrl,
    name_first: "Vaultt",
    email_address: "customer@vaultt.co.za",
    m_payment_id: paymentId,
    amount,
    item_name: itemName,
  };

  Object.entries(fields).forEach(([key, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = key;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
}

const C = {
  bg:'#06070b', bg2:'#0d1118', bg3:'#141a24',
  blue:'#4ba3ff', blueL:'rgba(75,163,255,0.14)', blueB:'rgba(176,202,233,0.2)',
  white:'#ffffff', grey:'#9ea6b4', grey2:'#d7dde8', grey3:'#2a3442',
  green:'#46d369', red:'#ff5a54', gold:'#f1c66d', border:'rgba(176,202,233,0.12)',
  card:'rgba(20,26,36,0.9)',
};

const DEMO_SHOWS = [
  {id:1,title:'Hustle SA',type:'series',cat:'SA Originals',eps:8,emoji:'\u{1F3AD}',g:'135deg,#2a4266,#385c88',creator:'Yanga Sibisi',subs:'42K',match:98,isNew:true,isLocal:true,desc:'A Soweto entrepreneur fights to keep his family business alive against corporate giants.',top10:1},
  {id:2,title:'The Real Joburg',type:'reality',cat:'SA Originals',eps:12,emoji:'\u{1F3D9}',g:'135deg,#2f3550,#1d2336',creator:'Nandi Dlamini',subs:'128K',match:95,isNew:true,isLocal:true,desc:'Inside the lives of Johannesburg most ambitious young professionals. No filters.',top10:2},
  {id:3,title:'Mzansi Kitchen',type:'series',cat:'SA Originals',eps:24,emoji:'\u{1F372}',g:'135deg,#40502b,#69733e',creator:'Nokuthula Dube',subs:'84K',match:94,isNew:false,isLocal:true,desc:'Celebrating the rich flavours and food culture of South Africa.',top10:3},
  {id:4,title:'PSL Live',type:'sports',cat:'Sports',eps:1,emoji:'\u26BD',g:'135deg,#1f3426,#34583a',creator:'Football SA',subs:'96K',match:99,isNew:true,isLocal:true,desc:'Live watch-alongs, pre-match analysis and post-match breakdowns for every PSL game.',top10:4},
  {id:5,title:'Springbok Talk',type:'sports',cat:'Sports',eps:16,emoji:'\u{1F3C9}',g:'135deg,#213924,#3f5d34',creator:'Rugby Breakdown',subs:'67K',match:97,isNew:false,isLocal:true,desc:'Weekly in-depth analysis of the Springboks. Stats, tactics and fan debate.',top10:5},
  {id:6,title:'The Roundtable',type:'talk_show',cat:'Talk Shows',eps:20,emoji:'\u{1F399}',g:'135deg,#453126,#77513a',creator:'Various',subs:'210K',match:93,isNew:false,isLocal:true,desc:'SA creators come together for unfiltered conversations about life, business and culture.',top10:6},
  {id:7,title:'Hustle Talks',type:'talk_show',cat:'Talk Shows',eps:8,emoji:'\u{1F4BC}',g:'135deg,#35294a,#5c4772',creator:'Thabo Mokoena',subs:'128K',match:96,isNew:true,isLocal:true,desc:'Raw conversations with SA entrepreneurs about what it really takes to build something.',top10:7},
  {id:8,title:'The Breakdown Pod',type:'podcast',cat:'Podcasts',eps:32,emoji:'\u{1F3A7}',g:'135deg,#23364e,#345779',creator:'DJ Nomvula',subs:'145K',match:92,isNew:true,isLocal:true,desc:'Weekly video podcast covering SA business, culture, music and current affairs.',top10:8},
  {id:9,title:'Mind and Body SA',type:'podcast',cat:'Podcasts',eps:28,emoji:'\u{1F9E0}',g:'135deg,#2d3f23,#4f6737',creator:'Lebo Fitness',subs:'67K',match:89,isNew:false,isLocal:false,desc:'Health, wellness and mental fitness for South Africans.',top10:9},
  {id:10,title:'Comedy Central SA',type:'comedy',cat:'SA Originals',eps:20,emoji:'\u{1F602}',g:'135deg,#593323,#7a4a31',creator:'Zakhele Ndlovu',subs:'310K',match:97,isNew:false,isLocal:true,desc:'South Africa freshest comedy voices in one place. No corporate speak. Just funny.',top10:10},
];

const LIVE_NOW = [
  {id:1,name:'Football SA',title:'PSL: Chiefs vs Pirates - LIVE',viewers:12400,emoji:'\u26BD',bg:'135deg,#0c2a0c,#1a5a1a'},
  {id:2,name:'DJ Nomvula',title:'Friday amapiano set',viewers:8820,emoji:'\u{1F3B5}',bg:'135deg,#0a1a2d,#14355c'},
  {id:3,name:'Thabo Mokoena',title:'Q&A: Building your side hustle',viewers:3240,emoji:'\u{1F4BC}',bg:'135deg,#1a0a2d,#2d145c'},
];

const NIGHTDROP_DEMO_EPISODES = [
  {
    id:'nightdrop-demo-1',
    episode_number:1,
    title:'Sandton After Dark',
    synopsis:'A luxury launch party turns dangerous when a missing phone exposes a secret affair and a suspicious cash transfer.',
    status:'voting_open',
    vote_option_a:'Lebo confronts the host on camera',
    vote_option_b:'Ayanda follows the money trail instead',
    vote_closes_at:new Date(Date.now() + 1000 * 60 * 60 * 9).toISOString(),
    publish_at:new Date(Date.now() - 1000 * 60 * 90).toISOString(),
    art_gradient:'135deg,#171a27,#40334a',
    hook:'One room. Too much money. One secret about to spill in public.',
  },
  {
    id:'nightdrop-demo-2',
    episode_number:2,
    title:'The Soft Launch',
    synopsis:'The fallout moves from gossip to blackmail as screenshots leak and old business loyalties begin to crack.',
    status:'scheduled',
    vote_option_a:'Thandeka leaks the voice note',
    vote_option_b:'The investor arrives early',
    vote_closes_at:new Date(Date.now() + 1000 * 60 * 60 * 33).toISOString(),
    publish_at:new Date(Date.now() + 1000 * 60 * 60 * 24).toISOString(),
    art_gradient:'135deg,#11161f,#2c4258',
    hook:'Nobody leaves the launch untouched once the first message lands.',
  },
  {
    id:'nightdrop-demo-3',
    episode_number:3,
    title:'After the Vote',
    synopsis:'The audience choice reshapes the next move as reputations and leverage shift across Johannesburg overnight.',
    status:'planned',
    vote_option_a:'Take the meeting in Rosebank',
    vote_option_b:'Run the story through the podcast first',
    vote_closes_at:new Date(Date.now() + 1000 * 60 * 60 * 57).toISOString(),
    publish_at:new Date(Date.now() + 1000 * 60 * 60 * 48).toISOString(),
    art_gradient:'135deg,#20151a,#483930',
    hook:'The winning choice always costs someone more than expected.',
  },
];

function getPosterAccent(show) {
  if (show?.cat === 'Sports' || show?.type === 'sports') return '#7fdc8a';
  if (show?.cat === 'Talk Shows' || show?.type === 'talk_show') return '#f1c66d';
  if (show?.cat === 'Podcasts' || show?.type === 'podcast') return '#8fc3ff';
  if (show?.isLocal || show?.cat === 'SA Originals') return '#66b2ff';
  return '#d7dde8';
}

function initialsFromTitle(title = '') {
  return title
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();
}

function formatDateTimeShort(value) {
  if (!value) return 'Date coming soon';
  try {
    return new Date(value).toLocaleString('en-ZA', {
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch (error) {
    return value;
  }
}

function getNightDropPalette(episodeNumber = 1) {
  const palettes = [
    {
      glow: 'rgba(241,198,109,0.22)',
      edge: 'rgba(241,198,109,0.18)',
      wash: 'rgba(94,126,182,0.18)',
      stamp: 'AFTER HOURS',
      micro: 'Sandton nights',
    },
    {
      glow: 'rgba(120,167,235,0.22)',
      edge: 'rgba(120,167,235,0.16)',
      wash: 'rgba(241,198,109,0.1)',
      stamp: 'LEAKED',
      micro: 'Soft launch fallout',
    },
    {
      glow: 'rgba(220,142,117,0.22)',
      edge: 'rgba(220,142,117,0.18)',
      wash: 'rgba(101,122,166,0.16)',
      stamp: 'AFTERMATH',
      micro: 'The vote lands',
    },
  ];
  return palettes[(Math.max(episodeNumber, 1) - 1) % palettes.length];
}

function mapLiveEventCard(event, channelName = 'VAULTT Creator') {
  return {
    id: event.id,
    title: event.title,
    name: channelName,
    viewers: event.status === 'live' ? 420 + Math.floor(Math.random() * 1200) : 0,
    bg: event.status === 'live' ? '135deg,#16293f,#27486c' : '135deg,#1b2636,#313f55',
    description: event.description || 'Upcoming creator-led watch-along and community room.',
    startsAt: event.starts_at,
    status: event.status,
    accessType: event.access_type,
    ticketPrice: event.ticket_price_zar,
    isWatchAlong: event.is_watch_along,
    creator_channel_id: event.creator_channel_id,
  };
}

function PosterArtwork({ show, size = 'card', rank = null }) {
  const accent = getPosterAccent(show);
  const title = show?.title || 'VAULTT';
  const creator = show?.creator || 'VAULTT Creator';
  const category = show?.cat || show?.type || 'Featured';
  const isCard = size === 'card';
  const titleSize = size === 'hero' ? 'clamp(36px,4.8vw,60px)' : size === 'wide' ? 24 : size === 'search' ? 18 : 16;
  const creatorSize = size === 'hero' ? 15 : isCard ? 11 : 12;
  const badgeSize = size === 'hero' ? 11 : 10;
  const monoSize = size === 'hero' ? 120 : size === 'wide' ? 76 : size === 'search' ? 56 : 64;
  const titleMaxWidth = size === 'hero' ? '70%' : isCard ? '100%' : '72%';

  return (
    <div style={{ position:'absolute', inset:0, overflow:'hidden' }}>
      <div style={{ position:'absolute', inset:0, background:`linear-gradient(${show?.g || '135deg,#26374f,#4d5d79'})` }} />
      <div style={{ position:'absolute', inset:0, background:isCard ? 'linear-gradient(180deg,rgba(255,255,255,0.03),transparent 28%,rgba(0,0,0,0.22) 100%)' : 'linear-gradient(180deg,rgba(255,255,255,0.04),transparent 32%,rgba(0,0,0,0.28) 100%)' }} />
      <div style={{ position:'absolute', top:isCard ? '-16%' : '-10%', right:isCard ? '-10%' : '-4%', width:size === 'hero' ? 300 : isCard ? 140 : 170, height:size === 'hero' ? 300 : isCard ? 140 : 170, borderRadius:'50%', background:`radial-gradient(circle, ${accent}55 0%, transparent 62%)`, filter:'blur(6px)', opacity:isCard ? 0.7 : 0.85 }} />
      {isCard ? (
        <>
          <div style={{ position:'absolute', left:14, right:14, top:12, display:'flex', justifyContent:'space-between', alignItems:'center', gap:8 }}>
            <div style={{ padding:'4px 9px', background:'rgba(7,14,22,0.32)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:999, fontSize:9, fontWeight:800, color:C.white, letterSpacing:1.1, textTransform:'uppercase', backdropFilter:'blur(10px)' }}>
              {category}
            </div>
            {rank ? (
              <div style={{ fontSize:18, fontWeight:900, lineHeight:0.9, color:'rgba(255,255,255,0.9)', letterSpacing:-1 }}>
                {rank}
              </div>
            ) : show?.isNew ? (
              <div style={{ padding:'4px 8px', background:'rgba(255,255,255,0.08)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:999, fontSize:9, fontWeight:800, color:C.white, letterSpacing:1.1, textTransform:'uppercase' }}>
                New
              </div>
            ) : null}
          </div>
          <div style={{ position:'absolute', inset:0, background:'linear-gradient(180deg,transparent 42%, rgba(4,8,14,0.18) 74%, rgba(4,8,14,0.34) 100%)' }} />
        </>
      ) : (
        <>
      <div style={{ position:'absolute', left:size === 'hero' ? 28 : isCard ? 14 : 18, right:size === 'hero' ? 28 : isCard ? 14 : 18, top:size === 'hero' ? 22 : isCard ? 12 : 14, display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:12 }}>
        <div style={{ padding:'5px 10px', background:'rgba(7,14,22,0.34)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:999, fontSize:badgeSize, fontWeight:800, color:C.white, letterSpacing:1.2, textTransform:'uppercase', backdropFilter:'blur(10px)' }}>
          {category}
        </div>
        <div style={{ display:'flex', gap:8, alignItems:'center' }}>
          {show?.isNew && <div style={{ padding:isCard ? '4px 8px' : '5px 10px', background:'rgba(255,255,255,0.08)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:999, fontSize:badgeSize, fontWeight:800, color:C.white, letterSpacing:1.2, textTransform:'uppercase' }}>New</div>}
          {rank && <div style={{ fontSize:size === 'hero' ? 54 : isCard ? 22 : 34, fontWeight:900, lineHeight:0.9, color:'rgba(255,255,255,0.9)', letterSpacing:-1.8, textShadow:'0 10px 30px rgba(0,0,0,0.28)' }}>{rank}</div>}
        </div>
      </div>
      <div style={{ position:'absolute', left:size === 'hero' ? 30 : isCard ? 14 : 18, right:size === 'hero' ? 28 : isCard ? 14 : 18, bottom:size === 'hero' ? 24 : isCard ? 14 : 16, display:'flex', justifyContent:'space-between', alignItems:'flex-end', gap:16 }}>
        <div style={{ maxWidth:titleMaxWidth }}>
          <div style={{ fontSize:titleSize, fontWeight:900, lineHeight:isCard ? 0.98 : 0.95, color:C.white, letterSpacing:size === 'hero' ? -1.8 : isCard ? -0.5 : -0.8, marginBottom:isCard ? 6 : 8, textShadow:'0 12px 28px rgba(0,0,0,0.28)' }}>
            {title}
          </div>
          <div style={{ fontSize:creatorSize, color:'rgba(215,221,232,0.9)', lineHeight:1.5 }}>
            {creator}
            {show?.eps ? ` • ${show.eps} episode${show.eps > 1 ? 's' : ''}` : ''}
          </div>
        </div>
        {!isCard && (
          <div style={{ width:size === 'hero' ? 116 : 74, height:size === 'hero' ? 116 : 74, borderRadius:size === 'hero' ? 28 : 22, border:'1px solid rgba(255,255,255,0.08)', background:'rgba(7,14,22,0.26)', backdropFilter:'blur(12px)', display:'flex', alignItems:'center', justifyContent:'center', boxShadow:'inset 0 1px 0 rgba(255,255,255,0.05)' }}>
            <div style={{ fontSize:monoSize, fontWeight:900, color:'rgba(255,255,255,0.12)', letterSpacing:-3, lineHeight:0.8 }}>{initialsFromTitle(title)}</div>
          </div>
        )}
      </div>
        </>
      )}
    </div>
  );
}

function Toast({message,type,onClose}) {
  useEffect(()=>{const t=setTimeout(onClose,4000);return()=>clearTimeout(t);},[onClose]);
  return <div onClick={onClose} style={{position:'fixed',bottom:24,right:24,background:type==='error'?C.red:type==='info'?C.blue:C.green,color:C.white,padding:'14px 20px',borderRadius:4,fontSize:14,fontWeight:600,zIndex:9999,cursor:'pointer',boxShadow:'0 4px 24px rgba(0,0,0,0.5)',maxWidth:320}}>{message}</div>;
}

function LoginScreen({onLogin,onApply}) {
  const [mode,setMode]=useState('signin');
  const [email,setEmail]=useState('');
  const [password,setPassword]=useState('');
  const [name,setName]=useState('');
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState('');
  const inp={width:'100%',padding:'18px 18px',background:'rgba(255,255,255,0.06)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:18,fontSize:15,color:C.white,outline:'none',fontFamily:'inherit',marginBottom:14,boxSizing:'border-box',boxShadow:'inset 0 1px 0 rgba(255,255,255,0.04)'};
  const handleSubmit=async()=>{
    setError('');
    if(!email||!password){setError('Please enter your email and password.');return;}
    setLoading(true);
    try{
      if(mode==='signup'){
        if(!name){setError('Please enter your full name.');setLoading(false);return;}
        const res=await supabase.auth.signUp({email,password});
        if(res.error)throw res.error;
        if(res.data.user){
          await supabase.from('profiles').insert({id:res.data.user.id,email,full_name:name,role:'viewer'});
          setError('Account created. Please check your email to verify, then sign in.');
          setMode('signin');
        }
      }else{
        const res=await supabase.auth.signInWithPassword({email,password});
        if(res.error)throw res.error;
        const pr=await supabase.from('profiles').select('*').eq('id',res.data.user.id).single();
        onLogin(pr.data||{id:res.data.user.id,email,role:'viewer',full_name:email});
      }
    }catch(e){setError(e.message||'Something went wrong.');}
    setLoading(false);
  };
  return (
    <div style={{minHeight:'100vh',background:'radial-gradient(circle at 50% 0%, rgba(10,132,255,0.18) 0%, transparent 24%), radial-gradient(circle at 80% 12%, rgba(255,214,10,0.08) 0%, transparent 18%), linear-gradient(180deg,#06080d 0%,#09111c 42%,#0b1420 100%)',display:'flex',alignItems:'center',justifyContent:'center',padding:'42px 18px'}}>
      <div style={{width:'100%',maxWidth:1160,display:'grid',gridTemplateColumns:'minmax(320px,0.95fr) minmax(360px,0.8fr)',gap:28,alignItems:'stretch'}}>
        <div style={{padding:'28px 14px 28px 6px',display:'flex',flexDirection:'column',justifyContent:'center'}}>
          <div style={{fontSize:52,fontWeight:900,letterSpacing:10,color:C.white,marginBottom:10}}>VAULTT</div>
          <div style={{fontSize:14,color:'rgba(210,210,215,0.9)',fontStyle:'italic',marginBottom:22}}>Where Africa Watches.</div>
          <div style={{display:'inline-flex',alignItems:'center',gap:8,background:'rgba(10,132,255,0.12)',border:`1px solid ${C.border}`,borderRadius:999,padding:'8px 16px',fontSize:11,fontWeight:800,color:C.blue,letterSpacing:1.5,textTransform:'uppercase',marginBottom:26,alignSelf:'flex-start'}}>
            <span style={{width:6,height:6,borderRadius:'50%',background:C.blue,display:'inline-block'}}/>
            Pre-launch access
          </div>
          <div style={{fontSize:'clamp(44px,6vw,78px)',fontWeight:900,lineHeight:0.94,letterSpacing:-2.8,color:C.white,marginBottom:18,maxWidth:640}}>
            Your front row seat to launch.
          </div>
          <div style={{fontSize:19,color:'rgba(210,210,215,0.92)',lineHeight:1.7,maxWidth:620,marginBottom:26}}>
            Join early access for founding viewer updates, launch announcements and the first wave of South African originals, live formats and creator channels.
          </div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(3,minmax(0,1fr))',gap:14,maxWidth:720}}>
            {[
              {label:'Founding price', value:'R49'},
              {label:'Launch window', value:'June 2026'},
              {label:'Experience', value:'Premium SA'}
            ].map((item)=>(
              <div key={item.label} style={{background:'linear-gradient(180deg,rgba(255,255,255,0.07),rgba(255,255,255,0.03))',border:`1px solid ${C.border}`,borderRadius:20,padding:'18px 18px 16px',boxShadow:'inset 0 1px 0 rgba(255,255,255,0.04)'}}>
                <div style={{fontSize:28,fontWeight:800,color:C.white,letterSpacing:-0.8,marginBottom:6}}>{item.value}</div>
                <div style={{fontSize:12,color:C.grey2,lineHeight:1.5}}>{item.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div style={{background:'linear-gradient(180deg,rgba(255,255,255,0.09),rgba(255,255,255,0.04))',border:`1px solid rgba(255,255,255,0.1)`,borderRadius:32,padding:'28px 26px 24px',width:'100%',boxShadow:'0 30px 80px rgba(0,0,0,0.34), inset 0 1px 0 rgba(255,255,255,0.05)',backdropFilter:'blur(18px)',position:'relative',overflow:'hidden'}}>
          <div style={{position:'absolute',top:-30,right:-10,width:160,height:160,borderRadius:'50%',background:'radial-gradient(circle,rgba(10,132,255,0.2),transparent 64%)'}}/>
          <div style={{position:'absolute',left:-20,bottom:-40,width:180,height:180,borderRadius:'50%',background:'radial-gradient(circle,rgba(255,214,10,0.08),transparent 64%)'}}/>
          <div style={{position:'relative',zIndex:1}}>
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:12,marginBottom:22}}>
              <div>
                <div style={{fontSize:12,fontWeight:800,letterSpacing:2.4,textTransform:'uppercase',color:C.grey2,marginBottom:8}}>Viewer access</div>
                <div style={{fontSize:28,fontWeight:800,color:C.white,letterSpacing:-0.9}}>{mode==='signin'?'Sign in':'Create your account'}</div>
              </div>
              <div style={{padding:'6px 12px',background:'rgba(255,255,255,0.06)',border:`1px solid ${C.border}`,borderRadius:999,fontSize:11,fontWeight:800,color:'#f5dfa3',letterSpacing:1.2,textTransform:'uppercase'}}>Founding era</div>
            </div>

            <div style={{display:'inline-flex',gap:6,marginBottom:22,padding:6,background:'rgba(255,255,255,0.04)',border:`1px solid ${C.border}`,borderRadius:999}}>
              {['signin','signup'].map(m=>(
                <button key={m} onClick={()=>{setMode(m);setError('');}} style={{padding:'11px 18px',border:'none',background:mode===m?'rgba(255,255,255,0.12)':'transparent',cursor:'pointer',fontFamily:'inherit',fontSize:14,fontWeight:800,color:mode===m?C.white:C.grey2,borderRadius:999,transition:'all 0.18s'}}>
                  {m==='signin'?'Sign In':'Sign Up'}
                </button>
              ))}
            </div>

            <div style={{fontSize:14,color:C.grey2,lineHeight:1.7,marginBottom:18,maxWidth:520}}>
              {mode==='signin'
                ? 'Sign in to continue into early access and the premium VAULTT experience.'
                : 'Create your account to get launch updates, early access news and your place in the opening lineup.'}
            </div>
            {mode==='signup'&&<input style={inp} placeholder="Full name" value={name} onChange={e=>setName(e.target.value)}/>}
            <input style={inp} type="email" placeholder="Email address" value={email} onChange={e=>setEmail(e.target.value)}/>
            <input style={inp} type="password" placeholder="Password" value={password} onChange={e=>setPassword(e.target.value)}/>
            {error&&<div style={{color:C.red,fontSize:13,marginBottom:12,lineHeight:1.5}}>{error}</div>}
            <button onClick={handleSubmit} disabled={loading} style={{width:'100%',padding:'17px 18px',background:'linear-gradient(135deg,#1e88ff,#0A84FF)',color:C.white,border:'none',borderRadius:999,fontSize:17,fontWeight:800,cursor:loading?'not-allowed':'pointer',fontFamily:'inherit',marginBottom:14,opacity:loading?0.7:1,boxShadow:'0 18px 34px rgba(10,132,255,0.26)'}}>
              {loading?'Please wait...':(mode==='signin'?'Enter Early Access':'Create Early Access Account')}
            </button>
            <button onClick={onApply} style={{width:'100%',padding:'15px 18px',background:'rgba(255,255,255,0.03)',color:C.white,border:`1px solid rgba(255,255,255,0.16)`,borderRadius:999,fontSize:14,fontWeight:800,cursor:'pointer',fontFamily:'inherit'}}>
              Apply as a Founding Creator
            </button>
            <div style={{display:'flex',gap:8,justifyContent:'center',flexWrap:'wrap',marginTop:18}}>
              {['R49 launch price','South African stories','Creator-first platform'].map((item, i) => (
                <span key={i} style={{padding:'7px 12px',background:'rgba(255,255,255,0.06)',border:`1px solid ${C.border}`,borderRadius:999,fontSize:11,color:C.grey2}}>{item}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function TopNav({user,screen,onNav,onLogout,onSearch}) {
  const [scrolled,setScrolled]=useState(false);
  const [menuOpen,setMenuOpen]=useState(false);
  useEffect(()=>{const h=()=>setScrolled(window.scrollY>60);window.addEventListener('scroll',h);return()=>window.removeEventListener('scroll',h);},[]);
  const isCreator=user?.role==='creator';
  const nm=user?.full_name||user?.email||'?';
  const initials=nm.split(' ').map(w=>w[0]).join('').slice(0,2).toUpperCase();
  const links=[{label:'Home',key:'home'},{label:'NightDrop',key:'nightdrop'},{label:'SA Originals',key:'originals'},{label:'Sports',key:'sports'},{label:'Talk Shows',key:'talkshows'},{label:'Podcasts',key:'podcasts'},{label:'Live',key:'live'},...(isCreator?[{label:'Studio',key:'dashboard'}]:[])];
  const navClick=(key)=>{onNav(key);setMenuOpen(false);};
  return (
    <>
      <nav style={{position:'fixed',top:14,left:24,right:24,zIndex:500,height:70,display:'flex',alignItems:'center',justifyContent:'space-between',padding:'0 22px',background:scrolled||menuOpen?'linear-gradient(180deg,rgba(19,26,36,0.84),rgba(17,23,32,0.72))':'linear-gradient(180deg,rgba(19,26,36,0.68),rgba(17,23,32,0.54))',backdropFilter:'blur(30px) saturate(140%)',WebkitBackdropFilter:'blur(30px) saturate(140%)',border:`1px solid ${scrolled||menuOpen?'rgba(176,202,233,0.16)':'rgba(176,202,233,0.1)'}`,borderRadius:24,boxShadow:scrolled||menuOpen?'0 18px 40px rgba(0,0,0,0.34)':'0 10px 22px rgba(0,0,0,0.18)',transition:'all 0.35s'}}>
        <div style={{display:'flex',alignItems:'center',gap:28}}>
          <div onClick={()=>navClick('home')} style={{fontFamily:'Arial',fontSize:19,fontWeight:900,letterSpacing:7,color:C.white,cursor:'pointer'}}>VAULTT</div>
          <div className="nav-links" style={{display:'flex',gap:10,alignItems:'center',color:C.grey2,fontSize:13,fontWeight:700}} />
        </div>
        <div style={{display:'flex',alignItems:'center',gap:14}}>
          <button onClick={onSearch} style={{background:'rgba(255,255,255,0.06)',border:`1px solid ${C.border}`,color:C.white,cursor:'pointer',fontSize:18,padding:'10px 12px',borderRadius:999,boxShadow:'inset 0 1px 0 rgba(255,255,255,0.05)'}}>⌕</button>
          <button onClick={()=>setMenuOpen(!menuOpen)} style={{display:'none',background:'none',border:'none',color:C.white,cursor:'pointer',fontSize:22,padding:4}} className="mobile-menu-btn">☰</button>
          <div onClick={onLogout} title="Sign out" style={{width:42,height:42,borderRadius:'50%',background:'rgba(255,255,255,0.08)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,fontWeight:800,color:C.white,cursor:'pointer',boxShadow:'inset 0 1px 0 rgba(255,255,255,0.06)',border:'1px solid rgba(255,255,255,0.1)'}}>{initials}</div>
        </div>
      </nav>
      {menuOpen&&(
        <div style={{position:'fixed',top:88,left:24,right:24,background:'linear-gradient(180deg,rgba(19,26,36,0.94),rgba(17,23,32,0.9))',zIndex:499,padding:'12px 0',border:`1px solid ${C.border}`,borderRadius:22,backdropFilter:'blur(24px)',boxShadow:'0 20px 40px rgba(0,0,0,0.34)'}}>
          {links.map(l=>(
            <button key={l.key} onClick={()=>navClick(l.key)} style={{display:'block',width:'100%',padding:'14px 24px',border:'none',background:'transparent',cursor:'pointer',fontFamily:'inherit',fontSize:15,fontWeight:600,color:screen===l.key?C.blue:C.white,textAlign:'left'}}>
              {l.label}
            </button>
          ))}
          <button onClick={()=>{onLogout();setMenuOpen(false);}} style={{display:'block',width:'100%',padding:'14px 24px',border:'none',background:'transparent',cursor:'pointer',fontFamily:'inherit',fontSize:15,fontWeight:600,color:C.red,textAlign:'left'}}>
            Sign Out
          </button>
        </div>
      )}
    </>
  );
}

function LeftRail({ user, current, onNav, onLogout }) {
  const [open, setOpen] = useState(false);
  const railWidth = 270;
  const items = [
    { key: 'home', label: 'Home', icon: '⌂' },
    { key: 'nightdrop', label: 'NightDrop', icon: '◈' },
    { key: 'originals', label: 'Originals', icon: '✦' },
    { key: 'sports', label: 'Sports', icon: '⚽' },
    { key: 'talkshows', label: 'Talk Shows', icon: '🎙' },
    { key: 'podcasts', label: 'Podcasts', icon: '🎧' },
    { key: 'live', label: 'Live', icon: '●' },
  ];
  if (user?.role === 'creator') items.push({ key: 'dashboard', label: 'Studio', icon: '▣' });

  useEffect(() => {
    const handleMove = (event) => {
      if (event.clientX <= 26) setOpen(true);
      else if (event.clientX > 300) setOpen(false);
    };
    window.addEventListener('mousemove', handleMove);
    return () => window.removeEventListener('mousemove', handleMove);
  }, []);

  return (
    <>
      <div
        onMouseEnter={() => setOpen(true)}
        style={{ position:'fixed', left:0, top:0, bottom:0, width:18, zIndex:460 }}
      />
      <div
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        style={{
          position:'fixed',
          top:22,
          left:18,
          bottom:22,
          width: railWidth,
          zIndex:470,
          background:'linear-gradient(180deg,rgba(19,26,36,0.88),rgba(17,23,32,0.74))',
          border:`1px solid ${open ? 'rgba(255,255,255,0.14)' : 'rgba(255,255,255,0.08)'}`,
          borderRadius:28,
          backdropFilter:'blur(26px) saturate(155%)',
          WebkitBackdropFilter:'blur(26px) saturate(155%)',
          boxShadow: open ? '22px 0 48px rgba(0,0,0,0.32)' : '0 12px 26px rgba(0,0,0,0.2)',
          transform: open ? 'translateX(0)' : `translateX(-${railWidth - 22}px)`,
          opacity: 1,
          transition:'transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease',
          overflow:'hidden',
        }}
      >
        <div style={{ padding:'24px 18px 14px' }}>
          <div style={{ color:C.grey2, fontSize:11, fontWeight:800, letterSpacing:1.8, textTransform:'uppercase', opacity: open ? 1 : 0, transition:'opacity 0.18s' }}>
            Browse
          </div>
        </div>
        <div style={{ display:'grid', gap:10, padding:'0 12px' }}>
          {items.map(item => (
            <button
              key={item.key}
              onClick={() => onNav(item.key)}
              style={{
                display:'flex',
                alignItems:'center',
                gap:16,
                width:'100%',
                padding:'14px 16px',
                border:'none',
                borderRadius:18,
                background: current===item.key ? 'rgba(255,255,255,0.12)' : 'transparent',
                color: C.white,
                cursor:'pointer',
                fontFamily:'inherit',
                fontSize:14,
                fontWeight:800,
                textAlign:'left',
                boxShadow: current===item.key ? 'inset 0 1px 0 rgba(255,255,255,0.06)' : 'none',
              }}
            >
              <span style={{ minWidth:24, textAlign:'center', fontSize:18, filter: current===item.key ? 'drop-shadow(0 0 10px rgba(255,255,255,0.08))' : 'none' }}>{item.icon}</span>
              <span style={{ opacity: open ? 1 : 0, transition:'opacity 0.16s', whiteSpace:'nowrap' }}>{item.label}</span>
            </button>
          ))}
        </div>
        <div style={{ position:'absolute', left:12, right:12, bottom:18 }}>
          <button
            onClick={onLogout}
            style={{
              display:'flex',
              alignItems:'center',
              gap:16,
              width:'100%',
              padding:'14px 16px',
              border:'1px solid rgba(255,255,255,0.08)',
              borderRadius:18,
              background:'rgba(255,255,255,0.05)',
              color:C.white,
              cursor:'pointer',
              fontFamily:'inherit',
              fontSize:14,
              fontWeight:800,
              textAlign:'left',
            }}
          >
            <span style={{ minWidth:24, textAlign:'center', fontSize:18 }}>⇠</span>
            <span style={{ opacity: open ? 1 : 0, transition:'opacity 0.16s', whiteSpace:'nowrap' }}>Sign Out</span>
          </button>
        </div>
      </div>
    </>
  );
}

function ShowCard({show,onClick,onAddList,myList}) {
  const [hov,setHov]=useState(false);
  const [preview,setPreview]=useState(false);
  const timer=useRef(null);
  const inList=myList&&myList.includes(show.id);
  const onEnter=()=>{setHov(true);if(show.mux_playback_id){timer.current=setTimeout(()=>setPreview(true),1000);}};
  const onLeave=()=>{setHov(false);setPreview(false);if(timer.current)clearTimeout(timer.current);};
  return (
    <div onMouseEnter={onEnter} onMouseLeave={onLeave} style={{flexShrink:0,width:220,cursor:'pointer',position:'relative',zIndex:hov?20:1,transition:'transform 0.26s ease, box-shadow 0.26s ease',transform:hov?'translateY(-4px) scale(1.01)':'scale(1)',boxShadow:hov?'0 24px 44px rgba(0,0,0,0.28)':'0 14px 28px rgba(0,0,0,0.16)',borderRadius:24}}>
      <div onClick={()=>onClick(show)} style={{aspectRatio:'16/9',background:`linear-gradient(${show.g})`,borderRadius:22,display:'flex',alignItems:'center',justifyContent:'center',fontSize:32,overflow:'hidden',position:'relative',border:`1px solid ${hov ? 'rgba(255,255,255,0.14)' : C.border}`}}>
        {preview&&show.mux_playback_id&&<video autoPlay muted loop playsInline style={{position:'absolute',inset:0,width:'100%',height:'100%',objectFit:'cover'}}><source src={`https://stream.mux.com/${show.mux_playback_id}/low.mp4`} type="video/mp4"/></video>}
        {!preview && <PosterArtwork show={show} rank={show.top10} />}
        <div style={{position:'absolute',right:12,bottom:12,display:'flex',gap:8,opacity:hov?1:0,transform:hov?'translateY(0)':'translateY(4px)',transition:'opacity 0.18s ease, transform 0.18s ease'}}>
          <button onClick={(e)=>{e.stopPropagation();onClick(show);}} style={{width:34,height:34,borderRadius:'50%',background:'rgba(255,255,255,0.9)',border:'none',cursor:'pointer',fontSize:14,display:'flex',alignItems:'center',justifyContent:'center',color:'#000',boxShadow:'0 12px 24px rgba(255,255,255,0.14)'}}>&#9654;</button>
          <button onClick={(e)=>{e.stopPropagation();onAddList&&onAddList(show.id);}} style={{width:34,height:34,borderRadius:'50%',background:'rgba(7,14,22,0.56)',backdropFilter:'blur(10px)',border:`1px solid ${inList?C.green:C.border}`,cursor:'pointer',fontSize:14,display:'flex',alignItems:'center',justifyContent:'center',color:inList?C.green:C.white}}>{inList?'✓':'+'}</button>
        </div>
      </div>
      <div style={{padding:'10px 6px 0'}}>
        <div style={{fontSize:14,fontWeight:800,color:C.white,marginBottom:4,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{show.title}</div>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:8}}>
          <div style={{fontSize:11,color:C.grey2,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{show.creator}</div>
          {show.match && <div style={{fontSize:11,fontWeight:700,color:C.green,flexShrink:0}}>{show.match}%</div>}
        </div>
      </div>
    </div>
  );
}

function Shelf({title,shows,onWatch,onAddList,myList,badge}) {
  const ref=useRef();
  const scroll=dir=>ref.current.scrollBy({left:dir*600,behavior:'smooth'});
  if(!shows||shows.length===0)return null;
  return (
    <div style={{marginBottom:48}}>
      <div className='shelf-title' style={{padding:'0 4%',marginBottom:16,display:'flex',alignItems:'center',gap:12}}>
        <div style={{fontSize:22,fontWeight:800,color:C.white,letterSpacing:-0.3}}>{title}</div>
        {badge&&<span style={{background:'rgba(255,255,255,0.06)',color:C.white,border:`1px solid ${C.border}`,fontSize:10,fontWeight:800,padding:'4px 10px',borderRadius:999,letterSpacing:1.2,textTransform:'uppercase'}}>{badge}</span>}
      </div>
      <div style={{position:'relative'}}>
        <button onClick={()=>scroll(-1)} style={{position:'absolute',left:18,top:'34%',width:48,height:48,background:'linear-gradient(180deg,rgba(19,26,36,0.8),rgba(17,23,32,0.72))',border:`1px solid ${C.border}`,borderRadius:'50%',color:C.white,fontSize:26,cursor:'pointer',zIndex:10,display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(14px)',boxShadow:'0 14px 30px rgba(0,0,0,0.26)'}}>&#8249;</button>
        <div ref={ref} className='shelf-pad' style={{display:'flex',gap:16,padding:'4px 4%',overflowX:'auto',scrollbarWidth:'none'}}>
          {shows.map(s=><ShowCard key={s.id} show={s} onClick={onWatch} onAddList={onAddList} myList={myList}/>)}
        </div>
        <button onClick={()=>scroll(1)} style={{position:'absolute',right:18,top:'34%',width:48,height:48,background:'linear-gradient(180deg,rgba(19,26,36,0.8),rgba(17,23,32,0.72))',border:`1px solid ${C.border}`,borderRadius:'50%',color:C.white,fontSize:26,cursor:'pointer',zIndex:10,display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(14px)',boxShadow:'0 14px 30px rgba(0,0,0,0.26)'}}>&#8250;</button>
      </div>
    </div>
  );
}

function CreatorMembershipSpotlight({ channel, tier, onOpenChannel, onOpenStudio, isCreator }) {
  if (!channel || !tier) return null;

  const perks = Array.isArray(tier.perks) ? tier.perks.slice(0, 4) : [];

  return (
    <div style={{ margin: '8px 4% 40px' }}>
      <div style={{
        background: 'radial-gradient(circle at 78% 12%, rgba(241,198,109,0.08) 0%, transparent 22%), linear-gradient(135deg,rgba(16,33,54,0.96),rgba(12,21,34,0.94) 58%,rgba(20,30,44,0.98) 100%)',
        border: `1px solid ${C.blueB}`,
        borderRadius: 28,
        padding: '30px 26px',
        boxShadow: '0 20px 50px rgba(0,0,0,0.28)',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 24, flexWrap: 'wrap' }}>
          <div style={{ flex: '1 1 320px', minWidth: 260 }}>
            <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1.8, textTransform: 'uppercase', color: '#f3dfb4', marginBottom: 8 }}>
              Creator Memberships
            </div>
            <div style={{ fontSize: 38, fontWeight: 900, color: C.white, lineHeight: 1.02, marginBottom: 10, letterSpacing: -1.2 }}>
              {channel.display_name}
            </div>
            <div style={{ fontSize: 15, color: 'rgba(215,221,232,0.92)', lineHeight: 1.72, marginBottom: 14, maxWidth: 680 }}>
              {channel.tagline || channel.bio || 'Support creators directly with member perks, bonus drops and future live access.'}
            </div>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 16 }}>
              {channel.membership_enabled && <span style={{ padding: '7px 12px', background: 'rgba(255,255,255,0.055)', border: `1px solid ${C.border}`, borderRadius: 999, fontSize: 12, color: C.grey2 }}>Memberships on</span>}
              {channel.tipping_enabled && <span style={{ padding: '7px 12px', background: 'rgba(255,255,255,0.055)', border: `1px solid ${C.border}`, borderRadius: 999, fontSize: 12, color: C.grey2 }}>Tipping ready</span>}
              <span style={{ padding: '7px 12px', background: 'rgba(255,255,255,0.055)', border: `1px solid ${C.border}`, borderRadius: 999, fontSize: 12, color: C.grey2 }}>Founding creator layer</span>
            </div>
          </div>

          <div style={{
            flex: '0 1 360px',
            minWidth: 280,
            background: 'linear-gradient(180deg,rgba(255,255,255,0.045),rgba(255,255,255,0.022))',
            border: `1px solid ${C.border}`,
            borderRadius: 22,
            padding: 22,
            alignSelf: 'stretch',
            boxShadow:'inset 0 1px 0 rgba(255,255,255,0.03)',
          }}>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, marginBottom: 8 }}>
              <span style={{ fontSize: 38, fontWeight: 900, color: C.white, letterSpacing: -1.1 }}>R{Number(tier.price_zar || 0).toFixed(0)}</span>
              <span style={{ fontSize: 13, color: C.grey2, marginBottom: 6 }}>/ {tier.billing_interval || 'month'}</span>
            </div>
            <div style={{ fontSize: 18, fontWeight: 800, color: C.white, marginBottom: 8 }}>{tier.name}</div>
            <div style={{ fontSize: 13, color: C.grey2, lineHeight: 1.6, marginBottom: 14 }}>
              {tier.description || 'Support this creator directly and unlock future member-only drops.'}
            </div>
            <div style={{ display: 'grid', gap: 8, marginBottom: 18 }}>
              {perks.length > 0 ? perks.map((perk, index) => (
                <div key={index} style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                  <span style={{ color: C.green, fontSize: 13, marginTop: 1 }}>✓</span>
                  <span style={{ fontSize: 13, color: C.grey2, lineHeight: 1.5 }}>{perk}</span>
                </div>
              )) : (
                <div style={{ fontSize: 13, color: C.grey2 }}>Perks will appear here as creator memberships roll out in the app.</div>
              )}
            </div>
            <div style={{ display: 'grid', gap: 10 }}>
              <button
                onClick={onOpenChannel}
                style={{ width: '100%', padding: '13px 16px', background: 'linear-gradient(135deg,#66b2ff,#2f8fff)', color: C.white, border: 'none', borderRadius: 999, fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', boxShadow:'0 14px 28px rgba(75,163,255,0.18)' }}
              >
                View Creator Channel
              </button>
              {isCreator && (
                <button
                  onClick={onOpenStudio}
                  style={{ width: '100%', padding: '12px 16px', background: 'rgba(255,255,255,0.05)', color: C.white, border: `1px solid ${C.border}`, borderRadius: 999, fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}
                >
                  Open Creator Studio
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function CreatorChannelScreen({ user, channel, onBack, onJoinMembership, onWatch, onCreateTip }) {
  const [tiers, setTiers] = useState([]);
  const [bonusItems, setBonusItems] = useState([]);
  const [creatorUpdates, setCreatorUpdates] = useState([]);
  const [featuredShows, setFeaturedShows] = useState([]);
  const [liveEvents, setLiveEvents] = useState([]);
  const [recentTips, setRecentTips] = useState([]);
  const [joiningTierId, setJoiningTierId] = useState(null);
  const [membershipState, setMembershipState] = useState({});
  const [membershipHandoff, setMembershipHandoff] = useState({});
  const [tipAmount, setTipAmount] = useState(50);
  const [tipMessage, setTipMessage] = useState('');
  const [tipLoading, setTipLoading] = useState(false);
  const [tipStatus, setTipStatus] = useState('');
  const [showTipConfirm, setShowTipConfirm] = useState(false);
  const [latestTip, setLatestTip] = useState(null);

  useEffect(() => {
    let mounted = true;
    const loadChannelData = async () => {
      if (!channel?.id) return;

      const [tiersRes, bonusRes, membershipsRes, showsRes, tipsRes, liveRes] = await Promise.all([
        supabase
          .from('membership_tiers')
          .select('*')
          .eq('creator_channel_id', channel.id)
          .eq('is_active', true)
          .order('sort_order', { ascending: true }),
        supabase
          .from('bonus_content_items')
          .select('*')
          .eq('creator_channel_id', channel.id)
          .eq('is_published', true)
          .order('published_at', { ascending: false })
          .limit(6),
        user?.id
          ? supabase
              .from('creator_memberships')
              .select('tier_id,status,payment_reference,payment_provider')
              .eq('creator_channel_id', channel.id)
              .eq('viewer_id', user.id)
          : Promise.resolve({ data: [] }),
        supabase
          .from('shows')
          .select('*')
          .eq('creator_id', channel.creator_id)
          .order('created_at', { ascending: false })
          .limit(4),
        user?.id
          ? supabase
              .from('tip_transactions')
              .select('id,amount_zar,status,message,created_at,payment_reference,payment_provider')
              .eq('creator_channel_id', channel.id)
              .eq('viewer_id', user.id)
              .order('created_at', { ascending: false })
              .limit(5)
          : Promise.resolve({ data: [] }),
        supabase
          .from('live_events')
          .select('*')
          .eq('creator_channel_id', channel.id)
          .order('starts_at', { ascending: true })
          .limit(6),
      ]);

      if (!mounted) return;
      setTiers(tiersRes.data || []);
      const publishedBonus = bonusRes.data || [];
      setBonusItems(publishedBonus);
      setCreatorUpdates(
        publishedBonus
          .filter((item) => (item.content_type || '').toLowerCase().includes('update') || item.body_markdown || item.description)
          .slice(0, 4)
      );
      setFeaturedShows((showsRes.data || []).map((s) => ({
        ...s,
        g:'135deg,#27384d,#4d6079',
        emoji:'\u{1F3AC}',
        match:99,
        isLocal:s.is_local,
        isNew:s.is_new,
        cat:s.category || s.type,
        creator:channel.display_name,
        desc:s.description || s.title,
        eps:s.episode_count || 1,
      })));
      const membershipMap = {};
      const handoffMap = {};
      (membershipsRes.data || []).forEach((row) => {
        membershipMap[row.tier_id] = row.status;
        if (row.payment_reference || row.payment_provider) {
          handoffMap[row.tier_id] = {
            paymentReference: row.payment_reference,
            paymentProvider: row.payment_provider || 'payfast_pending',
          };
        }
      });
      setMembershipState(membershipMap);
      setMembershipHandoff(handoffMap);
      setRecentTips(tipsRes.data || []);
      setLatestTip((tipsRes.data || [])[0] || null);
      setLiveEvents((liveRes.data || []).map((event) => mapLiveEventCard(event, channel.display_name)));
    };

    loadChannelData();
    return () => {
      mounted = false;
    };
  }, [channel?.id, user?.id]);

  if (!channel) return null;

  const joinTier = async (tier) => {
    setJoiningTierId(tier.id);
    const result = await onJoinMembership?.(tier, channel);
    if (result?.status) {
      setMembershipState((prev) => ({ ...prev, [tier.id]: result.status }));
      setMembershipHandoff((prev) => ({
        ...prev,
        [tier.id]: {
          paymentReference: result.paymentReference,
          paymentProvider: result.paymentProvider,
        },
      }));
    }
    setJoiningTierId(null);
  };

  const initials = (channel.display_name || 'VC').split(' ').map((part) => part[0]).join('').slice(0, 2).toUpperCase();
  const activeMembershipCount = Object.values(membershipState).filter((status) => status === 'active').length;
  const featuredDrop = bonusItems[0];
  const latestTipStatusColor = latestTip?.status === 'paid' ? C.green : latestTip?.status === 'failed' ? C.red : C.gold;

  const confirmTip = async () => {
    setTipLoading(true);
    setTipStatus('');
    const tip = await onCreateTip?.({
      channel,
      amount: Number(tipAmount),
      message: tipMessage.trim(),
      viewerId: user?.id || null,
    });
    if (tip) {
      setLatestTip(tip);
      setRecentTips((prev) => [tip, ...prev.filter((item) => item.id !== tip.id)].slice(0, 5));
      setTipStatus(`Tip recorded. Payment handoff reference: ${tip.payment_reference || 'pending-reference'}.`);
      setTipMessage('');
      setShowTipConfirm(false);
    }
    setTipLoading(false);
  };

  return (
    <div style={{ background: C.bg, minHeight: '100vh', paddingTop: 74 }}>
      <div style={{ padding: '28px 4% 24px' }}>
        <button onClick={onBack} style={{ padding: '8px 14px', background: 'rgba(255,255,255,0.05)', border: `1px solid ${C.border}`, borderRadius: 999, color: C.white, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit', marginBottom: 18 }}>
          Home
        </button>
        <div style={{ background: channel.cover_image_url ? `linear-gradient(rgba(7,21,35,0.56),rgba(10,29,49,0.92)), url(${channel.cover_image_url}) center/cover` : 'linear-gradient(135deg,rgba(0,130,255,0.2),rgba(10,29,49,0.92))', border: `1px solid ${C.blueB}`, borderRadius: 24, padding: '32px 28px', boxShadow: '0 24px 64px rgba(0,0,0,0.28)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 24, flexWrap: 'wrap' }}>
            <div style={{ flex: '1 1 420px' }}>
              <div style={{ display:'flex', alignItems:'center', gap:16, marginBottom:18, flexWrap:'wrap' }}>
                {channel.avatar_url ? (
                  <img src={channel.avatar_url} alt={channel.display_name} style={{ width:76, height:76, borderRadius:'50%', objectFit:'cover', border:`2px solid ${C.blueB}`, boxShadow:'0 12px 30px rgba(0,0,0,0.24)' }} />
                ) : (
                  <div style={{ width:76, height:76, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', background:'linear-gradient(135deg,rgba(0,130,255,0.3),rgba(0,88,185,0.2))', border:`2px solid ${C.blueB}`, fontSize:24, fontWeight:900, color:C.white }}>
                    {initials}
                  </div>
                )}
                <div style={{ display:'flex', gap:10, flexWrap:'wrap' }}>
                  <div style={{ padding:'10px 14px', background:'rgba(255,255,255,0.06)', border:`1px solid ${C.border}`, borderRadius:16 }}>
                    <div style={{ fontSize:10, letterSpacing:1.4, textTransform:'uppercase', color:C.grey2, marginBottom:4 }}>Founder status</div>
                    <div style={{ fontSize:14, fontWeight:800, color:C.white }}>Founding creator</div>
                  </div>
                  <div style={{ padding:'10px 14px', background:'rgba(255,255,255,0.06)', border:`1px solid ${C.border}`, borderRadius:16 }}>
                    <div style={{ fontSize:10, letterSpacing:1.4, textTransform:'uppercase', color:C.grey2, marginBottom:4 }}>Membership state</div>
                    <div style={{ fontSize:14, fontWeight:800, color:C.white }}>{activeMembershipCount > 0 ? 'Active member' : 'Ready to join'}</div>
                  </div>
                </div>
              </div>
              <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1.8, textTransform: 'uppercase', color: C.blue, marginBottom: 10 }}>
                Creator Channel
              </div>
              <div style={{ fontFamily: 'Arial', fontSize: 'clamp(34px,5vw,56px)', fontWeight: 900, color: C.white, lineHeight: 1.02, marginBottom: 10 }}>
                {channel.display_name}
              </div>
              <div style={{ fontSize: 16, color: C.grey2, lineHeight: 1.7, maxWidth: 700, marginBottom: 16 }}>
                {channel.bio || channel.tagline || 'Support this creator directly through memberships, bonus content, tips and future live drops.'}
              </div>
              <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                {channel.membership_enabled && <span style={{ padding: '7px 12px', background: 'rgba(255,255,255,0.06)', border: `1px solid ${C.border}`, borderRadius: 999, fontSize: 12, color: C.grey2 }}>Memberships</span>}
                {channel.tipping_enabled && <span style={{ padding: '7px 12px', background: 'rgba(255,255,255,0.06)', border: `1px solid ${C.border}`, borderRadius: 999, fontSize: 12, color: C.grey2 }}>Tips</span>}
                <span style={{ padding: '7px 12px', background: 'rgba(255,255,255,0.06)', border: `1px solid ${C.border}`, borderRadius: 999, fontSize: 12, color: C.grey2 }}>Founding creator</span>
              </div>
            </div>
            <div style={{ flex: '0 1 320px', minWidth: 260, background: 'rgba(255,255,255,0.05)', border: `1px solid ${C.border}`, borderRadius: 18, padding: 20 }}>
              <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: 1.4, textTransform: 'uppercase', color: C.grey2, marginBottom: 8 }}>Why join early</div>
              <div style={{ display: 'grid', gap: 10 }}>
                {[
                  'Support a creator directly from launch',
                  'Unlock founder-only bonus content',
                  'Be first in line for future live events',
                  'Stay close to new drops and member perks',
                ].map((item, index) => (
                  <div key={index} style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                    <span style={{ color: C.green, marginTop: 1 }}>✓</span>
                    <span style={{ fontSize: 13, color: C.grey2, lineHeight: 1.5 }}>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ padding: '0 4% 28px' }}>
        <div style={{ display:'grid', gridTemplateColumns:'minmax(0,1.35fr) minmax(280px,0.65fr)', gap:16 }}>
          <div>
            <div style={{ fontSize: 20, fontWeight: 800, color: C.white, marginBottom: 14 }}>Membership tiers</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: 14 }}>
              {tiers.map((tier) => {
                const perks = Array.isArray(tier.perks) ? tier.perks : [];
                const status = membershipState[tier.id];
                const handoff = membershipHandoff[tier.id];
                return (
                  <div key={tier.id} style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 20, padding: 22, backdropFilter: 'blur(14px)' }}>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, marginBottom: 10 }}>
                      <span style={{ fontFamily: 'Arial', fontSize: 34, fontWeight: 900, color: C.white }}>R{Number(tier.price_zar || 0).toFixed(0)}</span>
                      <span style={{ fontSize: 13, color: C.grey2 }}>/ {tier.billing_interval}</span>
                    </div>
                    <div style={{ fontSize: 18, fontWeight: 800, color: C.white, marginBottom: 8 }}>{tier.name}</div>
                    <div style={{ fontSize: 13, color: C.grey2, lineHeight: 1.6, marginBottom: 14 }}>{tier.description || 'Support this creator and unlock bonus access.'}</div>
                    <div style={{ display: 'grid', gap: 8, marginBottom: 16 }}>
                      {perks.map((perk, index) => (
                        <div key={index} style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                          <span style={{ color: C.green, marginTop: 1 }}>✓</span>
                          <span style={{ fontSize: 13, color: C.grey2, lineHeight: 1.5 }}>{perk}</span>
                        </div>
                      ))}
                    </div>
                    <button
                      onClick={() => joinTier(tier)}
                      disabled={joiningTierId === tier.id || status === 'pending' || status === 'active'}
                      style={{
                        width: '100%',
                        padding: '13px 16px',
                        background: status === 'active' ? C.green : status === 'pending' ? 'rgba(255,255,255,0.08)' : C.blue,
                        color: C.white,
                        border: 'none',
                        borderRadius: 999,
                        fontSize: 14,
                        fontWeight: 700,
                        cursor: joiningTierId === tier.id || status === 'pending' || status === 'active' ? 'not-allowed' : 'pointer',
                        fontFamily: 'inherit',
                        opacity: joiningTierId === tier.id ? 0.7 : 1,
                      }}
                    >
                      {joiningTierId === tier.id ? 'Saving...' : status === 'active' ? 'Membership active' : status === 'pending' ? 'Membership pending' : 'Join this membership'}
                    </button>
                    {status === 'pending' && handoff?.paymentReference && (
                      <div style={{ marginTop: 10, padding: '10px 12px', background: 'rgba(255,255,255,0.04)', border: `1px solid ${C.border}`, borderRadius: 14 }}>
                        <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1.3, textTransform: 'uppercase', color: C.grey2, marginBottom: 5 }}>Checkout handoff</div>
                        <div style={{ fontSize: 12, color: C.white, lineHeight: 1.5 }}>Reference: {handoff.paymentReference}</div>
                        <div style={{ fontSize: 12, color: C.grey2, lineHeight: 1.5 }}>Provider: {handoff.paymentProvider || 'payfast_pending'}</div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          <div style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:20, padding:22, backdropFilter:'blur(14px)', alignSelf:'start' }}>
            <div style={{ fontSize:12, fontWeight:800, letterSpacing:1.5, textTransform:'uppercase', color:C.blue, marginBottom:10 }}>Tip this creator</div>
            <div style={{ fontSize:16, fontWeight:800, color:C.white, marginBottom:8 }}>Show support instantly</div>
            <div style={{ fontSize:13, color:C.grey2, lineHeight:1.6, marginBottom:16 }}>
              Tipping is now part of the creator journey. You can record support now and VAULTT will hand it into the live payment flow as soon as PayFast support is ready.
            </div>
            <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginBottom:14 }}>
              {[20, 50, 100, 250].map((amount) => (
                <button
                  key={amount}
                  onClick={() => setTipAmount(amount)}
                  style={{
                    padding:'9px 14px',
                    borderRadius:999,
                    border:`1px solid ${tipAmount === amount ? C.blueB : C.border}`,
                    background: tipAmount === amount ? 'linear-gradient(135deg,rgba(0,130,255,0.24),rgba(0,88,185,0.16))' : 'rgba(255,255,255,0.04)',
                    color:C.white,
                    cursor:'pointer',
                    fontSize:12,
                    fontWeight:800,
                    fontFamily:'inherit',
                  }}
                >
                  R{amount}
                </button>
              ))}
            </div>
            <textarea
              value={tipMessage}
              onChange={(e) => setTipMessage(e.target.value)}
              placeholder="Add a short message"
              style={{ width:'100%', minHeight:96, resize:'vertical', padding:'12px 14px', background:'rgba(255,255,255,0.05)', border:`1px solid ${C.border}`, borderRadius:16, color:C.white, fontSize:13, fontFamily:'inherit', outline:'none', marginBottom:12 }}
            />
            <button
              onClick={() => setShowTipConfirm(true)}
              disabled={tipLoading}
              style={{ width:'100%', padding:'13px 16px', background:C.blue, color:C.white, border:'none', borderRadius:999, fontSize:14, fontWeight:700, cursor:tipLoading?'not-allowed':'pointer', fontFamily:'inherit', opacity:tipLoading?0.7:1 }}
            >
              {tipLoading ? 'Saving tip...' : `Continue with R${tipAmount} tip`}
            </button>
            {tipStatus && <div style={{ fontSize:12, color:C.green, marginTop:10, lineHeight:1.5 }}>{tipStatus}</div>}
            {latestTip && (
              <div style={{ marginTop:16, padding:14, background:'rgba(255,255,255,0.04)', border:`1px solid ${C.border}`, borderRadius:16 }}>
                <div style={{ fontSize:10, fontWeight:800, letterSpacing:1.4, textTransform:'uppercase', color:C.grey2, marginBottom:6 }}>Latest support</div>
                <div style={{ display:'flex', justifyContent:'space-between', gap:10, alignItems:'center', marginBottom:6 }}>
                  <div style={{ fontSize:18, fontWeight:800, color:C.white }}>R{Number(latestTip.amount_zar || 0).toFixed(0)}</div>
                  <div style={{ fontSize:11, fontWeight:800, letterSpacing:1.2, textTransform:'uppercase', color:latestTipStatusColor }}>{latestTip.status}</div>
                </div>
                <div style={{ fontSize:12, color:C.grey2, lineHeight:1.5 }}>
                  {latestTip.status === 'pending' ? 'Saved and waiting for payment handoff.' : latestTip.status === 'paid' ? 'Tip completed successfully.' : 'Payment status will update here.'}
                </div>
                {(latestTip.payment_reference || latestTip.payment_provider) && (
                  <div style={{ marginTop: 8, fontSize: 12, color: C.grey2, lineHeight: 1.5 }}>
                    {latestTip.payment_provider || 'payfast_pending'} · {latestTip.payment_reference || 'reference pending'}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div style={{ padding: '0 4% 28px' }}>
        <div style={{ display:'grid', gridTemplateColumns:'minmax(0,1fr) minmax(280px,0.65fr)', gap:16 }}>
          <div>
            <div style={{ fontSize: 20, fontWeight: 800, color: C.white, marginBottom: 14 }}>Featured uploads</div>
            {featuredShows.length > 0 ? (
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))', gap:14 }}>
                {featuredShows.map((show) => (
                  <div key={show.id} onClick={() => onWatch(show)} style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:20, overflow:'hidden', cursor:'pointer', boxShadow:'0 18px 40px rgba(0,0,0,0.2)' }}>
                    <div style={{ aspectRatio:'16/9', background:`linear-gradient(${show.g})`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:38, position:'relative' }}>
                      <PosterArtwork show={show} size='wide' />
                    </div>
                    <div style={{ padding:16 }}>
                      <div style={{ fontSize:16, fontWeight:800, color:C.white, marginBottom:6 }}>{show.title}</div>
                      <div style={{ fontSize:12, color:C.grey2, lineHeight:1.6 }}>{show.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:20, padding:22 }}>
                <div style={{ fontSize:16, fontWeight:700, color:C.white, marginBottom:6 }}>Featured uploads will appear here</div>
                <div style={{ fontSize:13, color:C.grey2, lineHeight:1.6 }}>As this creator uploads more shows, featured episodes and premium moments will be surfaced here.</div>
              </div>
            )}
          </div>
          <div style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:20, padding:22, alignSelf:'start' }}>
            <div style={{ fontSize:12, fontWeight:800, letterSpacing:1.5, textTransform:'uppercase', color:C.blue, marginBottom:10 }}>Featured drop</div>
            <div style={{ fontSize:18, fontWeight:800, color:C.white, marginBottom:8 }}>{featuredDrop?.title || 'Founder update coming soon'}</div>
            <div style={{ fontSize:13, color:C.grey2, lineHeight:1.6, marginBottom:14 }}>
              {featuredDrop?.description || 'Use this space for the creator’s most important bonus release, member message or premium post.'}
            </div>
            {featuredDrop?.external_url ? (
              <button onClick={() => window.open(featuredDrop.external_url, '_blank', 'noopener,noreferrer')} style={{ padding:'10px 14px', background:C.blue, border:'none', borderRadius:999, color:C.white, cursor:'pointer', fontSize:12, fontWeight:700, fontFamily:'inherit' }}>
                Open featured drop
              </button>
            ) : (
              <button onClick={() => onWatch && onWatch({ id: `featured-drop-${channel.id}`, title: `${channel.display_name} Featured Drop`, desc: channel.bio || channel.tagline || 'Featured creator moment', g: '135deg,#2b3951,#4e5364', emoji: '✨', match: 99, isLocal: true, cat: 'Featured', creator: channel.display_name, eps: 1 })} style={{ padding:'10px 14px', background:C.blue, border:'none', borderRadius:999, color:C.white, cursor:'pointer', fontSize:12, fontWeight:700, fontFamily:'inherit' }}>
                Preview featured slot
              </button>
            )}
          </div>
        </div>
      </div>

      <div style={{ padding: '0 4% 28px' }}>
        <div style={{ display:'grid', gridTemplateColumns:'minmax(0,1fr) minmax(280px,0.75fr)', gap:16 }}>
          <div style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:20, padding:22 }}>
            <div style={{ fontSize: 20, fontWeight: 800, color: C.white, marginBottom: 14 }}>Creator updates</div>
            {creatorUpdates.length > 0 ? (
              <div style={{ display: 'grid', gap: 12 }}>
                {creatorUpdates.map((item) => (
                  <div key={item.id} style={{ padding:'16px 16px 14px', background:'rgba(255,255,255,0.04)', border:`1px solid ${C.border}`, borderRadius:18 }}>
                    <div style={{ display:'flex', justifyContent:'space-between', gap:12, alignItems:'center', marginBottom:8, flexWrap:'wrap' }}>
                      <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1.5, textTransform: 'uppercase', color: C.blue }}>{item.content_type || 'Creator update'}</div>
                      <div style={{ fontSize: 11, color: C.grey2 }}>{formatDateTimeShort(item.published_at || item.created_at)}</div>
                    </div>
                    <div style={{ fontSize: 18, fontWeight: 800, color: C.white, marginBottom: 8 }}>{item.title}</div>
                    <div style={{ fontSize: 13, color: C.grey2, lineHeight: 1.65, marginBottom: item.external_url ? 12 : 0 }}>
                      {item.description || item.body_markdown || 'New member update available on this channel.'}
                    </div>
                    {item.external_url && (
                      <button onClick={() => window.open(item.external_url, '_blank', 'noopener,noreferrer')} style={{ padding:'10px 14px', background:'rgba(255,255,255,0.05)', border:`1px solid ${C.border}`, borderRadius:999, color:C.white, cursor:'pointer', fontSize:12, fontWeight:700, fontFamily:'inherit' }}>
                        Open update
                      </button>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ fontSize:13, color:C.grey2, lineHeight:1.6 }}>Creator updates will appear here as founder notes, member posts and bonus drops are published.</div>
            )}
          </div>
          <div style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:20, padding:22 }}>
            <div style={{ fontSize: 20, fontWeight: 800, color: C.white, marginBottom: 14 }}>Upcoming live events</div>
            {liveEvents.length > 0 ? (
              <div style={{ display:'grid', gap:12 }}>
                {liveEvents.map((event) => (
                  <div key={event.id} style={{ padding:'16px 16px 14px', background:'rgba(255,255,255,0.04)', border:`1px solid ${C.border}`, borderRadius:18 }}>
                    <div style={{ display:'flex', justifyContent:'space-between', gap:10, alignItems:'center', marginBottom:8, flexWrap:'wrap' }}>
                      <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: 1.4, textTransform: 'uppercase', color: event.status === 'live' ? C.red : '#f3dfb4' }}>
                        {event.status === 'live' ? 'Live now' : event.isWatchAlong ? 'Watch-along scheduled' : 'Live session scheduled'}
                      </div>
                      <div style={{ fontSize: 11, color: C.grey2 }}>{formatDateTimeShort(event.startsAt)}</div>
                    </div>
                    <div style={{ fontSize: 17, fontWeight: 800, color: C.white, marginBottom: 6 }}>{event.title}</div>
                    <div style={{ fontSize: 13, color: C.grey2, lineHeight: 1.6, marginBottom: 10 }}>{event.description}</div>
                    <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                      <span style={{ padding:'6px 10px', background:'rgba(255,255,255,0.04)', border:`1px solid ${C.border}`, borderRadius:999, fontSize:11, color:C.grey2 }}>{event.accessType}</span>
                      {event.ticketPrice ? <span style={{ padding:'6px 10px', background:'rgba(255,255,255,0.04)', border:`1px solid ${C.border}`, borderRadius:999, fontSize:11, color:C.grey2 }}>R{Number(event.ticketPrice).toFixed(0)} ticketed</span> : <span style={{ padding:'6px 10px', background:'rgba(255,255,255,0.04)', border:`1px solid ${C.border}`, borderRadius:999, fontSize:11, color:C.grey2 }}>Open creator room</span>}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ fontSize:13, color:C.grey2, lineHeight:1.6 }}>This creator has not scheduled live rooms yet. Future watch-alongs and founder sessions will appear here.</div>
            )}
          </div>
        </div>
      </div>

      <div style={{ padding: '0 4% 90px' }}>
        <div style={{ fontSize: 20, fontWeight: 800, color: C.white, marginBottom: 14 }}>Bonus content</div>
        {bonusItems.length > 0 ? (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(260px,1fr))', gap: 14 }}>
            {bonusItems.map((item) => (
              <div key={item.id} style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 20, padding: 20 }}>
                <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1.6, textTransform: 'uppercase', color: C.blue, marginBottom: 8 }}>
                  {item.content_type || 'Bonus drop'}
                </div>
                <div style={{ fontSize: 18, fontWeight: 800, color: C.white, marginBottom: 8 }}>{item.title}</div>
                <div style={{ fontSize: 13, color: C.grey2, lineHeight: 1.6, marginBottom: 16 }}>{item.description || 'Bonus content for members and early supporters.'}</div>
                {item.external_url && (
                  <button onClick={() => window.open(item.external_url, '_blank', 'noopener,noreferrer')} style={{ padding: '10px 14px', background: 'rgba(255,255,255,0.05)', border: `1px solid ${C.border}`, borderRadius: 999, color: C.white, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit' }}>
                    Open
                  </button>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 20, padding: 24 }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: C.white, marginBottom: 6 }}>Bonus drops are coming here</div>
            <div style={{ fontSize: 13, color: C.grey2, lineHeight: 1.6, marginBottom: 16 }}>
              This channel is ready for founder-only updates, premium posts and future bonus releases.
            </div>
            <button onClick={() => onWatch && onWatch({ id: `channel-preview-${channel.id}`, title: `${channel.display_name} Preview`, desc: channel.bio || channel.tagline || 'Creator preview', g: '135deg,#26374f,#4d5d79', emoji: '🎬', match: 99, isLocal: true, cat: 'Creator Channel', creator: channel.display_name, eps: 1 })} style={{ padding: '10px 14px', background: C.blue, border: 'none', borderRadius: 999, color: C.white, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit' }}>
              Preview channel card
            </button>
          </div>
        )}
      </div>

      {showTipConfirm && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.74)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:24, backdropFilter:'blur(10px)' }}>
          <div style={{ width:'100%', maxWidth:460, background:'linear-gradient(180deg,rgba(18,39,66,0.98),rgba(10,27,47,0.98))', border:`1px solid ${C.blueB}`, borderRadius:28, padding:26, boxShadow:'0 34px 70px rgba(0,12,30,0.55)' }}>
            <div style={{ fontSize:12, fontWeight:800, letterSpacing:1.6, textTransform:'uppercase', color:C.blue, marginBottom:8 }}>Confirm support</div>
            <div style={{ fontSize:24, fontWeight:900, color:C.white, marginBottom:10 }}>Send R{tipAmount} to {channel.display_name}?</div>
            <div style={{ fontSize:13, color:C.grey2, lineHeight:1.6, marginBottom:18 }}>
              This creates a pending tip record now. Once PayFast tipping is switched on, this handoff becomes a proper payment checkout.
            </div>
            <div style={{ background:'rgba(255,255,255,0.05)', border:`1px solid ${C.border}`, borderRadius:18, padding:16, marginBottom:18 }}>
              <div style={{ display:'flex', justifyContent:'space-between', gap:10, marginBottom:8 }}>
                <div style={{ fontSize:12, color:C.grey2 }}>Creator</div>
                <div style={{ fontSize:12, fontWeight:700, color:C.white }}>{channel.display_name}</div>
              </div>
              <div style={{ display:'flex', justifyContent:'space-between', gap:10, marginBottom:8 }}>
                <div style={{ fontSize:12, color:C.grey2 }}>Amount</div>
                <div style={{ fontSize:12, fontWeight:700, color:C.white }}>R{tipAmount}</div>
              </div>
              <div style={{ display:'flex', justifyContent:'space-between', gap:10 }}>
                <div style={{ fontSize:12, color:C.grey2 }}>Status after save</div>
                <div style={{ fontSize:12, fontWeight:700, color:C.gold }}>Pending payment</div>
              </div>
              {tipMessage && (
                <div style={{ marginTop:12, paddingTop:12, borderTop:`1px solid ${C.border}` }}>
                  <div style={{ fontSize:12, color:C.grey2, marginBottom:4 }}>Message</div>
                  <div style={{ fontSize:13, color:C.white, lineHeight:1.5 }}>{tipMessage}</div>
                </div>
              )}
            </div>
            {recentTips.length > 0 && (
              <div style={{ marginBottom:18 }}>
                <div style={{ fontSize:11, fontWeight:800, letterSpacing:1.4, textTransform:'uppercase', color:C.grey2, marginBottom:8 }}>Recent support</div>
                <div style={{ display:'grid', gap:8 }}>
                  {recentTips.slice(0, 3).map((tip) => (
                    <div key={tip.id} style={{ display:'flex', justifyContent:'space-between', gap:12, padding:'10px 12px', background:'rgba(255,255,255,0.04)', border:`1px solid ${C.border}`, borderRadius:14 }}>
                      <div style={{ fontSize:13, color:C.white }}>R{Number(tip.amount_zar || 0).toFixed(0)}</div>
                      <div style={{ fontSize:11, fontWeight:800, letterSpacing:1.2, textTransform:'uppercase', color:tip.status === 'paid' ? C.green : C.gold }}>{tip.status}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div style={{ display:'grid', gap:10 }}>
              <button onClick={confirmTip} disabled={tipLoading} style={{ width:'100%', padding:'13px 16px', background:C.blue, color:C.white, border:'none', borderRadius:999, fontSize:14, fontWeight:700, cursor:tipLoading?'not-allowed':'pointer', fontFamily:'inherit', opacity:tipLoading?0.7:1 }}>
                {tipLoading ? 'Saving tip...' : 'Confirm tip'}
              </button>
              <button onClick={() => !tipLoading && setShowTipConfirm(false)} style={{ width:'100%', padding:'12px 16px', background:'rgba(255,255,255,0.05)', color:C.white, border:`1px solid ${C.border}`, borderRadius:999, fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'inherit' }}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function Hero({show,onWatch,onAddList,myList}) {
  const [muted,setMuted]=useState(true);
  const playerRef=useRef(null);
  const heroRef=useRef(null);
  useEffect(()=>{
    const obs=new IntersectionObserver(([e])=>{
      if(playerRef.current){if(e.isIntersecting){playerRef.current.play&&playerRef.current.play();}else{playerRef.current.pause&&playerRef.current.pause();}}
    },{threshold:0.2});
    if(heroRef.current)obs.observe(heroRef.current);
    return()=>obs.disconnect();
  },[show?.mux_playback_id]);
  if(!show)return null;
  const inList=myList&&myList.includes(show.id);
  return (
    <div ref={heroRef} style={{position:'relative',height:'88vh',minHeight:580,display:'flex',alignItems:'flex-end',overflow:'hidden',margin:'0 24px 28px',borderRadius:36,border:`1px solid rgba(255,255,255,0.08)`,boxShadow:'0 30px 80px rgba(0,0,0,0.38)'}}>
      {show.mux_playback_id?(
        <MuxPlayer ref={playerRef} playbackId={show.mux_playback_id} autoPlay="muted" muted={muted} loop style={{position:'absolute',inset:0,width:'100%',height:'100%',objectFit:'cover',zIndex:0}} thumbnailTime={5}/>
      ):(
        <div style={{position:'absolute',inset:0,background:`linear-gradient(${show.g})`}}/>
      )}
      <div style={{position:'absolute',inset:0,zIndex:2,background:'linear-gradient(to right,rgba(0,0,0,0.92) 0%,rgba(0,0,0,0.42) 48%,rgba(0,0,0,0.14) 78%),linear-gradient(to top,rgba(0,0,0,0.94) 0%,rgba(0,0,0,0.18) 22%,transparent 52%)'}}/>
      {!show.mux_playback_id && (
        <div style={{position:'absolute',inset:0,display:'flex',alignItems:'center',justifyContent:'flex-end',padding:'0 7%',zIndex:1}}>
          <div style={{width:320,height:320,borderRadius:72,border:'1px solid rgba(255,255,255,0.08)',background:'radial-gradient(circle at 24% 24%, rgba(241,198,109,0.14) 0%, transparent 36%), rgba(7,14,22,0.24)',backdropFilter:'blur(14px)',display:'flex',alignItems:'center',justifyContent:'center',boxShadow:'inset 0 1px 0 rgba(255,255,255,0.05)'}}>
            <div style={{fontSize:230,fontWeight:900,color:'rgba(255,255,255,0.12)',letterSpacing:-10,lineHeight:0.8}}>{initialsFromTitle(show.title)}</div>
          </div>
        </div>
      )}
      <div className='hero-text' style={{position:'relative',zIndex:3,padding:'0 4.5% 88px',maxWidth:620}}>
        <div style={{display:'flex',gap:8,marginBottom:16,flexWrap:'wrap'}}>
          {show.isNew&&<span style={{background:'rgba(255,255,255,0.08)',backdropFilter:'blur(12px)',color:C.white,border:`1px solid rgba(255,255,255,0.1)`,fontSize:10,fontWeight:800,padding:'5px 11px',borderRadius:999,letterSpacing:1.1}}>NEW</span>}
          {show.isLocal&&<span style={{background:'rgba(245,166,35,0.14)',color:'#ffd383',border:'1px solid rgba(245,166,35,0.34)',fontSize:10,fontWeight:800,padding:'5px 11px',borderRadius:999,letterSpacing:1.1}}>SA Original</span>}
        </div>
        <div style={{fontFamily:'Arial',fontSize:'clamp(48px,6vw,78px)',fontWeight:900,color:C.white,lineHeight:0.98,letterSpacing:-1.4,marginBottom:16,textShadow:'0 10px 30px rgba(0,0,0,0.24)'}}>{show.title}</div>
        <div style={{fontSize:14,color:'rgba(219,234,255,0.72)',marginBottom:10,letterSpacing:0.2}}>by {show.creator} &middot; {show.eps} Episode{show.eps>1?'s':''} &middot; {show.cat}</div>
        <p className='hero-desc' style={{fontSize:16,color:'rgba(255,255,255,0.84)',lineHeight:1.75,maxWidth:500,marginBottom:32,fontWeight:300}}>{show.desc}</p>
        <div style={{display:'flex',gap:10,flexWrap:'wrap',alignItems:'center'}}>
          <button onClick={()=>onWatch(show)} style={{display:'flex',alignItems:'center',gap:10,padding:'14px 30px',background:C.white,color:'#000',border:'none',borderRadius:999,fontSize:16,fontWeight:800,cursor:'pointer',fontFamily:'inherit',boxShadow:'0 18px 36px rgba(255,255,255,0.16)'}}>&#9654; Play</button>
          <button onClick={()=>onAddList&&onAddList(show.id)} style={{display:'flex',alignItems:'center',gap:8,padding:'14px 24px',background:'rgba(255,255,255,0.09)',backdropFilter:'blur(14px)',color:C.white,border:`1px solid ${C.border}`,borderRadius:999,fontSize:15,fontWeight:700,cursor:'pointer',fontFamily:'inherit'}}>{inList?'✓ In My List':'+ My List'}</button>
        </div>
      </div>
      <div style={{position:'absolute',bottom:84,right:'4.5%',zIndex:4,display:'flex',alignItems:'center',gap:12}}>
        <button onClick={()=>{const nm=!muted;setMuted(nm);if(playerRef.current)playerRef.current.muted=nm;}} style={{width:40,height:40,borderRadius:'50%',background:'rgba(255,255,255,0.08)',backdropFilter:'blur(14px)',border:`1px solid rgba(255,255,255,0.12)`,color:C.white,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',fontSize:16}}>
          {muted?'🔇':'🔊'}
        </button>
        <div style={{background:'rgba(255,255,255,0.08)',backdropFilter:'blur(14px)',color:C.white,padding:'6px 14px',fontSize:11,fontWeight:800,letterSpacing:1.5,borderRadius:999,border:`1px solid rgba(255,255,255,0.12)`}}>{show.match}% MATCH</div>
      </div>
      <div style={{position:'absolute',bottom:0,left:0,right:0,height:120,background:'linear-gradient(to top,rgba(0,0,0,1),transparent)',zIndex:3}}/>
    </div>
  );
}

function HomeScreen({user,onWatch,onNav,myList,onAddList,onDbShowsLoaded,continueWatching,onOpenChannel}) {
  const [dbShows,setDbShows]=useState([]);
  const [featuredChannel,setFeaturedChannel]=useState(null);
  const [featuredTier,setFeaturedTier]=useState(null);
  useEffect(()=>{
    supabase.from('shows').select('*').order('created_at',{ascending:false}).then(({data})=>{
      if(data&&data.length>0){setDbShows(data);onDbShowsLoaded&&onDbShowsLoaded(data);}
    });
  },[]);
  useEffect(()=>{
    let isMounted = true;
    const loadMembershipSpotlight = async () => {
      const { data: channels } = await supabase
        .from('creator_channels')
        .select('*')
        .eq('membership_enabled', true)
        .limit(1);

      const channel = channels?.[0];
      if (!channel) return;

      const { data: tiers } = await supabase
        .from('membership_tiers')
        .select('*')
        .eq('creator_channel_id', channel.id)
        .eq('is_active', true)
        .order('sort_order', { ascending: true })
        .limit(1);

      if (!isMounted) return;
      setFeaturedChannel(channel);
      setFeaturedTier(tiers?.[0] || null);
    };

    loadMembershipSpotlight();
    return () => {
      isMounted = false;
    };
  }, []);
  const isAdmin=user?.email==='creators@vaultt.co.za';
  const realShows=dbShows.map(s=>({...s,g:'135deg,#27384d,#4d6079',emoji:'\u{1F3AC}',match:99,subs:'0',isLocal:s.is_local,isNew:s.is_new,cat:s.category||s.type,creator:user?.full_name||'VAULTT Creator',desc:s.description||s.title,eps:s.episode_count||1,top10:null}));
  const normalizedContinueWatching=(continueWatching||[]).map((show)=>({
    ...show,
    g:
      !show.g || show.g === '135deg,#1e3a5f,#2d5a8e'
        ? '135deg,#27384d,#4d6079'
        : show.g,
  }));
  const allShows=isAdmin?[...realShows,...DEMO_SHOWS]:realShows;
  const hero=allShows[0];
  const isCreator=user?.role==='creator';
  return (
    <div style={{background:'radial-gradient(circle at 46% 0%, rgba(75,163,255,0.11) 0%, transparent 24%), radial-gradient(circle at 80% 10%, rgba(241,198,109,0.09) 0%, transparent 18%), linear-gradient(180deg,#07090f 0%,#0d1520 42%,#121c28 74%,#151f2c 100%)',minHeight:'100vh',paddingTop:hero?0:144}}>
      <Hero show={hero} onWatch={onWatch} onAddList={onAddList} myList={myList}/>
      {myList&&myList.length>0&&<Shelf title="My List" shows={allShows.filter(s=>myList.includes(s.id))} onWatch={onWatch} onAddList={onAddList} myList={myList}/>}
      {normalizedContinueWatching.length>0&&<Shelf title="Continue Watching" shows={normalizedContinueWatching} onWatch={onWatch} onAddList={onAddList} myList={myList}/>}
      <CreatorMembershipSpotlight channel={featuredChannel} tier={featuredTier} onOpenChannel={()=>onOpenChannel&&onOpenChannel(featuredChannel)} onOpenStudio={()=>onNav('dashboard')} isCreator={user?.role==='creator'} />
      {realShows.length===0&&!isAdmin&&(
        <div style={{padding:'80px 4%',textAlign:'center'}}>
              <div style={{width:116,height:116,margin:'0 auto 20px',borderRadius:32,background:'radial-gradient(circle at 32% 24%, rgba(102,178,255,0.18) 0%, transparent 40%), linear-gradient(135deg,#26374f,#4d5d79)',border:'1px solid rgba(255,255,255,0.08)',display:'flex',alignItems:'center',justifyContent:'center',boxShadow:'0 18px 40px rgba(0,0,0,0.22)'}}>
                <div style={{fontSize:64,fontWeight:900,color:'rgba(255,255,255,0.16)',letterSpacing:-4,lineHeight:0.8}}>VP</div>
              </div>
          <div style={{fontFamily:'Arial',fontSize:32,fontWeight:900,color:'#fff',marginBottom:12}}>Content dropping June 2026</div>
          <div style={{fontSize:15,color:'#808080',maxWidth:480,margin:'0 auto 28px',lineHeight:1.7}}>We are handpicking the best SA creators right now. Sports, comedy, talk shows, podcasts and SA Originals — all launching June 2026.</div>
          <div style={{display:'flex',gap:10,justifyContent:'center',flexWrap:'wrap',marginBottom:32}}>
            {['⚽ Sports','🎭 SA Originals','🎙️ Talk Shows','🎧 Podcasts'].map((c,i)=>(
              <div key={i} style={{padding:'10px 20px',background:'rgba(255,255,255,0.06)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:4,fontSize:13,color:'#b3b3b3',fontWeight:600}}>{c}</div>
            ))}
          </div>
          <div style={{fontSize:13,color:'#0071eb',fontWeight:600}}>Are you a SA creator? Apply for a founding spot →</div>
        </div>
      )}
      {realShows.length>0&&<Shelf title="Your Uploads" shows={realShows} onWatch={onWatch} onAddList={onAddList} myList={myList} badge="New"/>}
      <div style={{margin:'0 4% 40px',background:'radial-gradient(circle at 82% 16%, rgba(241,198,109,0.08) 0%, transparent 18%), linear-gradient(135deg,rgba(18,28,42,0.94),rgba(13,20,30,0.96) 58%,rgba(20,30,44,0.98) 100%)',border:`1px solid ${C.border}`,borderRadius:28,padding:'28px 30px',display:'flex',justifyContent:'space-between',alignItems:'center',gap:18,flexWrap:'wrap',boxShadow:'0 20px 44px rgba(0,0,0,0.24)'}}>
        <div>
          <div style={{fontSize:12,fontWeight:700,letterSpacing:1.6,textTransform:'uppercase',marginBottom:8,color:'#f3dfb4'}}>NightDrop</div>
          <div style={{fontFamily:'Arial',fontSize:34,fontWeight:900,color:C.white,lineHeight:1.02,marginBottom:6}}>A nightly drop the audience can steer.</div>
          <div style={{fontSize:14,color:C.grey2,lineHeight:1.7,maxWidth:620}}>Preview VAULTT’s interactive mini-drama format with premium voting, next-episode branching and a creator-facing production loop.</div>
        </div>
        <button onClick={()=>onNav('nightdrop')} style={{padding:'13px 24px',background:'linear-gradient(135deg,#6bb5ff,#3d91ee)',color:C.white,border:'none',borderRadius:999,fontSize:13,fontWeight:800,cursor:'pointer',fontFamily:'inherit',boxShadow:'0 18px 34px rgba(66,144,235,0.24)'}}>Open NightDrop</button>
      </div>
      <Shelf title="Top 10 in South Africa" shows={[...allShows].sort((a,b)=>(a.top10||99)-(b.top10||99)).slice(0,10)} onWatch={onWatch} onAddList={onAddList} myList={myList}/>
      <Shelf title="SA Originals" shows={allShows.filter(s=>s.cat==='SA Originals'||s.isLocal)} onWatch={onWatch} onAddList={onAddList} myList={myList}/>
      <Shelf title="Sports" shows={allShows.filter(s=>s.cat==='Sports'||s.type==='sports')} onWatch={onWatch} onAddList={onAddList} myList={myList}/>
      <Shelf title="Talk Shows" shows={allShows.filter(s=>s.cat==='Talk Shows'||s.type==='talk_show')} onWatch={onWatch} onAddList={onAddList} myList={myList}/>
      <Shelf title="Podcasts" shows={allShows.filter(s=>s.cat==='Podcasts'||s.type==='podcast')} onWatch={onWatch} onAddList={onAddList} myList={myList}/>
      {isCreator&&<div style={{margin:'0 4% 48px',background:'radial-gradient(circle at 78% 18%, rgba(241,198,109,0.08) 0%, transparent 20%), linear-gradient(135deg,rgba(18,28,42,0.94),rgba(15,24,36,0.96) 58%,rgba(20,30,44,0.98) 100%)',border:`1px solid ${C.border}`,borderRadius:24,padding:'26px 30px',display:'flex',justifyContent:'space-between',alignItems:'center',gap:18,flexWrap:'wrap',boxShadow:'0 20px 44px rgba(0,0,0,0.24)'}}><div><div style={{fontSize:12,fontWeight:700,letterSpacing:1.5,textTransform:'uppercase',marginBottom:6,color:'#f3dfb4'}}>Creator Workspace</div><div style={{fontFamily:'Arial',fontSize:34,fontWeight:900,color:C.white,lineHeight:1.02,marginBottom:6}}>Run your channel from one place</div><div style={{fontSize:13,color:C.grey2,lineHeight:1.6,maxWidth:520}}>Manage memberships, publish bonus drops, schedule live rooms and prepare your creator experience for launch.</div></div><button onClick={()=>onNav('dashboard')} style={{padding:'13px 24px',background:'linear-gradient(135deg,#6bb5ff,#3d91ee)',color:C.white,border:'none',borderRadius:999,fontSize:13,fontWeight:800,cursor:'pointer',fontFamily:'inherit',boxShadow:'0 18px 34px rgba(66,144,235,0.24)'}}>Open Studio</button></div>}
      <div style={{height:80}}/>
    </div>
  );
}

function CategoryScreen({category,title,onWatch,onAddList,myList,onNav,user}) {
  const [dbShows,setDbShows]=useState([]);
  useEffect(()=>{supabase.from('shows').select('*').order('created_at',{ascending:false}).then(({data})=>{if(data&&data.length>0)setDbShows(data);});},[]);
  const realShows=dbShows.map(s=>({...s,g:'135deg,#27384d,#4d6079',emoji:'\u{1F3AC}',match:99,subs:'0',isLocal:s.is_local,isNew:s.is_new,cat:s.category,creator:'VAULTT Creator',desc:s.description||'',eps:s.episode_count||1}));
  const allShows=[...realShows,...DEMO_SHOWS];
  const filtered=allShows.filter(s=>{
    if(category==='originals')return s.cat==='SA Originals'||s.isLocal;
    if(category==='sports')return s.cat==='Sports'||s.type==='sports';
    if(category==='talkshows')return s.cat==='Talk Shows'||s.type==='talk_show';
    if(category==='podcasts')return s.cat==='Podcasts'||s.type==='podcast';
    return true;
  });
  return (
    <div style={{background:'radial-gradient(circle at 48% 0%, rgba(75,163,255,0.12) 0%, transparent 24%), radial-gradient(circle at 84% 10%, rgba(241,198,109,0.08) 0%, transparent 18%), linear-gradient(180deg,#06070b 0%,#0d1118 42%,#141a24 100%)',minHeight:'100vh',paddingTop:86}}>
      <div style={{padding:'32px 4% 26px'}}>
        <div style={{background:'radial-gradient(circle at 80% 18%, rgba(241,198,109,0.08) 0%, transparent 18%), linear-gradient(135deg,rgba(18,28,42,0.92),rgba(13,20,30,0.96) 58%,rgba(20,30,44,0.98) 100%)',border:`1px solid ${C.border}`,borderRadius:30,padding:'34px 34px 28px',boxShadow:'0 20px 48px rgba(0,0,0,0.24)'}}>
          <div style={{fontSize:12,fontWeight:800,letterSpacing:2,textTransform:'uppercase',color:'#f3dfb4',marginBottom:10}}>Browse lane</div>
          <div style={{fontFamily:'Arial',fontSize:'clamp(38px,5vw,62px)',fontWeight:900,color:C.white,letterSpacing:-1.4,lineHeight:0.96,marginBottom:10}}>{title}</div>
          <div style={{fontSize:15,color:C.grey2,lineHeight:1.7,maxWidth:660,marginBottom:16}}>
            {category==='originals' && 'Premium South African storytelling, reality, lifestyle and comedy built for viewers who want local substance, not filler.'}
            {category==='sports' && 'Live watch-alongs, match-night reactions and creator-led breakdowns built around South African sports culture.'}
            {category==='talkshows' && 'Panel shows, founder conversations and creator-driven formats that bring local perspective into every episode.'}
            {category==='podcasts' && 'Video-first podcasts and episode-based formats for loyal audiences who come back for real voices and strong communities.'}
          </div>
          <div style={{display:'flex',gap:10,flexWrap:'wrap'}}>
            <span style={{padding:'8px 12px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:999,fontSize:12,color:C.grey2}}>{filtered.length} titles</span>
            <span style={{padding:'8px 12px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:999,fontSize:12,color:C.grey2}}>Curated for VAULTT</span>
          </div>
        </div>
      </div>
      <div className='category-grid' style={{padding:'8px 4% 100px',display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(220px,1fr))',gap:18}}>
        {filtered.map(s=>(
          <div key={s.id} onClick={()=>onWatch(s)} style={{cursor:'pointer',borderRadius:24,overflow:'hidden',transition:'transform 0.22s ease, box-shadow 0.22s ease',background:'linear-gradient(180deg,rgba(20,26,36,0.94),rgba(14,20,28,0.94))',border:`1px solid ${C.border}`,boxShadow:'0 14px 32px rgba(0,0,0,0.18)'}} onMouseEnter={e=>{e.currentTarget.style.transform='translateY(-4px) scale(1.01)';e.currentTarget.style.boxShadow='0 22px 42px rgba(0,0,0,0.26)';}} onMouseLeave={e=>{e.currentTarget.style.transform='translateY(0) scale(1)';e.currentTarget.style.boxShadow='0 14px 32px rgba(0,0,0,0.18)';}}>
            <div style={{aspectRatio:'16/9',background:`linear-gradient(${s.g})`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:42,position:'relative'}}>
              <PosterArtwork show={s} size='wide' rank={s.top10} />
            </div>
            <div style={{padding:'14px 14px 16px'}}>
              <div style={{fontSize:16,fontWeight:800,color:C.white,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',marginBottom:4}}>{s.title}</div>
              <div style={{fontSize:12,color:C.grey2,marginBottom:8}}>{s.creator}</div>
              <div style={{fontSize:12,color:C.grey2,lineHeight:1.6,minHeight:38}}>{s.desc || 'A premium VAULTT title.'}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function WatchScreen({show,onBack,myList,onAddList,onHome,onWatch}) {
  const [playing,setPlaying]=useState(false);
  const [pct,setPct]=useState(0);
  const inList=myList&&myList.includes(show.id);
  const relatedShows=DEMO_SHOWS.filter((item)=>item.id!==show.id&&(item.cat===show.cat||item.type===show.type||item.isLocal===show.isLocal)).slice(0,4);
  const fallbackRelated=(relatedShows.length>0?relatedShows:DEMO_SHOWS.filter((item)=>item.id!==show.id).slice(0,4));
  useEffect(()=>{if(!playing||show.mux_playback_id)return;const t=setInterval(()=>setPct(p=>{if(p>=100){clearInterval(t);setPlaying(false);return 100;}return p+0.25;}),120);return()=>clearInterval(t);},[playing,show.mux_playback_id]);
  return (
    <div style={{background:'radial-gradient(circle at 50% 0%, rgba(75,163,255,0.12) 0%, transparent 22%), radial-gradient(circle at 82% 10%, rgba(241,198,109,0.08) 0%, transparent 18%), linear-gradient(180deg,#06070b 0%,#0d1118 44%,#141a24 100%)',minHeight:'100vh',paddingTop:104}}>
      <div style={{maxWidth:1220,margin:'0 auto',padding:'20px 4% 100px'}}>
        <div style={{display:'flex',gap:12,alignItems:'center',marginBottom:16,flexWrap:'wrap'}}>
          <button onClick={onBack} style={{display:'flex',alignItems:'center',gap:6,background:'none',border:'none',color:'#91cfff',cursor:'pointer',fontSize:13,fontWeight:700,fontFamily:'inherit',padding:0}}>Back</button>
          <button onClick={onHome} style={{padding:'8px 14px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:999,color:C.white,cursor:'pointer',fontSize:12,fontWeight:700,fontFamily:'inherit'}}>Home</button>
          <div style={{marginLeft:'auto',display:'flex',gap:8,flexWrap:'wrap'}}>
            <span style={{padding:'7px 12px',background:'rgba(255,255,255,0.06)',border:`1px solid ${C.border}`,borderRadius:999,fontSize:11,fontWeight:800,color:C.grey2,letterSpacing:1.2,textTransform:'uppercase'}}>{show.cat || show.type || 'Featured'}</span>
            {show.isLocal&&<span style={{padding:'7px 12px',background:'rgba(241,198,109,0.1)',border:'1px solid rgba(241,198,109,0.2)',borderRadius:999,fontSize:11,fontWeight:800,color:'#f3dfb4',letterSpacing:1.2,textTransform:'uppercase'}}>SA Original</span>}
          </div>
        </div>
        <div onClick={()=>{if(!show.mux_playback_id)setPlaying(!playing);}} style={{borderRadius:34,overflow:'hidden',background:show.mux_playback_id?'#000':`linear-gradient(${show.g})`,aspectRatio:'16/9',display:'flex',alignItems:'center',justifyContent:'center',fontSize:80,position:'relative',marginBottom:24,cursor:'pointer',boxShadow:'0 28px 70px rgba(0,0,0,0.5)',border:`1px solid ${C.border}`}}>
          {show.mux_playback_id?(
            <video src={`https://stream.mux.com/${show.mux_playback_id}.m3u8`} controls autoPlay style={{width:'100%',height:'100%',objectFit:'contain',background:'#000'}} poster={`https://image.mux.com/${show.mux_playback_id}/thumbnail.jpg`}/>
          ):(
            <>
              <div style={{fontSize:96,fontWeight:900,color:'rgba(255,255,255,0.12)',letterSpacing:-4,lineHeight:0.8}}>{initialsFromTitle(show.title)}</div>
              <div style={{position:'absolute',inset:0,background:'linear-gradient(180deg,rgba(255,255,255,0.02),transparent 34%,rgba(0,0,0,0.24) 100%)',display:'flex',alignItems:'center',justifyContent:'center'}}>
                <div style={{width:72,height:72,borderRadius:'50%',background:'rgba(255,255,255,0.9)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:26,color:'#000'}}>{playing?'⏸':'▶'}</div>
              </div>
              <div style={{position:'absolute',bottom:0,left:0,right:0,height:4,background:'rgba(255,255,255,0.15)'}}>
                <div style={{height:'100%',background:C.red,width:`${pct}%`,transition:'width 0.1s'}}/>
              </div>
            </>
          )}
          <div style={{position:'absolute',left:24,right:24,bottom:22,display:'flex',justifyContent:'space-between',alignItems:'flex-end',gap:18,pointerEvents:'none'}}>
            <div style={{maxWidth:620}}>
              <div style={{display:'inline-flex',gap:8,alignItems:'center',padding:'6px 12px',background:'rgba(8,18,30,0.52)',backdropFilter:'blur(14px)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:999,fontSize:11,fontWeight:800,color:C.white,letterSpacing:1.3,textTransform:'uppercase',marginBottom:12}}>
                {show.match}% Match
              </div>
              <div style={{fontSize:'clamp(30px,4vw,56px)',fontWeight:900,color:C.white,letterSpacing:-1.4,lineHeight:0.98,textShadow:'0 12px 28px rgba(0,0,0,0.28)'}}>{show.title}</div>
            </div>
            <div style={{padding:'8px 14px',background:'rgba(8,18,30,0.52)',backdropFilter:'blur(14px)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:999,fontSize:12,color:C.grey2,whiteSpace:'nowrap'}}>{show.creator || 'VAULTT Creator'}</div>
          </div>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'minmax(0,1.15fr) minmax(320px,0.7fr)',gap:22,marginBottom:34}} className='watch-details-grid'>
          <div style={{background:'linear-gradient(180deg,rgba(20,26,36,0.92),rgba(14,20,28,0.92))',border:`1px solid ${C.border}`,borderRadius:28,padding:'28px 26px',boxShadow:'0 18px 50px rgba(0,0,0,0.22)'}}>
            <div style={{display:'flex',gap:10,alignItems:'center',flexWrap:'wrap',marginBottom:14}}>
              <span style={{color:C.green,fontWeight:700,fontSize:14}}>{show.match}% Match</span>
              <span style={{padding:'5px 10px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:999,fontSize:11,color:C.grey2}}>{show.eps || 1} episode{show.eps>1?'s':''}</span>
              <span style={{padding:'5px 10px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:999,fontSize:11,color:C.grey2}}>{show.cat || 'Featured on VAULTT'}</span>
            </div>
            <div style={{fontSize:32,fontWeight:900,color:C.white,letterSpacing:-0.8,lineHeight:1.02,marginBottom:12}}>{show.title}</div>
            <p style={{fontSize:15,color:C.grey2,lineHeight:1.8,marginBottom:22,maxWidth:720}}>{show.desc}</p>
            <div style={{display:'flex',gap:10,flexWrap:'wrap'}}>
              <button onClick={()=>onAddList&&onAddList(show.id)} style={{padding:'12px 18px',border:`1px solid ${inList?C.blue:'rgba(255,255,255,0.14)'}`,borderRadius:999,background:inList?C.blueL:'rgba(255,255,255,0.05)',color:inList?C.blue:C.white,cursor:'pointer',fontFamily:'inherit',fontSize:13,fontWeight:700}}>{inList?'✓ In My List':'+ Save to My List'}</button>
              <button onClick={onHome} style={{padding:'12px 18px',border:`1px solid ${C.border}`,borderRadius:999,background:'rgba(255,255,255,0.03)',color:C.white,cursor:'pointer',fontFamily:'inherit',fontSize:13,fontWeight:700}}>Browse more</button>
            </div>
          </div>
          <div style={{background:'radial-gradient(circle at 82% 16%, rgba(241,198,109,0.08) 0%, transparent 22%), linear-gradient(180deg,rgba(20,26,36,0.94),rgba(14,20,28,0.94))',border:`1px solid ${C.border}`,borderRadius:28,padding:'28px 24px',boxShadow:'0 18px 50px rgba(0,0,0,0.22)'}}>
            <div style={{fontSize:11,fontWeight:800,letterSpacing:1.8,textTransform:'uppercase',color:'#f3dfb4',marginBottom:10}}>Creator Access</div>
            <div style={{fontSize:24,fontWeight:900,color:C.white,letterSpacing:-0.6,marginBottom:10}}>{show.creator || 'VAULTT Creator'}</div>
            <div style={{fontSize:14,color:C.grey2,lineHeight:1.7,marginBottom:18}}>
              Support this creator, unlock member drops and stay close to future live sessions, bonus notes and founder-only access.
            </div>
            <div style={{display:'grid',gap:10,marginBottom:18}}>
              {['Founding member drops','Creator support layer','Future live watch-alongs'].map((item)=>(
                <div key={item} style={{display:'flex',gap:10,alignItems:'flex-start'}}>
                  <span style={{color:C.green,fontSize:13,marginTop:1}}>✓</span>
                  <span style={{fontSize:13,color:C.grey2,lineHeight:1.5}}>{item}</span>
                </div>
              ))}
            </div>
            <div style={{display:'grid',gap:10}}>
              <button style={{width:'100%',padding:'13px 16px',background:'linear-gradient(135deg,#66b2ff,#2f8fff)',color:C.white,border:'none',borderRadius:999,fontSize:14,fontWeight:800,cursor:'pointer',fontFamily:'inherit',boxShadow:'0 14px 28px rgba(75,163,255,0.18)'}}>Join Membership</button>
              <button style={{width:'100%',padding:'12px 16px',background:'rgba(255,255,255,0.05)',color:C.white,border:`1px solid ${C.border}`,borderRadius:999,fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'inherit'}}>Support creator</button>
            </div>
          </div>
        </div>
        <div style={{marginBottom:18}}>
          <div style={{fontSize:22,fontWeight:800,color:C.white,letterSpacing:-0.3,marginBottom:16}}>More on VAULTT</div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))',gap:16}}>
            {fallbackRelated.map((item)=>(
              <div key={item.id} onClick={()=>onWatch&&onWatch(item)} style={{background:'linear-gradient(180deg,rgba(20,26,36,0.92),rgba(14,20,28,0.92))',border:`1px solid ${C.border}`,borderRadius:24,overflow:'hidden',cursor:'pointer',boxShadow:'0 16px 40px rgba(0,0,0,0.2)'}}>
                <div style={{aspectRatio:'16/9',background:`linear-gradient(${item.g})`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:36,position:'relative'}}>
                  <PosterArtwork show={item} size='wide' />
                </div>
                <div style={{padding:16}}>
                  <div style={{fontSize:16,fontWeight:800,color:C.white,marginBottom:6}}>{item.title}</div>
                  <div style={{fontSize:12,color:C.grey2,lineHeight:1.6}}>{item.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function LiveScreen({ onNav, user }) {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [roomMessages, setRoomMessages] = useState([]);
  const [messageDraft, setMessageDraft] = useState('');
  const [reactionPulse, setReactionPulse] = useState([]);

  useEffect(() => {
    let mounted = true;
    const loadEvents = async () => {
      const [eventsRes, channelsRes] = await Promise.all([
        supabase.from('live_events').select('*').order('starts_at', { ascending: true }).limit(12),
        supabase.from('creator_channels').select('id,display_name'),
      ]);

      if (!mounted) return;
      const channelMap = Object.fromEntries((channelsRes.data || []).map((channel) => [channel.id, channel.display_name]));
      const dbEvents = (eventsRes.data || []).map((event) => mapLiveEventCard(event, channelMap[event.creator_channel_id] || 'VAULTT Creator'));
      setEvents(
        dbEvents.length > 0
          ? dbEvents
          : LIVE_NOW.map((event, index) => ({
              ...event,
              status: 'live',
              startsAt: new Date(Date.now() + index * 3600000).toISOString(),
              description: 'Creator-led live room for early audiences and community reactions.',
              accessType: 'public',
              ticketPrice: null,
              isWatchAlong: event.title.toLowerCase().includes('psl'),
            }))
      );
    };

    loadEvents();
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    let mounted = true;
    const loadRoom = async () => {
      if (!selectedEvent?.id) return;
      const [messageRes, reactionRes] = await Promise.all([
        supabase
          .from('live_event_messages')
          .select('id,display_name,message,created_at')
          .eq('live_event_id', selectedEvent.id)
          .order('created_at', { ascending: true })
          .limit(40),
        supabase
          .from('live_event_reactions')
          .select('id,reaction,created_at')
          .eq('live_event_id', selectedEvent.id)
          .order('created_at', { ascending: false })
          .limit(20),
      ]);

      if (!mounted) return;
      setRoomMessages(messageRes.data || []);
      setReactionPulse((reactionRes.data || []).slice(0, 8));
    };

    loadRoom();
    return () => {
      mounted = false;
    };
  }, [selectedEvent?.id]);

  const sendChatMessage = async () => {
    const text = messageDraft.trim();
    if (!text || !selectedEvent) return;

    const optimistic = {
      id: `local-${Date.now()}`,
      display_name: user?.full_name || user?.email || 'Viewer',
      message: text,
      created_at: new Date().toISOString(),
    };

    setRoomMessages((prev) => [...prev, optimistic]);
    setMessageDraft('');

    await supabase.from('live_event_messages').insert({
      live_event_id: selectedEvent.id,
      creator_channel_id: selectedEvent.creator_channel_id || null,
      viewer_id: user?.id || null,
      display_name: user?.full_name || user?.email || 'Viewer',
      message: text,
    });
  };

  const sendReaction = async (reaction) => {
    if (!selectedEvent) return;
    const optimistic = {
      id: `reaction-${Date.now()}`,
      reaction,
      created_at: new Date().toISOString(),
    };
    setReactionPulse((prev) => [optimistic, ...prev].slice(0, 10));

    await supabase.from('live_event_reactions').insert({
      live_event_id: selectedEvent.id,
      creator_channel_id: selectedEvent.creator_channel_id || null,
      viewer_id: user?.id || null,
      display_name: user?.full_name || user?.email || 'Viewer',
      reaction,
    });
  };

  return (
    <div style={{background:'radial-gradient(circle at 50% 0%, rgba(75,163,255,0.12) 0%, transparent 22%), radial-gradient(circle at 84% 10%, rgba(241,198,109,0.08) 0%, transparent 18%), linear-gradient(180deg,#06070b 0%,#0d1118 44%,#141a24 100%)',minHeight:'100vh',paddingTop:104}}>
      <div style={{padding:'28px 4% 22px'}}>
        <div style={{background:'radial-gradient(circle at 82% 18%, rgba(241,198,109,0.08) 0%, transparent 18%), linear-gradient(135deg,rgba(18,28,42,0.92),rgba(13,20,30,0.96) 58%,rgba(20,30,44,0.98) 100%)',border:`1px solid ${C.border}`,borderRadius:30,padding:'34px 34px 28px',boxShadow:'0 20px 48px rgba(0,0,0,0.24)'}}>
          <div style={{fontSize:12,fontWeight:800,letterSpacing:2,textTransform:'uppercase',color:'#f3dfb4',marginBottom:10}}>Live on VAULTT</div>
          <div style={{fontFamily:'Arial',fontSize:'clamp(38px,5vw,62px)',fontWeight:900,color:C.white,marginBottom:10,letterSpacing:-1.4,lineHeight:0.96}}>Live community rooms</div>
          <div style={{fontSize:15,color:C.grey2,lineHeight:1.7,maxWidth:760,marginBottom:16}}>
            Scheduled watch-alongs, live creator briefings and reaction rooms are now part of the platform. Creators can schedule them in Studio, audiences can gather here, and chat plus reactions are ready for the next payment-connected phase.
          </div>
          <div style={{display:'flex',gap:10,flexWrap:'wrap'}}>
            <span style={{padding:'8px 12px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:999,fontSize:12,color:C.grey2}}>{events.length} live or scheduled rooms</span>
            <span style={{padding:'8px 12px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:999,fontSize:12,color:C.grey2}}>Chat + reactions layer</span>
          </div>
        </div>
      </div>

      <div style={{padding:'10px 4% 24px',display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(320px,1fr))',gap:22}}>
        {events.map((event) => (
          <div key={event.id} style={{borderRadius:30,overflow:'hidden',background:'linear-gradient(180deg,rgba(20,26,36,0.96),rgba(15,20,29,0.94))',border:'1px solid rgba(176,202,233,0.12)',boxShadow:'0 20px 48px rgba(0,0,0,0.26)'}}>
            <div style={{height:230,background:`linear-gradient(${event.bg})`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:62,position:'relative'}}>
              <div style={{position:'absolute',top:14,left:14,background:event.status === 'live' ? 'rgba(229,9,20,0.9)' : 'rgba(243,223,180,0.18)',color:C.white,fontSize:10,fontWeight:900,letterSpacing:2,padding:'5px 12px',borderRadius:999}}>
                {event.status === 'live' ? 'LIVE' : 'SCHEDULED'}
              </div>
              <div style={{position:'absolute',top:14,right:14,background:'rgba(7,21,35,0.62)',backdropFilter:'blur(12px)',color:C.white,fontSize:11,padding:'5px 10px',borderRadius:999,border:'1px solid rgba(255,255,255,0.08)'}}>
                {event.status === 'live' ? `${event.viewers.toLocaleString()} watching` : formatDateTimeShort(event.startsAt)}
              </div>
              <div style={{position:'absolute',inset:0,background:'linear-gradient(180deg,rgba(255,255,255,0.03),transparent 34%,rgba(0,0,0,0.2) 100%)'}} />
              <div style={{width:118,height:118,borderRadius:30,border:'1px solid rgba(255,255,255,0.08)',background:'rgba(7,14,22,0.26)',backdropFilter:'blur(12px)',display:'flex',alignItems:'center',justifyContent:'center',boxShadow:'inset 0 1px 0 rgba(255,255,255,0.05)'}}>
                <div style={{fontSize:96,fontWeight:900,color:'rgba(255,255,255,0.12)',letterSpacing:-4,lineHeight:0.8}}>{initialsFromTitle(event.title)}</div>
              </div>
            </div>
            <div style={{padding:'18px 20px 20px'}}>
              <div style={{fontSize:20,fontWeight:800,color:C.white,marginBottom:6,letterSpacing:-0.4}}>{event.title}</div>
              <div style={{fontSize:13,color:C.grey2,marginBottom:10}}>{event.name}</div>
              <div style={{fontSize:13,color:C.grey2,lineHeight:1.6,marginBottom:14}}>{event.description}</div>
              <div style={{display:'flex',gap:8,flexWrap:'wrap',marginBottom:16}}>
                <span style={{padding:'6px 10px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:999,fontSize:11,color:C.grey2}}>{event.isWatchAlong ? 'Watch-along' : 'Creator room'}</span>
                <span style={{padding:'6px 10px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:999,fontSize:11,color:C.grey2}}>{event.accessType}</span>
              </div>
              <button onClick={() => setSelectedEvent(event)} style={{width:'100%',padding:'13px 0',background:'linear-gradient(135deg,#66b2ff,#2f8fff)',color:C.white,border:'none',borderRadius:999,fontSize:13,fontWeight:800,cursor:'pointer',fontFamily:'inherit',boxShadow:'0 14px 28px rgba(75,163,255,0.18)'}}>
                {event.status === 'live' ? 'Enter live room' : 'Open event room'}
              </button>
            </div>
          </div>
        ))}
      </div>

      {selectedEvent && (
        <div style={{padding:'0 4% 100px'}}>
          <div style={{display:'grid',gridTemplateColumns:'minmax(0,1.1fr) minmax(320px,0.7fr)',gap:20}} className='watch-details-grid'>
            <div style={{background:'linear-gradient(180deg,rgba(20,26,36,0.94),rgba(14,20,28,0.94))',border:`1px solid ${C.border}`,borderRadius:28,padding:'26px 24px',boxShadow:'0 18px 50px rgba(0,0,0,0.22)'}}>
              <div style={{display:'flex',justifyContent:'space-between',gap:12,alignItems:'center',marginBottom:14,flexWrap:'wrap'}}>
                <div>
                  <div style={{fontSize:11,fontWeight:800,letterSpacing:1.8,textTransform:'uppercase',color:selectedEvent.status === 'live' ? C.red : '#f3dfb4',marginBottom:6}}>
                    {selectedEvent.status === 'live' ? 'Live room' : 'Scheduled room'}
                  </div>
                  <div style={{fontSize:30,fontWeight:900,color:C.white,letterSpacing:-0.9,marginBottom:6}}>{selectedEvent.title}</div>
                  <div style={{fontSize:14,color:C.grey2}}>{selectedEvent.name} · {formatDateTimeShort(selectedEvent.startsAt)}</div>
                </div>
                <button onClick={() => setSelectedEvent(null)} style={{padding:'10px 14px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:999,color:C.white,cursor:'pointer',fontFamily:'inherit',fontSize:12,fontWeight:700}}>Close room</button>
              </div>
              <div style={{aspectRatio:'16/9',borderRadius:24,background:`linear-gradient(${selectedEvent.bg})`,position:'relative',overflow:'hidden',display:'flex',alignItems:'center',justifyContent:'center',marginBottom:18,border:`1px solid ${C.border}`}}>
                <div style={{position:'absolute',inset:0,background:'linear-gradient(180deg,rgba(255,255,255,0.03),transparent 36%,rgba(0,0,0,0.28) 100%)'}} />
                <div style={{fontSize:120,fontWeight:900,color:'rgba(255,255,255,0.12)',letterSpacing:-5,lineHeight:0.8}}>{initialsFromTitle(selectedEvent.title)}</div>
                <div style={{position:'absolute',left:18,bottom:18,right:18,display:'flex',justifyContent:'space-between',alignItems:'flex-end',gap:14}}>
                  <div style={{maxWidth:520}}>
                    <div style={{fontSize:24,fontWeight:900,color:C.white,letterSpacing:-0.7,marginBottom:6}}>{selectedEvent.title}</div>
                    <div style={{fontSize:14,color:'rgba(215,221,232,0.92)',lineHeight:1.6}}>{selectedEvent.description}</div>
                  </div>
                  <div style={{padding:'8px 12px',background:'rgba(7,14,22,0.42)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:999,fontSize:12,color:C.white}}>
                    {selectedEvent.status === 'live' ? `${selectedEvent.viewers.toLocaleString()} watching` : 'Room ready'}
                  </div>
                </div>
              </div>
              <div style={{display:'grid',gap:12}}>
                <div style={{fontSize:12,fontWeight:800,letterSpacing:1.6,textTransform:'uppercase',color:C.blue}}>Live chat</div>
                <div style={{display:'grid',gap:10,maxHeight:360,overflowY:'auto',paddingRight:6}}>
                  {roomMessages.length > 0 ? roomMessages.map((item) => (
                    <div key={item.id} style={{padding:'12px 14px',background:'rgba(255,255,255,0.04)',border:`1px solid ${C.border}`,borderRadius:16}}>
                      <div style={{display:'flex',justifyContent:'space-between',gap:10,marginBottom:5}}>
                        <div style={{fontSize:13,fontWeight:800,color:C.white}}>{item.display_name || 'Viewer'}</div>
                        <div style={{fontSize:11,color:C.grey2}}>{formatDateTimeShort(item.created_at)}</div>
                      </div>
                      <div style={{fontSize:13,color:C.grey2,lineHeight:1.6}}>{item.message}</div>
                    </div>
                  )) : (
                    <div style={{fontSize:13,color:C.grey2,lineHeight:1.6}}>No messages yet. The first comment will kick this room into motion.</div>
                  )}
                </div>
                <div style={{display:'grid',gridTemplateColumns:'minmax(0,1fr) auto',gap:10}}>
                  <input value={messageDraft} onChange={(e) => setMessageDraft(e.target.value)} placeholder='Send a message to the room' style={{width:'100%',padding:'14px 16px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:16,fontSize:14,color:C.white,outline:'none',fontFamily:'inherit'}} />
                  <button onClick={sendChatMessage} style={{padding:'0 18px',background:C.blue,color:C.white,border:'none',borderRadius:16,fontSize:13,fontWeight:800,cursor:'pointer',fontFamily:'inherit'}}>Send</button>
                </div>
              </div>
            </div>

            <div style={{display:'grid',gap:16,alignSelf:'start'}}>
              <div style={{background:'linear-gradient(180deg,rgba(20,26,36,0.94),rgba(14,20,28,0.94))',border:`1px solid ${C.border}`,borderRadius:28,padding:'24px 22px',boxShadow:'0 18px 50px rgba(0,0,0,0.22)'}}>
                <div style={{fontSize:12,fontWeight:800,letterSpacing:1.6,textTransform:'uppercase',color:'#f3dfb4',marginBottom:12}}>Live reactions</div>
                <div style={{display:'flex',gap:10,flexWrap:'wrap',marginBottom:14}}>
                  {['🔥', '👏', '💙', '⚽', '🎉'].map((reaction) => (
                    <button key={reaction} onClick={() => sendReaction(reaction)} style={{width:54,height:54,borderRadius:'50%',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,color:C.white,cursor:'pointer',fontSize:22,fontFamily:'inherit'}}>
                      {reaction}
                    </button>
                  ))}
                </div>
                <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
                  {reactionPulse.length > 0 ? reactionPulse.map((item) => (
                    <span key={item.id} style={{padding:'7px 10px',background:'rgba(255,255,255,0.04)',border:`1px solid ${C.border}`,borderRadius:999,fontSize:12,color:C.white}}>{item.reaction}</span>
                  )) : <div style={{fontSize:13,color:C.grey2,lineHeight:1.6}}>Reactions will stack here as viewers respond in real time.</div>}
                </div>
              </div>

              <div style={{background:'linear-gradient(180deg,rgba(20,26,36,0.94),rgba(14,20,28,0.94))',border:`1px solid ${C.border}`,borderRadius:28,padding:'24px 22px',boxShadow:'0 18px 50px rgba(0,0,0,0.22)'}}>
                <div style={{fontSize:12,fontWeight:800,letterSpacing:1.6,textTransform:'uppercase',color:C.blue,marginBottom:10}}>Room access</div>
                <div style={{fontSize:21,fontWeight:800,color:C.white,marginBottom:8}}>{selectedEvent.accessType}</div>
                <div style={{fontSize:13,color:C.grey2,lineHeight:1.6,marginBottom:12}}>
                  {selectedEvent.ticketPrice
                    ? `This room is prepared for ticketed access at R${Number(selectedEvent.ticketPrice).toFixed(0)} once event payments are switched on.`
                    : 'This room is open through the current creator community flow and ready for future membership or ticket gating.'}
                </div>
                <button onClick={() => onNav('dashboard')} style={{width:'100%',padding:'13px 16px',background:'rgba(255,255,255,0.05)',color:C.white,border:`1px solid ${C.border}`,borderRadius:999,fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'inherit'}}>Open Creator Studio</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function NightDropScreen({ user, onNav, onWatch, setToast }) {
  const [episodes, setEpisodes] = useState(NIGHTDROP_DEMO_EPISODES);
  const [voteRows, setVoteRows] = useState([]);
  const [submittingVote, setSubmittingVote] = useState(false);

  useEffect(() => {
    let mounted = true;
    const loadNightDrop = async () => {
      const [episodeRes, votesRes] = await Promise.all([
        supabase
          .from('nightdrop_episodes')
          .select('*')
          .order('episode_number', { ascending: true }),
        supabase
          .from('nightdrop_votes')
          .select('episode_id,choice,viewer_id,created_at'),
      ]);

      if (!mounted) return;
      if (episodeRes.data && episodeRes.data.length > 0) setEpisodes(episodeRes.data);
      if (votesRes.data) setVoteRows(votesRes.data);
    };
    loadNightDrop();
    return () => {
      mounted = false;
    };
  }, []);

  const featured = episodes.find((ep) => ep.status === 'voting_open') || episodes[0];
  const featuredVotes = voteRows.filter((row) => row.episode_id === featured?.id);
  const votesA = featuredVotes.filter((row) => row.choice === 'A').length;
  const votesB = featuredVotes.filter((row) => row.choice === 'B').length;
  const totalVotes = votesA + votesB;
  const hasVoted = !!featuredVotes.find((row) => row.viewer_id === user?.id);

  const castVote = async (choice) => {
    if (!user?.id) {
      setToast?.({ message: 'Please sign in to vote on NightDrop.', type: 'error' });
      return;
    }
    if (!featured?.id) return;

    setSubmittingVote(true);
    const payload = {
      episode_id: featured.id,
      viewer_id: user.id,
      choice,
    };

    const { data, error } = await supabase
      .from('nightdrop_votes')
      .upsert(payload, { onConflict: 'episode_id,viewer_id' })
      .select('episode_id,choice,viewer_id,created_at');

    if (error) {
      setToast?.({ message: 'We could not save your NightDrop vote yet.', type: 'error' });
      setSubmittingVote(false);
      return;
    }

    setVoteRows((prev) => {
      const rest = prev.filter((row) => !(row.episode_id === featured.id && row.viewer_id === user.id));
      return [...rest, ...(data || [])];
    });
    setToast?.({ message: `Vote ${choice} recorded for NightDrop.`, type: 'success' });
    setSubmittingVote(false);
  };

  const votePctA = totalVotes > 0 ? Math.round((votesA / totalVotes) * 100) : 50;
  const votePctB = totalVotes > 0 ? Math.round((votesB / totalVotes) * 100) : 50;
  const episodeTone = featured?.art_gradient || '135deg,#171a27,#40334a';
  const featuredPalette = getNightDropPalette(featured?.episode_number);

  return (
    <div style={{background:'radial-gradient(circle at 18% 0%, rgba(241,198,109,0.11) 0%, transparent 18%), radial-gradient(circle at 74% 10%, rgba(58,108,173,0.22) 0%, transparent 24%), linear-gradient(180deg,#07090d 0%,#0c121a 38%,#131b26 100%)',minHeight:'100vh',paddingTop:104}}>
      <div style={{padding:'28px 4% 30px'}}>
        <div style={{background:'radial-gradient(circle at 84% 18%, rgba(241,198,109,0.1) 0%, transparent 18%), radial-gradient(circle at 26% 0%, rgba(86,132,205,0.16) 0%, transparent 24%), linear-gradient(135deg,rgba(17,24,34,0.97),rgba(11,16,24,0.98) 58%,rgba(19,28,40,0.98) 100%)',border:`1px solid rgba(188,203,230,0.12)`,borderRadius:32,padding:'34px 34px 30px',boxShadow:'0 24px 54px rgba(0,0,0,0.32)'}}>
          <div style={{fontSize:12,fontWeight:800,letterSpacing:2.2,textTransform:'uppercase',color:'#f3dfb4',marginBottom:10}}>NightDrop</div>
          <div style={{fontFamily:'Arial',fontSize:'clamp(40px,5vw,68px)',fontWeight:900,color:C.white,lineHeight:0.94,letterSpacing:-1.5,marginBottom:12}}>A new drop lands nightly. The audience decides the fallout.</div>
          <div style={{fontSize:15,color:C.grey2,lineHeight:1.75,maxWidth:760,marginBottom:18}}>
            Every night, NightDrop opens a new chapter of glamour, power, betrayal and fast decisions. Watch the episode, follow the tension, and help decide what happens next before the next drop arrives.
          </div>
          <div style={{display:'flex',gap:10,flexWrap:'wrap',marginBottom:18}}>
            <span style={{padding:'8px 12px',background:'rgba(255,255,255,0.05)',border:`1px solid rgba(188,203,230,0.12)`,borderRadius:999,fontSize:12,color:C.grey2}}>Daily drops at 20:00</span>
            <span style={{padding:'8px 12px',background:'rgba(255,255,255,0.05)',border:`1px solid rgba(188,203,230,0.12)`,borderRadius:999,fontSize:12,color:C.grey2}}>Voting closes at 10:00</span>
            <span style={{padding:'8px 12px',background:'rgba(241,198,109,0.1)',border:'1px solid rgba(241,198,109,0.16)',borderRadius:999,fontSize:12,color:'#f3dfb4'}}>Johannesburg after-hours drama</span>
          </div>
          <div style={{display:'flex',gap:12,flexWrap:'wrap'}}>
            <button onClick={() => featured && onWatch({ id:`nightdrop-${featured.id}`, title:featured.title, desc:featured.synopsis, g:featured.art_gradient || '135deg,#171a27,#40334a', creator:'NightDrop', cat:'NightDrop', eps:1, match:99, isLocal:true, type:'series' })} style={{padding:'14px 24px',background:C.white,color:'#000',border:'none',borderRadius:999,fontSize:14,fontWeight:800,cursor:'pointer',fontFamily:'inherit'}}>Preview tonight’s drop</button>
            {user?.email === 'creators@vaultt.co.za' && (
              <button onClick={() => onNav('nightdrop-admin')} style={{padding:'14px 24px',background:'rgba(255,255,255,0.05)',color:C.white,border:`1px solid ${C.border}`,borderRadius:999,fontSize:14,fontWeight:800,cursor:'pointer',fontFamily:'inherit'}}>Open NightDrop Admin</button>
            )}
          </div>
        </div>
      </div>

      <div style={{padding:'0 4% 24px',display:'grid',gridTemplateColumns:'minmax(0,1.1fr) minmax(320px,0.7fr)',gap:20}} className='watch-details-grid'>
        <div style={{background:'linear-gradient(180deg,rgba(18,24,34,0.95),rgba(12,18,26,0.96))',border:`1px solid rgba(188,203,230,0.12)`,borderRadius:28,overflow:'hidden',boxShadow:'0 22px 52px rgba(0,0,0,0.26)'}}>
          <div style={{aspectRatio:'16/9',background:`radial-gradient(circle at 78% 14%, ${featuredPalette.glow} 0%, transparent 22%), radial-gradient(circle at 18% 0%, ${featuredPalette.wash} 0%, transparent 24%), linear-gradient(${episodeTone})`,position:'relative',display:'flex',alignItems:'flex-end',padding:'28px'}}>
            <div style={{position:'absolute',inset:0,background:'linear-gradient(180deg,rgba(255,255,255,0.03),transparent 30%,rgba(6,8,12,0.18) 52%,rgba(0,0,0,0.5) 100%)'}} />
            <div style={{position:'absolute',top:24,right:24,width:190,height:190,borderRadius:'50%',background:`radial-gradient(circle, ${featuredPalette.glow} 0%, rgba(0,0,0,0) 72%)`,filter:'blur(6px)',opacity:0.92}} />
            <div style={{position:'absolute',inset:'auto 24px 24px auto',padding:'10px 16px',borderRadius:999,background:'rgba(11,16,24,0.34)',border:`1px solid ${featuredPalette.edge}`,backdropFilter:'blur(10px)',fontSize:11,fontWeight:800,letterSpacing:2.1,textTransform:'uppercase',color:'#f4e2bc'}}>
              {featuredPalette.stamp}
            </div>
            <div style={{position:'absolute',left:28,top:28,fontSize:11,fontWeight:800,letterSpacing:2.1,textTransform:'uppercase',color:'rgba(255,255,255,0.74)'}}>
              {featuredPalette.micro}
            </div>
            <div style={{position:'relative',zIndex:1,maxWidth:620}}>
              <div style={{display:'inline-flex',padding:'7px 12px',background:featured?.status === 'voting_open' ? 'rgba(241,198,109,0.18)' : 'rgba(255,255,255,0.08)',border:`1px solid ${featured?.status === 'voting_open' ? 'rgba(241,198,109,0.28)' : C.border}`,borderRadius:999,fontSize:11,fontWeight:800,letterSpacing:1.5,textTransform:'uppercase',color:featured?.status === 'voting_open' ? '#f3dfb4' : C.white,marginBottom:12}}>
                {featured?.status === 'voting_open' ? 'Voting open now' : featured?.status || 'Planned'}
              </div>
              <div style={{fontFamily:'Arial',fontSize:'clamp(34px,4vw,58px)',fontWeight:900,color:C.white,lineHeight:0.96,letterSpacing:-1.2,marginBottom:10}}>
                Episode {featured?.episode_number}: {featured?.title}
              </div>
              <div style={{fontSize:14,color:'#f3dfb4',fontWeight:700,letterSpacing:0.2,lineHeight:1.6,marginBottom:10,maxWidth:540}}>
                {featured?.hook || 'Tonight, one decision changes the next episode.'}
              </div>
              <div style={{fontSize:15,color:'rgba(215,221,232,0.92)',lineHeight:1.75,maxWidth:560}}>
                {featured?.synopsis}
              </div>
            </div>
          </div>
          <div style={{padding:'22px 24px 24px'}}>
            <div style={{display:'flex',justifyContent:'space-between',gap:12,alignItems:'center',marginBottom:12,flexWrap:'wrap'}}>
              <div style={{fontSize:12,fontWeight:800,letterSpacing:1.7,textTransform:'uppercase',color:'#f3dfb4'}}>Tonight’s choice</div>
              <div style={{fontSize:12,color:C.grey2}}>{totalVotes.toLocaleString()} total votes so far</div>
            </div>
            <div style={{display:'grid',gap:12}}>
              {[
                { key:'A', label:featured?.vote_option_a, pct:votePctA, count:votesA },
                { key:'B', label:featured?.vote_option_b, pct:votePctB, count:votesB },
              ].map((option) => (
                <button key={option.key} onClick={() => castVote(option.key)} disabled={submittingVote || !featured || featured.status !== 'voting_open'} style={{textAlign:'left',padding:'16px 18px',background:'linear-gradient(180deg,rgba(255,255,255,0.045),rgba(255,255,255,0.025))',border:`1px solid rgba(188,203,230,0.12)`,borderRadius:18,color:C.white,cursor:submittingVote || !featured || featured.status !== 'voting_open' ? 'not-allowed' : 'pointer',fontFamily:'inherit',boxShadow:'inset 0 1px 0 rgba(255,255,255,0.04)'}}>
                  <div style={{display:'flex',justifyContent:'space-between',gap:12,alignItems:'center',marginBottom:8}}>
                    <div style={{fontSize:11,fontWeight:800,letterSpacing:1.4,textTransform:'uppercase',color:'#f3dfb4'}}>Option {option.key}</div>
                    <div style={{fontSize:12,color:C.grey2}}>{option.count} votes · {option.pct}%</div>
                  </div>
                  <div style={{fontSize:16,fontWeight:700,color:C.white,marginBottom:10,lineHeight:1.45}}>{option.label}</div>
                  <div style={{height:8,background:'rgba(255,255,255,0.05)',borderRadius:999,overflow:'hidden'}}>
                    <div style={{height:'100%',width:`${option.pct}%`,background:option.key === 'A' ? 'linear-gradient(135deg,#f1c66d,#d7a53f)' : 'linear-gradient(135deg,#6fa9e8,#3d78c7)'}} />
                  </div>
                </button>
              ))}
            </div>
            <div style={{marginTop:14,fontSize:13,color:C.grey2,lineHeight:1.65}}>
              {hasVoted ? 'Your vote is in. You can still watch the count move before the 10:00 close.' : 'Choose the path you want to see win. The strongest vote shapes what the next drop becomes.'}
            </div>
          </div>
        </div>

        <div style={{display:'grid',gap:16,alignSelf:'start'}}>
          <div style={{background:'linear-gradient(180deg,rgba(18,24,34,0.95),rgba(12,18,26,0.96))',border:`1px solid rgba(188,203,230,0.12)`,borderRadius:28,padding:'24px 22px',boxShadow:'0 18px 50px rgba(0,0,0,0.22)'}}>
            <div style={{fontSize:12,fontWeight:800,letterSpacing:1.6,textTransform:'uppercase',color:'#f3dfb4',marginBottom:10}}>Coming next</div>
            <div style={{display:'grid',gap:10}}>
              {episodes.slice(0, 3).map((episode) => {
                const cardPalette = getNightDropPalette(episode.episode_number);
                return (
                <div key={episode.id} style={{padding:'0',background:episode.id === featured?.id ? 'linear-gradient(135deg,rgba(42,56,78,0.52),rgba(28,36,51,0.68))' : 'rgba(255,255,255,0.04)',border:`1px solid ${episode.id === featured?.id ? 'rgba(241,198,109,0.18)' : 'rgba(188,203,230,0.12)'}`,borderRadius:18,overflow:'hidden'}}>
                  <div style={{minHeight:118,background:`radial-gradient(circle at 78% 18%, ${cardPalette.glow} 0%, transparent 28%), linear-gradient(${episode.art_gradient || '135deg,#1a2130,#39475d'})`,position:'relative',padding:'14px 14px 16px'}}>
                    <div style={{position:'absolute',inset:0,background:'linear-gradient(180deg,rgba(255,255,255,0.02),transparent 34%,rgba(0,0,0,0.46) 100%)'}} />
                    <div style={{position:'relative',zIndex:1,display:'flex',justifyContent:'space-between',gap:12,alignItems:'flex-start',marginBottom:10}}>
                      <div style={{fontSize:13,fontWeight:800,color:C.white}}>Episode {episode.episode_number}</div>
                      <div style={{display:'grid',justifyItems:'end',gap:4}}>
                        <div style={{fontSize:10,fontWeight:800,letterSpacing:1.2,textTransform:'uppercase',color:episode.status === 'voting_open' ? '#f3dfb4' : 'rgba(255,255,255,0.72)'}}>{episode.status}</div>
                        <div style={{fontSize:10,fontWeight:800,letterSpacing:1.6,textTransform:'uppercase',color:'#f4e2bc'}}>{cardPalette.stamp}</div>
                      </div>
                    </div>
                    <div style={{position:'relative',zIndex:1,fontSize:22,fontWeight:900,color:C.white,lineHeight:0.94,maxWidth:180}}>
                      {episode.title}
                    </div>
                  </div>
                  <div style={{padding:'14px 14px 15px'}}>
                    <div style={{fontSize:12,color:'#f3dfb4',lineHeight:1.55,marginBottom:6}}>{episode.hook || 'The next beat is already building.'}</div>
                    <div style={{fontSize:12,color:C.grey2,lineHeight:1.6}}>{episode.synopsis}</div>
                  </div>
                </div>
              )})}
            </div>
          </div>

          <div style={{background:'linear-gradient(180deg,rgba(18,24,34,0.95),rgba(12,18,26,0.96))',border:'1px solid rgba(188,203,230,0.12)',borderRadius:28,padding:'24px 22px',boxShadow:'0 18px 50px rgba(0,0,0,0.2)'}}>
            <div style={{fontSize:12,fontWeight:800,letterSpacing:1.6,textTransform:'uppercase',color:'#f3dfb4',marginBottom:12}}>Why viewers come back</div>
            <div style={{display:'grid',gap:10}}>
              {[
                'A fresh chapter drops nightly with a new decision point.',
                'The audience can directly shape which path wins next.',
                'NightDrop keeps the tension moving instead of waiting a week.',
              ].map((line) => (
                <div key={line} style={{padding:'12px 14px',background:'rgba(255,255,255,0.035)',border:'1px solid rgba(188,203,230,0.1)',borderRadius:16,fontSize:13,color:C.grey2,lineHeight:1.65}}>
                  {line}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function NightDropAdminScreen({ onBack, setToast, onOpenPublic }) {
  const [episodes, setEpisodes] = useState(NIGHTDROP_DEMO_EPISODES);
  const [votes, setVotes] = useState([]);
  const [saving, setSaving] = useState(false);
  const [runningAction, setRunningAction] = useState('');
  const [activeModule, setActiveModule] = useState(1);
  const [selectedEpisodeNumber, setSelectedEpisodeNumber] = useState(1);
  const [previousVoteWinner, setPreviousVoteWinner] = useState('A');
  const [voteContext, setVoteContext] = useState('');
  const [generatedEpisode, setGeneratedEpisode] = useState(null);
  const [automationSettings, setAutomationSettings] = useState({
    workflow_key: 'nightdrop',
    auto_open_vote: false,
    auto_close_vote: false,
    auto_generate_next_script: false,
    auto_publish_replay: false,
    nightly_drop_time: '20:00',
    vote_close_time: '10:00',
  });
  const [automationRuns, setAutomationRuns] = useState([]);
  const [automationLogs, setAutomationLogs] = useState([]);
  const [actionLog, setActionLog] = useState([
    { id:1, tone:'info', message:'NightDrop console initialized.' },
    { id:2, tone:'success', message:'Public NightDrop experience is connected to the console.' },
  ]);
  const [form, setForm] = useState({
    episode_number: '',
    title: '',
    synopsis: '',
    vote_option_a: '',
    vote_option_b: '',
    vote_closes_at: '',
    publish_at: '',
    status: 'planned',
  });

  const loadAdmin = async () => {
    const [episodeRes, votesRes, settingsRes, runsRes, logsRes] = await Promise.all([
      supabase.from('nightdrop_episodes').select('*').order('episode_number', { ascending: true }),
      supabase.from('nightdrop_votes').select('episode_id,choice,viewer_id,created_at'),
      supabase.from('nightdrop_automation_settings').select('*').eq('workflow_key', 'nightdrop').maybeSingle(),
      supabase.from('nightdrop_automation_runs').select('*').eq('workflow_key', 'nightdrop').order('scheduled_for', { ascending: true }).limit(8),
      supabase.from('nightdrop_automation_logs').select('*').eq('workflow_key', 'nightdrop').order('created_at', { ascending: false }).limit(10),
    ]);
    if (episodeRes.data && episodeRes.data.length > 0) setEpisodes(episodeRes.data);
    if (votesRes.data) setVotes(votesRes.data);
    if (!settingsRes.error && settingsRes.data) setAutomationSettings((prev) => ({ ...prev, ...settingsRes.data }));
    if (!runsRes.error && runsRes.data) setAutomationRuns(runsRes.data);
    if (!logsRes.error && logsRes.data) setAutomationLogs(logsRes.data);
  };

  useEffect(() => {
    loadAdmin();
  }, []);

  const saveEpisode = async () => {
    if (!form.episode_number || !form.title.trim() || !form.vote_option_a.trim() || !form.vote_option_b.trim()) {
      setToast?.({ message: 'Add episode number, title and both vote options.', type: 'error' });
      return;
    }
    setSaving(true);
    const payload = {
      episode_number: Number(form.episode_number),
      title: form.title.trim(),
      synopsis: form.synopsis.trim() || null,
      vote_option_a: form.vote_option_a.trim(),
      vote_option_b: form.vote_option_b.trim(),
      vote_closes_at: form.vote_closes_at ? new Date(form.vote_closes_at).toISOString() : null,
      publish_at: form.publish_at ? new Date(form.publish_at).toISOString() : null,
      status: form.status,
    };
    const { error } = await supabase.from('nightdrop_episodes').upsert(payload, { onConflict: 'episode_number' });
    if (error) {
      setToast?.({ message: 'We could not save the NightDrop episode yet.', type: 'error' });
      setSaving(false);
      return;
    }
    setToast?.({ message: `NightDrop episode ${payload.episode_number} saved.`, type: 'success' });
    setForm({
      episode_number: '',
      title: '',
      synopsis: '',
      vote_option_a: '',
      vote_option_b: '',
      vote_closes_at: '',
      publish_at: '',
      status: 'planned',
    });
    setSaving(false);
    loadAdmin();
  };

  const logAction = (message, tone = 'info') => {
    setActionLog((prev) => [
      { id: Date.now() + Math.random(), tone, message },
      ...prev,
    ].slice(0, 8));
  };

  const persistAutomationLog = async (message, tone = 'info', actionType = null) => {
    const payload = {
      workflow_key: 'nightdrop',
      level: tone,
      action_type: actionType,
      message,
    };
    const { error } = await supabase.from('nightdrop_automation_logs').insert(payload);
    if (!error) {
      setAutomationLogs((prev) => [{ ...payload, id: Date.now() + Math.random(), created_at: new Date().toISOString() }, ...prev].slice(0, 10));
    }
  };

  const queueAutomationRun = async (actionType, payload = {}, successMessage = '') => {
    const runPayload = {
      workflow_key: 'nightdrop',
      action_type: actionType,
      episode_number: selectedEpisode?.episode_number || null,
      payload,
      status: 'queued',
      scheduled_for: new Date().toISOString(),
    };
    const { error, data } = await supabase.from('nightdrop_automation_runs').insert(runPayload).select('*').single();
    if (!error && data) {
      setAutomationRuns((prev) => [data, ...prev].slice(0, 8));
      await persistAutomationLog(successMessage || `${actionType} queued.`, 'info', actionType);
      return true;
    }
    return false;
  };

  const groupedVotes = episodes.map((episode) => {
    const episodeVotes = votes.filter((row) => row.episode_id === episode.id);
    const countA = episodeVotes.filter((row) => row.choice === 'A').length;
    const countB = episodeVotes.filter((row) => row.choice === 'B').length;
    return { ...episode, countA, countB, total: countA + countB };
  });

  const selectedEpisode = episodes.find((episode) => episode.episode_number === selectedEpisodeNumber) || episodes[0];
  const selectedEpisodeVotes = groupedVotes.find((episode) => episode.episode_number === selectedEpisodeNumber) || selectedEpisode;
  const selectedTotalVotes = selectedEpisodeVotes?.total || 0;
  const selectedVotePctA = selectedTotalVotes > 0 ? Math.round(((selectedEpisodeVotes?.countA || 0) / selectedTotalVotes) * 100) : 50;
  const selectedVotePctB = selectedTotalVotes > 0 ? Math.round(((selectedEpisodeVotes?.countB || 0) / selectedTotalVotes) * 100) : 50;
  const selectedPalette = getNightDropPalette(selectedEpisodeNumber);

  const generateEpisodeDraft = () => {
    const basis = selectedEpisode || NIGHTDROP_DEMO_EPISODES[0];
    const nextEpisodeNumber = (basis?.episode_number || 1) + 1;
    const nextTitle = nextEpisodeNumber === 2 ? 'The Soft Launch' : nextEpisodeNumber === 3 ? 'After the Vote' : `Episode ${nextEpisodeNumber}`;
    const winningPath = previousVoteWinner === 'A' ? basis?.vote_option_a : basis?.vote_option_b;

    setGeneratedEpisode({
      episode: nextEpisodeNumber,
      title: nextTitle,
      totalDuration: '8 scenes · 12 minutes',
      openingBeat: `${winningPath || 'The audience winner'} becomes the first scene trigger. The fallout moves quickly before sunrise.`,
      scenes: [
        { number: 1, title: 'Cold Open', duration: '01:20', summary: 'Night city visuals, a phone lights up, and the consequence of the winning vote lands immediately.' },
        { number: 2, title: 'Power Shift', duration: '01:45', summary: 'The key alliance changes once the evidence or confrontation reaches the room.' },
        { number: 3, title: 'Public Pressure', duration: '01:30', summary: 'A second character tries to contain the damage while the audience expectation sharpens the stakes.' },
        { number: 4, title: 'Decision Point', duration: '02:00', summary: 'Someone has to choose between reputation, money, and loyalty before the next reveal.' },
      ],
      nextVoteQuestion: 'Who should control the story tomorrow night?',
      nextVoteOptionA: 'Let the secret leak to the podcast first',
      nextVoteOptionB: 'Force a face-to-face confrontation before dawn',
      costEstimate: { script: 22, visuals: 96, QC: 18, total: 136 },
      directorNote: voteContext || 'Keep the emotional center on status, pressure, and betrayal rather than procedural detail.',
    });
    setToast?.({ message: `Episode ${nextEpisodeNumber} draft generated for NightDrop.`, type: 'success' });
    logAction(`Draft generated for Episode ${nextEpisodeNumber} from winner ${previousVoteWinner}.`, 'success');
  };

  const loadSelectedEpisodeIntoForm = () => {
    if (!selectedEpisode) return;
    const localDate = (value) => {
      if (!value) return '';
      const date = new Date(value);
      const pad = (n) => String(n).padStart(2, '0');
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
    };
    setForm({
      episode_number: String(selectedEpisode.episode_number || ''),
      title: selectedEpisode.title || '',
      synopsis: selectedEpisode.synopsis || '',
      vote_option_a: selectedEpisode.vote_option_a || '',
      vote_option_b: selectedEpisode.vote_option_b || '',
      vote_closes_at: localDate(selectedEpisode.vote_closes_at),
      publish_at: localDate(selectedEpisode.publish_at),
      status: selectedEpisode.status || 'planned',
    });
    logAction(`Episode ${selectedEpisode.episode_number} loaded into the setup form.`, 'info');
  };

  const applyGeneratedDraftToForm = () => {
    if (!generatedEpisode) return;
    const tomorrowAtTen = new Date(Date.now() + 1000 * 60 * 60 * 18);
    const tomorrowAtEight = new Date(Date.now() + 1000 * 60 * 60 * 32);
    const pad = (n) => String(n).padStart(2, '0');
    const formatLocal = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
    setForm({
      episode_number: String(generatedEpisode.episode),
      title: generatedEpisode.title,
      synopsis: generatedEpisode.openingBeat,
      vote_option_a: generatedEpisode.nextVoteOptionA,
      vote_option_b: generatedEpisode.nextVoteOptionB,
      vote_closes_at: formatLocal(tomorrowAtTen),
      publish_at: formatLocal(tomorrowAtEight),
      status: 'scheduled',
    });
    logAction(`Generated draft pushed into Episode ${generatedEpisode.episode} setup.`, 'success');
    setToast?.({ message: `Episode ${generatedEpisode.episode} draft moved into setup.`, type: 'success' });
  };

  const updateSelectedEpisodeStatus = async (nextStatus, overrides = {}, successMessage = '') => {
    if (!selectedEpisode?.episode_number) {
      setToast?.({ message: 'Select a NightDrop episode first.', type: 'error' });
      return;
    }
    setRunningAction(nextStatus);
    const payload = {
      episode_number: selectedEpisode.episode_number,
      title: selectedEpisode.title,
      synopsis: selectedEpisode.synopsis || null,
      vote_option_a: selectedEpisode.vote_option_a,
      vote_option_b: selectedEpisode.vote_option_b,
      vote_closes_at: selectedEpisode.vote_closes_at || null,
      publish_at: selectedEpisode.publish_at || null,
      status: nextStatus,
      ...overrides,
    };
    const { error } = await supabase.from('nightdrop_episodes').upsert(payload, { onConflict: 'episode_number' });
    if (error) {
      setToast?.({ message: 'NightDrop automation action failed to save.', type: 'error' });
      setRunningAction('');
      return;
    }
    await loadAdmin();
    logAction(successMessage || `Episode ${selectedEpisode.episode_number} moved to ${nextStatus}.`, 'success');
    await queueAutomationRun(`set_${nextStatus}`, { episode_number: selectedEpisode.episode_number, next_status: nextStatus }, successMessage || `Episode ${selectedEpisode.episode_number} moved to ${nextStatus}.`);
    setToast?.({ message: successMessage || `Episode ${selectedEpisode.episode_number} updated.`, type: 'success' });
    setRunningAction('');
  };

  const simulateVoteTraffic = () => {
    logAction('Vote simulation triggered for the selected episode.', 'info');
    setToast?.({ message: 'Vote simulation is a console-only preview right now.', type: 'success' });
  };

  const saveAutomationSettings = async () => {
    setRunningAction('save_automation');
    const payload = {
      ...automationSettings,
      workflow_key: 'nightdrop',
    };
    const { error } = await supabase.from('nightdrop_automation_settings').upsert(payload, { onConflict: 'workflow_key' });
    if (error) {
      setToast?.({ message: 'NightDrop automation settings could not be saved yet.', type: 'error' });
      setRunningAction('');
      return;
    }
    logAction('NightDrop automation settings saved.', 'success');
    await persistAutomationLog('NightDrop automation settings updated from the admin console.', 'success', 'update_settings');
    setToast?.({ message: 'NightDrop automation settings saved.', type: 'success' });
    setRunningAction('');
  };

  const deploymentSteps = [
    { time: '17:00', title: 'Episode package locked', body: 'Poster, synopsis, vote options and playback assets are approved inside the console.' },
    { time: '19:55', title: 'Launch alert goes out', body: 'Push, social and homepage placement are switched on five minutes before the nightly drop.' },
    { time: '20:00', title: 'Episode goes live', body: 'NightDrop opens to viewers and the voting state is primed for the next turn.' },
    { time: '00:00', title: 'Free preview closes', body: 'The open preview window ends and the next audience conversion moment begins.' },
    { time: '10:00', title: 'Voting closes', body: 'The winning path locks and becomes the script input for the next episode generation run.' },
  ];

  const pipelineStages = [
    { label: 'Story trigger', state: previousVoteWinner === 'A' ? 'Option A carried forward' : 'Option B carried forward', tone: '#f3dfb4' },
    { label: 'Script draft', state: generatedEpisode ? 'Ready for review' : 'Waiting for generator', tone: generatedEpisode ? '#7fdc8a' : C.grey2 },
    { label: 'Scene packaging', state: generatedEpisode ? 'Episode beats mapped' : 'Not started', tone: generatedEpisode ? '#7fdc8a' : C.grey2 },
    { label: 'Viewer deployment', state: selectedEpisode?.status === 'voting_open' ? 'Live now' : selectedEpisode?.status || 'Planned', tone: selectedEpisode?.status === 'voting_open' ? '#f3dfb4' : C.grey2 },
  ];

  const field = {
    width:'100%',
    padding:'14px 16px',
    background:'rgba(255,255,255,0.04)',
    border:`1px solid ${C.border}`,
    borderRadius:16,
    fontSize:14,
    color:C.white,
    fontFamily:'inherit',
    boxSizing:'border-box',
  };

  return (
    <div style={{background:'radial-gradient(circle at 16% 0%, rgba(241,198,109,0.12) 0%, transparent 18%), radial-gradient(circle at 82% 10%, rgba(75,163,255,0.14) 0%, transparent 24%), linear-gradient(180deg,#06070b 0%,#0d1118 42%,#141a24 100%)',minHeight:'100vh',paddingTop:92}}>
      <div style={{padding:'0 4% 100px'}}>
        <div style={{display:'flex',justifyContent:'space-between',gap:16,alignItems:'center',marginBottom:24,flexWrap:'wrap'}}>
          <div>
            <div style={{fontSize:12,fontWeight:800,letterSpacing:2.2,textTransform:'uppercase',color:'#f3dfb4',marginBottom:8}}>NightDrop Admin</div>
            <div style={{fontFamily:'Arial',fontSize:'clamp(34px,4vw,58px)',fontWeight:900,color:C.white,lineHeight:0.96,letterSpacing:-1.2,marginBottom:8}}>Run the daily drop from one console.</div>
            <div style={{fontSize:14,color:C.grey2,lineHeight:1.7,maxWidth:760}}>Manage episode metadata, voting options and the next public-facing beats for NightDrop inside VAULTT.</div>
          </div>
          <div style={{display:'flex',gap:10,flexWrap:'wrap'}}>
            <button onClick={onBack} style={{padding:'12px 18px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:999,color:C.white,cursor:'pointer',fontFamily:'inherit',fontSize:13,fontWeight:800}}>Back</button>
            <button onClick={onOpenPublic} style={{padding:'12px 18px',background:'linear-gradient(135deg,#66b2ff,#2f8fff)',border:'none',borderRadius:999,color:C.white,cursor:'pointer',fontFamily:'inherit',fontSize:13,fontWeight:800}}>Open public NightDrop</button>
          </div>
        </div>

        <div style={{display:'flex',gap:0,overflowX:'auto',padding:'0 0 10px',marginBottom:20,borderBottom:`1px solid ${C.border}`}}>
          {[
            { id:1, label:'Script Generator' },
            { id:2, label:'Vote UI & Expiry' },
            { id:3, label:'Production Pipeline' },
            { id:4, label:'Deployment Guide' },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveModule(tab.id)}
              style={{
                padding:'14px 18px',
                background:'transparent',
                border:'none',
                borderBottom:activeModule === tab.id ? '2px solid #f3dfb4' : '2px solid transparent',
                color:activeModule === tab.id ? '#f3dfb4' : C.grey,
                fontSize:11,
                fontWeight:800,
                letterSpacing:1.9,
                textTransform:'uppercase',
                cursor:'pointer',
                fontFamily:'inherit',
                whiteSpace:'nowrap',
              }}
            >
              <span style={{display:'inline-flex',minWidth:24,justifyContent:'center',padding:'2px 6px',marginRight:10,borderRadius:999,background:activeModule === tab.id ? '#f3dfb4' : 'rgba(255,255,255,0.06)',color:activeModule === tab.id ? '#0a0d13' : C.grey2}}>
                0{tab.id}
              </span>
              {tab.label}
            </button>
          ))}
        </div>

        {activeModule === 1 && (
          <div style={{display:'grid',gridTemplateColumns:'minmax(320px,0.78fr) minmax(0,1.22fr)',gap:18}} className='watch-details-grid'>
            <div style={{background:'linear-gradient(180deg,rgba(20,26,36,0.94),rgba(14,20,28,0.94))',border:`1px solid ${C.border}`,borderRadius:28,padding:'24px 22px',boxShadow:'0 18px 50px rgba(0,0,0,0.22)'}}>
              <div style={{fontSize:12,fontWeight:800,letterSpacing:1.7,textTransform:'uppercase',color:C.blue,marginBottom:10}}>Production brief</div>
              <div style={{display:'grid',gap:12}}>
                <select value={selectedEpisodeNumber} onChange={(e) => setSelectedEpisodeNumber(Number(e.target.value))} style={field}>
                  {episodes.map((episode) => (
                    <option key={episode.id} value={episode.episode_number}>Episode {episode.episode_number} — {episode.title}</option>
                  ))}
                </select>
                <button onClick={loadSelectedEpisodeIntoForm} style={{padding:'12px 16px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:16,color:C.white,cursor:'pointer',fontFamily:'inherit',fontSize:13,fontWeight:800}}>
                  Load selected episode into setup
                </button>
                <div style={{display:'grid',gridTemplateColumns:'repeat(2,minmax(0,1fr))',gap:12}}>
                  <button onClick={() => setPreviousVoteWinner('A')} style={{padding:'14px 16px',background:previousVoteWinner === 'A' ? 'rgba(241,198,109,0.14)' : 'rgba(255,255,255,0.04)',border:previousVoteWinner === 'A' ? '1px solid rgba(241,198,109,0.28)' : `1px solid ${C.border}`,borderRadius:16,color:C.white,fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'inherit',textAlign:'left'}}>
                    <div style={{fontSize:10,letterSpacing:1.2,textTransform:'uppercase',color:'#f3dfb4',marginBottom:4}}>Winner A</div>
                    {selectedEpisode?.vote_option_a}
                  </button>
                  <button onClick={() => setPreviousVoteWinner('B')} style={{padding:'14px 16px',background:previousVoteWinner === 'B' ? 'rgba(241,198,109,0.14)' : 'rgba(255,255,255,0.04)',border:previousVoteWinner === 'B' ? '1px solid rgba(241,198,109,0.28)' : `1px solid ${C.border}`,borderRadius:16,color:C.white,fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'inherit',textAlign:'left'}}>
                    <div style={{fontSize:10,letterSpacing:1.2,textTransform:'uppercase',color:'#f3dfb4',marginBottom:4}}>Winner B</div>
                    {selectedEpisode?.vote_option_b}
                  </button>
                </div>
                <textarea value={voteContext} onChange={(e) => setVoteContext(e.target.value)} placeholder='Where did the previous episode leave off?' rows={5} style={{...field, resize:'vertical'}} />
                <button onClick={generateEpisodeDraft} style={{padding:'14px 18px',background:'linear-gradient(135deg,#f1c66d,#d6a648)',border:'none',borderRadius:16,color:'#0c1118',cursor:'pointer',fontFamily:'inherit',fontSize:14,fontWeight:800,boxShadow:'0 16px 32px rgba(214,166,72,0.2)'}}>
                  Generate next episode draft
                </button>

                <div style={{height:1,background:C.border,margin:'6px 0'}} />
                <div style={{fontSize:12,fontWeight:800,letterSpacing:1.7,textTransform:'uppercase',color:'#f3dfb4',marginBottom:2}}>Episode setup</div>
                <div style={{display:'grid',gap:12}}>
                  <div style={{display:'grid',gridTemplateColumns:'minmax(0,0.45fr) minmax(0,1fr)',gap:12}}>
                    <input value={form.episode_number} onChange={(e) => setForm((prev) => ({ ...prev, episode_number: e.target.value }))} placeholder='1' type='number' min='1' style={field} />
                    <input value={form.title} onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))} placeholder='Episode title' style={field} />
                  </div>
                  <textarea value={form.synopsis} onChange={(e) => setForm((prev) => ({ ...prev, synopsis: e.target.value }))} placeholder='Short synopsis for the episode card and vote page.' rows={4} style={{...field, resize:'vertical'}} />
                  <input value={form.vote_option_a} onChange={(e) => setForm((prev) => ({ ...prev, vote_option_a: e.target.value }))} placeholder='Vote option A' style={field} />
                  <input value={form.vote_option_b} onChange={(e) => setForm((prev) => ({ ...prev, vote_option_b: e.target.value }))} placeholder='Vote option B' style={field} />
                  <div style={{display:'grid',gridTemplateColumns:'minmax(0,1fr) minmax(0,1fr)',gap:12}}>
                    <input value={form.publish_at} onChange={(e) => setForm((prev) => ({ ...prev, publish_at: e.target.value }))} type='datetime-local' style={field} />
                    <input value={form.vote_closes_at} onChange={(e) => setForm((prev) => ({ ...prev, vote_closes_at: e.target.value }))} type='datetime-local' style={field} />
                  </div>
                  <select value={form.status} onChange={(e) => setForm((prev) => ({ ...prev, status: e.target.value }))} style={field}>
                    <option value='planned'>planned</option>
                    <option value='scheduled'>scheduled</option>
                    <option value='voting_open'>voting_open</option>
                    <option value='closed'>closed</option>
                    <option value='published'>published</option>
                  </select>
                  <button onClick={saveEpisode} disabled={saving} style={{padding:'14px 18px',background:'linear-gradient(135deg,#66b2ff,#2f8fff)',border:'none',borderRadius:16,color:C.white,cursor:saving?'not-allowed':'pointer',fontFamily:'inherit',fontSize:14,fontWeight:800,boxShadow:'0 16px 32px rgba(75,163,255,0.2)'}}>
                    {saving ? 'Saving...' : 'Save NightDrop episode'}
                  </button>
                </div>
              </div>
            </div>

            <div style={{display:'grid',gap:16}}>
              <div style={{background:'linear-gradient(180deg,rgba(20,26,36,0.94),rgba(14,20,28,0.94))',border:`1px solid ${C.border}`,borderRadius:28,padding:'24px 22px',boxShadow:'0 18px 50px rgba(0,0,0,0.22)'}}>
                <div style={{fontSize:12,fontWeight:800,letterSpacing:1.7,textTransform:'uppercase',color:'#f3dfb4',marginBottom:10}}>Generated episode</div>
                {generatedEpisode ? (
                  <div style={{display:'grid',gap:14}}>
                    <div style={{padding:'16px 18px',background:'rgba(241,198,109,0.06)',border:'1px solid rgba(241,198,109,0.18)',borderRadius:18}}>
                    <div style={{fontSize:11,fontWeight:800,letterSpacing:1.4,textTransform:'uppercase',color:'#f3dfb4',marginBottom:6}}>Episode {generatedEpisode.episode} · {generatedEpisode.totalDuration}</div>
                      <div style={{fontSize:28,fontWeight:900,color:C.white,lineHeight:1.02,marginBottom:8}}>{generatedEpisode.title}</div>
                      <div style={{fontSize:14,color:C.grey2,lineHeight:1.7}}>{generatedEpisode.openingBeat}</div>
                    </div>
                    <button onClick={applyGeneratedDraftToForm} style={{padding:'12px 16px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:16,color:C.white,cursor:'pointer',fontFamily:'inherit',fontSize:13,fontWeight:800}}>
                      Push this draft into episode setup
                    </button>
                    {generatedEpisode.scenes.map((scene) => (
                      <div key={scene.number} style={{padding:'14px 16px',background:'rgba(255,255,255,0.04)',border:`1px solid ${C.border}`,borderRadius:16}}>
                        <div style={{display:'flex',justifyContent:'space-between',gap:12,alignItems:'center',marginBottom:6}}>
                          <div style={{fontSize:14,fontWeight:800,color:C.white}}>Scene {scene.number}: {scene.title}</div>
                          <div style={{fontSize:11,color:'#f3dfb4'}}>{scene.duration}</div>
                        </div>
                        <div style={{fontSize:13,color:C.grey2,lineHeight:1.65}}>{scene.summary}</div>
                      </div>
                    ))}
                    <div style={{padding:'16px 18px',background:'rgba(255,255,255,0.03)',border:`1px solid ${C.border}`,borderRadius:18}}>
                      <div style={{fontSize:11,fontWeight:800,letterSpacing:1.4,textTransform:'uppercase',color:C.blue,marginBottom:8}}>Tomorrow’s vote prompt</div>
                      <div style={{fontSize:16,fontWeight:700,color:C.white,marginBottom:10}}>{generatedEpisode.nextVoteQuestion}</div>
                      <div style={{display:'grid',gap:8}}>
                        <div style={{padding:'11px 12px',background:'rgba(255,255,255,0.03)',border:`1px solid ${C.border}`,borderRadius:14,fontSize:13,color:C.white}}><strong style={{color:'#f3dfb4'}}>A</strong> {generatedEpisode.nextVoteOptionA}</div>
                        <div style={{padding:'11px 12px',background:'rgba(255,255,255,0.03)',border:`1px solid ${C.border}`,borderRadius:14,fontSize:13,color:C.white}}><strong style={{color:'#f3dfb4'}}>B</strong> {generatedEpisode.nextVoteOptionB}</div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div style={{padding:'52px 20px',textAlign:'center',color:C.grey2,fontStyle:'italic'}}>Generate the next NightDrop episode draft from the winning vote context.</div>
                )}
              </div>
            </div>
          </div>
        )}

        {activeModule === 2 && (
          <div style={{display:'grid',gridTemplateColumns:'minmax(320px,0.76fr) minmax(0,1.24fr)',gap:18}} className='watch-details-grid'>
            <div style={{background:'linear-gradient(180deg,rgba(20,26,36,0.94),rgba(14,20,28,0.94))',border:`1px solid ${C.border}`,borderRadius:28,padding:'24px 22px'}}>
              <div style={{fontSize:12,fontWeight:800,letterSpacing:1.7,textTransform:'uppercase',color:C.blue,marginBottom:10}}>Vote preview states</div>
              <div style={{display:'grid',gap:12}}>
                <div style={{padding:'16px 18px',background:'linear-gradient(135deg,rgba(31,39,55,0.92),rgba(20,26,36,0.96))',border:`1px solid ${C.border}`,borderRadius:20}}>
                  <div style={{fontSize:11,fontWeight:800,letterSpacing:1.4,textTransform:'uppercase',color:'#f3dfb4',marginBottom:8}}>Voting open</div>
                  <div style={{fontSize:15,color:C.white,lineHeight:1.65,marginBottom:12}}>{selectedEpisode?.vote_option_a}</div>
                  <div style={{display:'grid',gap:8}}>
                    <button style={{padding:'12px 14px',background:'rgba(241,198,109,0.14)',border:'1px solid rgba(241,198,109,0.22)',borderRadius:14,color:'#f4e2bc',fontWeight:700,fontFamily:'inherit',textAlign:'left'}}>A · {selectedEpisode?.vote_option_a}</button>
                    <button style={{padding:'12px 14px',background:'rgba(255,255,255,0.04)',border:`1px solid ${C.border}`,borderRadius:14,color:C.white,fontWeight:700,fontFamily:'inherit',textAlign:'left'}}>B · {selectedEpisode?.vote_option_b}</button>
                  </div>
                </div>
                <div style={{padding:'16px 18px',background:'rgba(255,255,255,0.03)',border:`1px solid ${C.border}`,borderRadius:20}}>
                  <div style={{fontSize:11,fontWeight:800,letterSpacing:1.4,textTransform:'uppercase',color:C.blue,marginBottom:8}}>Vote closed</div>
                  <div style={{fontSize:14,color:C.grey2,lineHeight:1.65}}>Votes are in. The winner is now carried into the next script run and the episode replay remains available.</div>
                </div>
                <div style={{padding:'16px 18px',background:'rgba(255,255,255,0.03)',border:`1px solid ${C.border}`,borderRadius:20}}>
                  <div style={{fontSize:11,fontWeight:800,letterSpacing:1.4,textTransform:'uppercase',color:C.blue,marginBottom:8}}>Access handoff</div>
                  <div style={{fontSize:14,color:C.grey2,lineHeight:1.65}}>Viewer memberships and future premium layers will plug into this flow once PayFast is switched on for NightDrop access.</div>
                </div>
                <div style={{display:'flex',gap:10,flexWrap:'wrap'}}>
                  <button onClick={simulateVoteTraffic} style={{padding:'12px 16px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:16,color:C.white,cursor:'pointer',fontFamily:'inherit',fontSize:13,fontWeight:800}}>Simulate vote traffic</button>
                  <button onClick={() => updateSelectedEpisodeStatus('closed', {}, `Voting closed for Episode ${selectedEpisode?.episode_number}.`)} disabled={runningAction === 'closed'} style={{padding:'12px 16px',background:'rgba(241,198,109,0.1)',border:'1px solid rgba(241,198,109,0.18)',borderRadius:16,color:'#f3dfb4',cursor:'pointer',fontFamily:'inherit',fontSize:13,fontWeight:800}}>
                    {runningAction === 'closed' ? 'Closing...' : 'Close vote now'}
                  </button>
                </div>
              </div>
            </div>
            <div style={{display:'grid',gap:16}}>
              <div style={{background:'linear-gradient(180deg,rgba(20,26,36,0.94),rgba(14,20,28,0.94))',border:`1px solid ${C.border}`,borderRadius:28,padding:'24px 22px'}}>
                <div style={{fontSize:12,fontWeight:800,letterSpacing:1.7,textTransform:'uppercase',color:'#f3dfb4',marginBottom:10}}>Vote tabulation dashboard</div>
                <div style={{display:'grid',gridTemplateColumns:'repeat(4,minmax(0,1fr))',gap:10,marginBottom:14}}>
                  <div style={{padding:'14px 14px',background:'rgba(255,255,255,0.03)',border:`1px solid ${C.border}`,borderRadius:16}}><div style={{fontSize:10,color:C.grey2,letterSpacing:1.2,textTransform:'uppercase'}}>Episode</div><div style={{fontSize:22,fontWeight:800,color:C.white}}>0{selectedEpisodeNumber}</div></div>
                  <div style={{padding:'14px 14px',background:'rgba(255,255,255,0.03)',border:`1px solid ${C.border}`,borderRadius:16}}><div style={{fontSize:10,color:C.grey2,letterSpacing:1.2,textTransform:'uppercase'}}>Total votes</div><div style={{fontSize:22,fontWeight:800,color:C.white}}>{selectedTotalVotes}</div></div>
                  <div style={{padding:'14px 14px',background:'rgba(255,255,255,0.03)',border:`1px solid ${C.border}`,borderRadius:16}}><div style={{fontSize:10,color:C.grey2,letterSpacing:1.2,textTransform:'uppercase'}}>A share</div><div style={{fontSize:22,fontWeight:800,color:'#f3dfb4'}}>{selectedVotePctA}%</div></div>
                  <div style={{padding:'14px 14px',background:'rgba(255,255,255,0.03)',border:`1px solid ${C.border}`,borderRadius:16}}><div style={{fontSize:10,color:C.grey2,letterSpacing:1.2,textTransform:'uppercase'}}>B share</div><div style={{fontSize:22,fontWeight:800,color:C.blue}}>{selectedVotePctB}%</div></div>
                </div>
                <div style={{display:'grid',gap:12}}>
                  <div style={{padding:'16px 18px',background:'rgba(255,255,255,0.04)',border:`1px solid ${C.border}`,borderRadius:18}}>
                    <div style={{display:'flex',justifyContent:'space-between',gap:12,marginBottom:8}}>
                      <div style={{fontSize:12,fontWeight:800,letterSpacing:1.4,textTransform:'uppercase',color:'#f3dfb4'}}>Option A</div>
                      <div style={{fontSize:12,color:C.grey2}}>{selectedEpisodeVotes?.countA || 0} votes</div>
                    </div>
                    <div style={{fontSize:15,fontWeight:700,color:C.white,marginBottom:10}}>{selectedEpisode?.vote_option_a}</div>
                    <div style={{height:10,background:'rgba(255,255,255,0.05)',borderRadius:999,overflow:'hidden'}}><div style={{height:'100%',width:`${selectedVotePctA}%`,background:'linear-gradient(135deg,#f1c66d,#d7a53f)'}} /></div>
                  </div>
                  <div style={{padding:'16px 18px',background:'rgba(255,255,255,0.04)',border:`1px solid ${C.border}`,borderRadius:18}}>
                    <div style={{display:'flex',justifyContent:'space-between',gap:12,marginBottom:8}}>
                      <div style={{fontSize:12,fontWeight:800,letterSpacing:1.4,textTransform:'uppercase',color:C.blue}}>Option B</div>
                      <div style={{fontSize:12,color:C.grey2}}>{selectedEpisodeVotes?.countB || 0} votes</div>
                    </div>
                    <div style={{fontSize:15,fontWeight:700,color:C.white,marginBottom:10}}>{selectedEpisode?.vote_option_b}</div>
                    <div style={{height:10,background:'rgba(255,255,255,0.05)',borderRadius:999,overflow:'hidden'}}><div style={{height:'100%',width:`${selectedVotePctB}%`,background:'linear-gradient(135deg,#6fa9e8,#3d78c7)'}} /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeModule === 3 && (
          <div style={{display:'grid',gridTemplateColumns:'minmax(300px,0.72fr) minmax(0,1.28fr)',gap:18}} className='watch-details-grid'>
            <div style={{display:'grid',gap:16,alignSelf:'start'}}>
              <div style={{background:'linear-gradient(180deg,rgba(20,26,36,0.94),rgba(14,20,28,0.94))',border:`1px solid ${C.border}`,borderRadius:28,padding:'24px 22px'}}>
                <div style={{fontSize:12,fontWeight:800,letterSpacing:1.7,textTransform:'uppercase',color:C.blue,marginBottom:10}}>Pipeline status</div>
                <div style={{display:'grid',gap:12}}>
                  {pipelineStages.map((stage) => (
                    <div key={stage.label} style={{padding:'14px 16px',background:'rgba(255,255,255,0.04)',border:`1px solid ${C.border}`,borderRadius:18}}>
                      <div style={{fontSize:11,fontWeight:800,letterSpacing:1.4,textTransform:'uppercase',color:C.grey2,marginBottom:4}}>{stage.label}</div>
                      <div style={{fontSize:15,fontWeight:700,color:stage.tone}}>{stage.state}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div style={{background:'linear-gradient(180deg,rgba(20,26,36,0.94),rgba(14,20,28,0.94))',border:`1px solid ${C.border}`,borderRadius:28,padding:'24px 22px'}}>
                <div style={{fontSize:12,fontWeight:800,letterSpacing:1.7,textTransform:'uppercase',color:'#f3dfb4',marginBottom:10}}>Tonight’s cost</div>
                <div style={{display:'grid',gap:10}}>
                  {[
                    ['Script draft', 'R22'],
                    ['Visual packaging', 'R96'],
                    ['QA + deployment prep', 'R18'],
                    ['Total', 'R136'],
                  ].map(([label, value], index) => (
                    <div key={label} style={{display:'flex',justifyContent:'space-between',padding:'8px 0',borderTop:index === 3 ? '1px solid rgba(241,198,109,0.18)' : 'none',color:index === 3 ? '#f3dfb4' : C.grey2,fontWeight:index === 3 ? 800 : 500}}>
                      <span>{label}</span>
                      <span style={{color:index === 3 ? '#f3dfb4' : C.white}}>{value}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div style={{background:'linear-gradient(180deg,rgba(20,26,36,0.94),rgba(14,20,28,0.94))',border:`1px solid ${C.border}`,borderRadius:28,padding:'24px 22px'}}>
                <div style={{fontSize:12,fontWeight:800,letterSpacing:1.7,textTransform:'uppercase',color:C.blue,marginBottom:10}}>Operator actions</div>
                <div style={{display:'grid',gap:10}}>
                  <button onClick={() => updateSelectedEpisodeStatus('scheduled', { publish_at: new Date(Date.now() + 1000 * 60 * 60 * 2).toISOString() }, `Episode ${selectedEpisode?.episode_number} scheduled for tonight's drop.`)} disabled={runningAction === 'scheduled'} style={{padding:'12px 16px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:16,color:C.white,cursor:'pointer',fontFamily:'inherit',fontSize:13,fontWeight:800,textAlign:'left'}}>
                    {runningAction === 'scheduled' ? 'Scheduling...' : 'Schedule selected episode'}
                  </button>
                  <button onClick={() => updateSelectedEpisodeStatus('voting_open', { publish_at: selectedEpisode?.publish_at || new Date().toISOString() }, `Episode ${selectedEpisode?.episode_number} is now live and voting is open.`)} disabled={runningAction === 'voting_open'} style={{padding:'12px 16px',background:'rgba(241,198,109,0.1)',border:'1px solid rgba(241,198,109,0.18)',borderRadius:16,color:'#f3dfb4',cursor:'pointer',fontFamily:'inherit',fontSize:13,fontWeight:800,textAlign:'left'}}>
                    {runningAction === 'voting_open' ? 'Opening...' : 'Open voting on public NightDrop'}
                  </button>
                  <button onClick={() => updateSelectedEpisodeStatus('published', {}, `Episode ${selectedEpisode?.episode_number} marked as published and archived.`)} disabled={runningAction === 'published'} style={{padding:'12px 16px',background:'rgba(111,169,232,0.12)',border:'1px solid rgba(111,169,232,0.18)',borderRadius:16,color:'#8fc3ff',cursor:'pointer',fontFamily:'inherit',fontSize:13,fontWeight:800,textAlign:'left'}}>
                    {runningAction === 'published' ? 'Publishing...' : 'Mark replay/published'}
                  </button>
                </div>
              </div>
            </div>
            <div style={{background:'linear-gradient(180deg,rgba(20,26,36,0.94),rgba(14,20,28,0.94))',border:`1px solid ${C.border}`,borderRadius:28,padding:'24px 22px'}}>
              <div style={{fontSize:12,fontWeight:800,letterSpacing:1.7,textTransform:'uppercase',color:'#f3dfb4',marginBottom:10}}>Episode pipeline</div>
              <div style={{display:'grid',gap:12}}>
                {groupedVotes.map((episode) => (
                  <div key={episode.id} style={{padding:'16px 16px',background:'rgba(255,255,255,0.04)',border:`1px solid ${C.border}`,borderRadius:18}}>
                    <div style={{display:'flex',justifyContent:'space-between',gap:12,alignItems:'center',marginBottom:8,flexWrap:'wrap'}}>
                      <div style={{fontSize:18,fontWeight:800,color:C.white}}>Episode {episode.episode_number}: {episode.title}</div>
                      <div style={{fontSize:10,fontWeight:800,letterSpacing:1.2,textTransform:'uppercase',color:episode.status === 'voting_open' ? '#f3dfb4' : C.grey2}}>{episode.status}</div>
                    </div>
                    <div style={{fontSize:13,color:C.grey2,lineHeight:1.65,marginBottom:12}}>{episode.synopsis}</div>
                    <div style={{display:'grid',gridTemplateColumns:'repeat(3,minmax(0,1fr))',gap:10}}>
                      <div style={{padding:'12px 12px',background:'rgba(255,255,255,0.03)',border:`1px solid ${C.border}`,borderRadius:14}}>
                        <div style={{fontSize:10,letterSpacing:1.2,textTransform:'uppercase',color:C.grey2,marginBottom:4}}>Votes A</div>
                        <div style={{fontSize:20,fontWeight:800,color:C.white}}>{episode.countA}</div>
                      </div>
                      <div style={{padding:'12px 12px',background:'rgba(255,255,255,0.03)',border:`1px solid ${C.border}`,borderRadius:14}}>
                        <div style={{fontSize:10,letterSpacing:1.2,textTransform:'uppercase',color:C.grey2,marginBottom:4}}>Votes B</div>
                        <div style={{fontSize:20,fontWeight:800,color:C.white}}>{episode.countB}</div>
                      </div>
                      <div style={{padding:'12px 12px',background:'rgba(255,255,255,0.03)',border:`1px solid ${C.border}`,borderRadius:14}}>
                        <div style={{fontSize:10,letterSpacing:1.2,textTransform:'uppercase',color:C.grey2,marginBottom:4}}>Total</div>
                        <div style={{fontSize:20,fontWeight:800,color:C.white}}>{episode.total}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {activeModule === 4 && (
          <div style={{display:'grid',gridTemplateColumns:'minmax(300px,0.68fr) minmax(0,1.32fr)',gap:18}} className='watch-details-grid'>
            <div style={{background:'linear-gradient(180deg,rgba(20,26,36,0.94),rgba(14,20,28,0.94))',border:`1px solid ${C.border}`,borderRadius:28,padding:'24px 22px'}}>
              <div style={{fontSize:12,fontWeight:800,letterSpacing:1.7,textTransform:'uppercase',color:C.blue,marginBottom:10}}>Automation settings</div>
              <div style={{display:'grid',gap:12}}>
                <div style={{display:'grid',gridTemplateColumns:'repeat(2,minmax(0,1fr))',gap:12}}>
                  <label style={{padding:'14px 16px',background:'rgba(255,255,255,0.03)',border:`1px solid ${C.border}`,borderRadius:16,color:C.white,display:'flex',justifyContent:'space-between',gap:12,alignItems:'center'}}>
                    <span>Auto open vote</span>
                    <input type='checkbox' checked={!!automationSettings.auto_open_vote} onChange={(e) => setAutomationSettings((prev) => ({ ...prev, auto_open_vote: e.target.checked }))} />
                  </label>
                  <label style={{padding:'14px 16px',background:'rgba(255,255,255,0.03)',border:`1px solid ${C.border}`,borderRadius:16,color:C.white,display:'flex',justifyContent:'space-between',gap:12,alignItems:'center'}}>
                    <span>Auto close vote</span>
                    <input type='checkbox' checked={!!automationSettings.auto_close_vote} onChange={(e) => setAutomationSettings((prev) => ({ ...prev, auto_close_vote: e.target.checked }))} />
                  </label>
                  <label style={{padding:'14px 16px',background:'rgba(255,255,255,0.03)',border:`1px solid ${C.border}`,borderRadius:16,color:C.white,display:'flex',justifyContent:'space-between',gap:12,alignItems:'center'}}>
                    <span>Auto generate next script</span>
                    <input type='checkbox' checked={!!automationSettings.auto_generate_next_script} onChange={(e) => setAutomationSettings((prev) => ({ ...prev, auto_generate_next_script: e.target.checked }))} />
                  </label>
                  <label style={{padding:'14px 16px',background:'rgba(255,255,255,0.03)',border:`1px solid ${C.border}`,borderRadius:16,color:C.white,display:'flex',justifyContent:'space-between',gap:12,alignItems:'center'}}>
                    <span>Auto publish replay</span>
                    <input type='checkbox' checked={!!automationSettings.auto_publish_replay} onChange={(e) => setAutomationSettings((prev) => ({ ...prev, auto_publish_replay: e.target.checked }))} />
                  </label>
                </div>
                <div style={{display:'grid',gridTemplateColumns:'repeat(2,minmax(0,1fr))',gap:12}}>
                  <input value={automationSettings.nightly_drop_time || ''} onChange={(e) => setAutomationSettings((prev) => ({ ...prev, nightly_drop_time: e.target.value }))} type='time' style={field} />
                  <input value={automationSettings.vote_close_time || ''} onChange={(e) => setAutomationSettings((prev) => ({ ...prev, vote_close_time: e.target.value }))} type='time' style={field} />
                </div>
                <button onClick={saveAutomationSettings} disabled={runningAction === 'save_automation'} style={{padding:'14px 18px',background:'linear-gradient(135deg,#66b2ff,#2f8fff)',border:'none',borderRadius:16,color:C.white,cursor:'pointer',fontFamily:'inherit',fontSize:14,fontWeight:800}}>
                  {runningAction === 'save_automation' ? 'Saving...' : 'Save automation settings'}
                </button>
              </div>
            </div>
            <div style={{background:'linear-gradient(180deg,rgba(20,26,36,0.94),rgba(14,20,28,0.94))',border:`1px solid ${C.border}`,borderRadius:28,padding:'24px 22px'}}>
              <div style={{fontSize:12,fontWeight:800,letterSpacing:1.7,textTransform:'uppercase',color:'#f3dfb4',marginBottom:10}}>Deployment guide</div>
              <div style={{display:'grid',gap:12}}>
                {deploymentSteps.map((step) => (
                  <div key={step.time} style={{display:'grid',gridTemplateColumns:'90px minmax(0,1fr)',gap:14,padding:'14px 0',borderTop:'1px solid rgba(188,203,230,0.08)'}}>
                    <div style={{fontSize:12,fontWeight:800,color:'#f3dfb4'}}>{step.time}</div>
                    <div>
                      <div style={{fontSize:15,fontWeight:800,color:C.white,marginBottom:4}}>{step.title}</div>
                      <div style={{fontSize:13,color:C.grey2,lineHeight:1.65}}>{step.body}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div style={{background:'linear-gradient(180deg,rgba(20,26,36,0.94),rgba(14,20,28,0.94))',border:`1px solid ${C.border}`,borderRadius:28,padding:'24px 22px'}}>
              <div style={{fontSize:12,fontWeight:800,letterSpacing:1.7,textTransform:'uppercase',color:C.blue,marginBottom:10}}>Queued runs</div>
              <div style={{display:'grid',gap:10,marginBottom:18}}>
                {automationRuns.length > 0 ? automationRuns.map((run) => (
                  <div key={run.id} style={{padding:'12px 14px',background:'rgba(255,255,255,0.035)',border:`1px solid ${C.border}`,borderRadius:14}}>
                    <div style={{display:'flex',justifyContent:'space-between',gap:12,alignItems:'center',marginBottom:4}}>
                      <div style={{fontSize:12,fontWeight:800,color:C.white,textTransform:'uppercase'}}>{run.action_type?.replaceAll('_', ' ')}</div>
                      <div style={{fontSize:10,color:'#f3dfb4',textTransform:'uppercase'}}>{run.status}</div>
                    </div>
                    <div style={{fontSize:12,color:C.grey2}}>Episode {run.episode_number || '—'} · {formatDateTimeShort(run.scheduled_for)}</div>
                  </div>
                )) : <div style={{padding:'12px 14px',background:'rgba(255,255,255,0.035)',border:`1px solid ${C.border}`,borderRadius:14,fontSize:13,color:C.grey2}}>No queued NightDrop automation runs yet.</div>}
              </div>
              <div style={{fontSize:12,fontWeight:800,letterSpacing:1.7,textTransform:'uppercase',color:C.blue,marginBottom:10}}>Console log</div>
              <div style={{display:'grid',gap:10}}>
                {(automationLogs.length > 0 ? automationLogs : actionLog).map((entry) => (
                  <div key={entry.id} style={{padding:'12px 14px',background:'rgba(255,255,255,0.035)',border:`1px solid ${C.border}`,borderRadius:14,fontSize:13,color:entry.level === 'success' || entry.tone === 'success' ? C.white : C.grey2,lineHeight:1.6}}>
                    {entry.message}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function DashboardScreen({user,onUpload,onAdmin,onBackHome,onOpenChannel}) {
  const [loadingStudio, setLoadingStudio] = useState(true);
  const [channel, setChannel] = useState(null);
  const [channelForm, setChannelForm] = useState({ display_name:'', tagline:'', bio:'' });
  const [tiers, setTiers] = useState([]);
  const [shows, setShows] = useState([]);
  const [bonusItems, setBonusItems] = useState([]);
  const [liveEvents, setLiveEvents] = useState([]);
  const [memberships, setMemberships] = useState([]);
  const [tips, setTips] = useState([]);
  const [savingChannel, setSavingChannel] = useState(false);
  const [savingTierId, setSavingTierId] = useState(null);
  const [creatingTier, setCreatingTier] = useState(false);
  const [savingBonus, setSavingBonus] = useState(false);
  const [savingEvent, setSavingEvent] = useState(false);
  const [studioMessage, setStudioMessage] = useState('');
  const [bonusDraft, setBonusDraft] = useState({
    title: '',
    description: '',
    content_type: 'founder update',
    access_type: 'creator_member',
    external_url: '',
    body_markdown: '',
    membership_tier_id: '',
    is_published: true,
  });
  const [eventDraft, setEventDraft] = useState({
    title: '',
    description: '',
    starts_at: '',
    access_type: 'public',
    ticket_price_zar: '',
    is_watch_along: true,
  });

  const loadStudio = async () => {
    if (!user?.id) return;
    setLoadingStudio(true);

    const channelRes = await supabase
      .from('creator_channels')
      .select('*')
      .eq('creator_id', user.id)
      .maybeSingle();

    const foundChannel = channelRes.data || null;
    setChannel(foundChannel);
    setChannelForm({
      display_name: foundChannel?.display_name || user?.full_name || 'VAULTT Creator',
      tagline: foundChannel?.tagline || '',
      bio: foundChannel?.bio || '',
    });

    if (!foundChannel) {
      setTiers([]);
      setShows([]);
      setBonusItems([]);
      setLiveEvents([]);
      setMemberships([]);
      setTips([]);
      setLoadingStudio(false);
      return;
    }

    const [tierRes, showRes, bonusRes, liveRes, membershipsRes, tipsRes] = await Promise.all([
      supabase
        .from('membership_tiers')
        .select('*')
        .eq('creator_channel_id', foundChannel.id)
        .order('sort_order', { ascending: true }),
      supabase
        .from('shows')
        .select('*')
        .eq('creator_id', user.id)
        .order('created_at', { ascending: false })
        .limit(8),
      supabase
        .from('bonus_content_items')
        .select('*')
        .eq('creator_channel_id', foundChannel.id)
        .order('created_at', { ascending: false })
        .limit(8),
      supabase
        .from('live_events')
        .select('*')
        .eq('creator_channel_id', foundChannel.id)
        .order('starts_at', { ascending: true })
        .limit(8),
      supabase
        .from('creator_memberships')
        .select('id,status,started_at,viewer_id')
        .eq('creator_channel_id', foundChannel.id)
        .order('created_at', { ascending: false }),
      supabase
        .from('tip_transactions')
        .select('id,amount_zar,status,message,created_at')
        .eq('creator_channel_id', foundChannel.id)
        .order('created_at', { ascending: false })
        .limit(10),
    ]);

    setTiers((tierRes.data || []).map((tier) => ({
      ...tier,
      perksText: Array.isArray(tier.perks) ? tier.perks.join('\n') : '',
    })));
    setShows(showRes.data || []);
    setBonusItems(bonusRes.data || []);
    setLiveEvents(liveRes.data || []);
    setMemberships(membershipsRes.data || []);
    setTips(tipsRes.data || []);
    setLoadingStudio(false);
  };

  useEffect(() => {
    loadStudio();
  }, [user?.id]);

  const activeMembers = memberships.filter((row) => row.status === 'active').length;
  const pendingMembers = memberships.filter((row) => row.status === 'pending').length;
  const paidTips = tips.filter((row) => row.status === 'paid');
  const pendingTips = tips.filter((row) => row.status === 'pending');
  const totalTipValue = tips.reduce((sum, row) => sum + Number(row.amount_zar || 0), 0);
  const paidTipValue = paidTips.reduce((sum, row) => sum + Number(row.amount_zar || 0), 0);
  const estimatedMonthlyValue = tiers
    .filter((tier) => tier.is_active)
    .reduce((sum, tier) => sum + (Number(tier.price_zar || 0) * activeMembers), 0);

  const metricCards = [
    { icon:'👥', label:'Active Members', value: activeMembers || '0', sub: pendingMembers ? `${pendingMembers} pending` : 'Membership pipeline open' },
    { icon:'🎁', label:'Tip Value', value:`R${Math.round(totalTipValue).toLocaleString()}`, sub: pendingTips.length ? `${pendingTips.length} pending handoff` : 'No pending tips' },
    { icon:'🎬', label:'Uploads', value: shows.length || '0', sub: shows.length ? 'Shows already in your channel' : 'No uploads yet' },
    { icon:'🔴', label:'Live Events', value: liveEvents.length || '0', sub: liveEvents.length ? 'Rooms ready for community' : 'No live sessions yet' },
  ];

  const saveChannel = async () => {
    if (!channelForm.display_name.trim()) {
      setStudioMessage('Please add a creator name before saving.');
      return;
    }
    setSavingChannel(true);
    setStudioMessage('');

    const slugBase = channelForm.display_name
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 40) || `creator-${user.id.slice(0, 8)}`;

    const payload = {
      creator_id: user.id,
      slug: channel?.slug || `${slugBase}-${user.id.slice(0, 4)}`,
      display_name: channelForm.display_name.trim(),
      tagline: channelForm.tagline.trim() || null,
      bio: channelForm.bio.trim() || null,
      membership_enabled: true,
      tipping_enabled: true,
      updated_at: new Date().toISOString(),
    };

    const result = channel?.id
      ? await supabase.from('creator_channels').update(payload).eq('id', channel.id).select('*').single()
      : await supabase.from('creator_channels').insert(payload).select('*').single();

    if (result.error) {
      setStudioMessage('We could not save your creator channel yet.');
      setSavingChannel(false);
      return;
    }

    setChannel(result.data);
    setStudioMessage(channel?.id ? 'Creator channel updated.' : 'Creator channel created.');
    setSavingChannel(false);
    await loadStudio();
  };

  const updateTierField = (tierId, field, value) => {
    setTiers((prev) => prev.map((tier) => (tier.id === tierId ? { ...tier, [field]: value } : tier)));
  };

  const saveTier = async (tier) => {
    setSavingTierId(tier.id);
    setStudioMessage('');
    const perks = tier.perksText
      ? tier.perksText.split('\n').map((line) => line.trim()).filter(Boolean)
      : [];

    const { error } = await supabase
      .from('membership_tiers')
      .update({
        name: tier.name,
        description: tier.description || null,
        price_zar: Number(tier.price_zar || 0),
        billing_interval: tier.billing_interval || 'monthly',
        perks,
        is_active: !!tier.is_active,
        sort_order: Number(tier.sort_order || 0),
        updated_at: new Date().toISOString(),
      })
      .eq('id', tier.id);

    if (error) {
      setStudioMessage('We could not save that membership tier yet.');
      setSavingTierId(null);
      return;
    }

    setStudioMessage(`Saved ${tier.name}.`);
    setSavingTierId(null);
    await loadStudio();
  };

  const createTier = async () => {
    if (!channel?.id) {
      setStudioMessage('Create your channel first, then add tiers.');
      return;
    }
    setCreatingTier(true);
    setStudioMessage('');

    const { error } = await supabase
      .from('membership_tiers')
      .insert({
        creator_channel_id: channel.id,
        name: `New Tier ${tiers.length + 1}`,
        description: 'Describe what supporters unlock here.',
        price_zar: 49,
        billing_interval: 'monthly',
        perks: ['Founder badge', 'Bonus updates'],
        is_active: true,
        sort_order: tiers.length + 1,
      });

    if (error) {
      setStudioMessage('We could not create a new tier yet.');
      setCreatingTier(false);
      return;
    }

    setStudioMessage('New membership tier created.');
    setCreatingTier(false);
    await loadStudio();
  };

  const publishBonusDrop = async () => {
    if (!channel?.id) {
      setStudioMessage('Create your channel first, then publish bonus content.');
      return;
    }
    if (!bonusDraft.title.trim()) {
      setStudioMessage('Add a title for the bonus drop before publishing.');
      return;
    }

    setSavingBonus(true);
    setStudioMessage('');

    const payload = {
      creator_channel_id: channel.id,
      membership_tier_id: bonusDraft.membership_tier_id || null,
      title: bonusDraft.title.trim(),
      description: bonusDraft.description.trim() || null,
      content_type: bonusDraft.content_type.trim() || 'founder update',
      access_type: bonusDraft.access_type || 'creator_member',
      body_markdown: bonusDraft.body_markdown.trim() || null,
      external_url: bonusDraft.external_url.trim() || null,
      is_published: !!bonusDraft.is_published,
      published_at: bonusDraft.is_published ? new Date().toISOString() : null,
      updated_at: new Date().toISOString(),
    };

    const { error } = await supabase
      .from('bonus_content_items')
      .insert(payload);

    if (error) {
      setStudioMessage('We could not publish that bonus drop yet.');
      setSavingBonus(false);
      return;
    }

    setBonusDraft({
      title: '',
      description: '',
      content_type: 'founder update',
      access_type: 'creator_member',
      external_url: '',
      body_markdown: '',
      membership_tier_id: '',
      is_published: true,
    });
    setStudioMessage('Bonus drop published to your creator channel.');
    setSavingBonus(false);
    await loadStudio();
  };

  const scheduleLiveEvent = async () => {
    if (!channel?.id) {
      setStudioMessage('Create your channel first, then schedule a live room.');
      return;
    }
    if (!eventDraft.title.trim() || !eventDraft.starts_at) {
      setStudioMessage('Add a title and start time for the live event.');
      return;
    }

    setSavingEvent(true);
    setStudioMessage('');
    const payload = {
      creator_channel_id: channel.id,
      title: eventDraft.title.trim(),
      description: eventDraft.description.trim() || null,
      status: 'scheduled',
      access_type: eventDraft.access_type,
      starts_at: new Date(eventDraft.starts_at).toISOString(),
      ticket_price_zar: eventDraft.ticket_price_zar ? Number(eventDraft.ticket_price_zar) : null,
      is_watch_along: !!eventDraft.is_watch_along,
      stream_provider: 'vaultt_live',
      updated_at: new Date().toISOString(),
    };

    const { error } = await supabase.from('live_events').insert(payload);
    if (error) {
      setStudioMessage('We could not schedule that live room yet.');
      setSavingEvent(false);
      return;
    }

    setEventDraft({
      title: '',
      description: '',
      starts_at: '',
      access_type: 'public',
      ticket_price_zar: '',
      is_watch_along: true,
    });
    setStudioMessage('Live room scheduled. It will now flow into the Live tab.');
    setSavingEvent(false);
    await loadStudio();
  };

  const studioField = {
    width:'100%',
    padding:'15px 16px',
    background:'rgba(255,255,255,0.04)',
    border:`1px solid ${C.border}`,
    borderRadius:16,
    fontSize:14,
    color:C.white,
    fontFamily:'inherit',
    boxSizing:'border-box',
    boxShadow:'inset 0 1px 0 rgba(255,255,255,0.03)',
  };

  const studioPanel = {
    background:'linear-gradient(180deg,rgba(255,255,255,0.055),rgba(255,255,255,0.028))',
    border:`1px solid ${C.border}`,
    borderRadius:24,
    padding:24,
    boxShadow:'0 20px 42px rgba(0,0,0,0.16)',
  };

  const studioInset = {
    padding:'16px 18px',
    background:'linear-gradient(180deg,rgba(255,255,255,0.045),rgba(255,255,255,0.025))',
    border:`1px solid ${C.border}`,
    borderRadius:18,
  };

  return (
    <div style={{background:'radial-gradient(circle at 50% 0%, rgba(75,163,255,0.12) 0%, transparent 24%), radial-gradient(circle at 82% 10%, rgba(241,198,109,0.08) 0%, transparent 16%), linear-gradient(180deg,#06070b 0%,#0d1118 42%,#141a24 100%)',minHeight:'100vh',paddingTop:68}}>
      <div style={{background:'linear-gradient(180deg,rgba(13,17,24,0.88),rgba(13,17,24,0.7))',borderBottom:`1px solid ${C.border}`,padding:'22px 4%',display:'flex',alignItems:'center',justifyContent:'space-between',gap:18,flexWrap:'wrap',boxShadow:'0 18px 50px rgba(0,0,0,0.18)',backdropFilter:'blur(16px)'}}>
        <div>
          <div style={{display:'flex',gap:10,alignItems:'center',marginBottom:14,flexWrap:'wrap'}}>
            <button onClick={onBackHome} style={{padding:'8px 14px',background:'linear-gradient(135deg,rgba(0,130,255,0.22),rgba(0,88,185,0.16))',border:`1px solid ${C.blueB}`,borderRadius:999,color:C.white,cursor:'pointer',fontSize:12,fontWeight:800,fontFamily:'inherit'}}>
              Home
            </button>
            <button onClick={onUpload} style={{padding:'8px 14px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:999,color:C.white,cursor:'pointer',fontSize:12,fontWeight:700,fontFamily:'inherit'}}>
              Upload
            </button>
            {channel?.id && <button onClick={() => onOpenChannel && onOpenChannel(channel)} style={{padding:'8px 14px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:999,color:C.white,cursor:'pointer',fontSize:12,fontWeight:700,fontFamily:'inherit'}}>View Channel</button>}
            {user?.email==='creators@vaultt.co.za'&&<button onClick={onAdmin} style={{padding:'8px 14px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:999,color:C.white,cursor:'pointer',fontSize:12,fontWeight:700,fontFamily:'inherit'}}>Admin</button>}
          </div>
          <div style={{fontSize:12,fontWeight:800,letterSpacing:2.2,textTransform:'uppercase',color:'#f3dfb4',marginBottom:8}}>Creator workspace</div>
          <div style={{fontSize:30,fontWeight:800,color:C.white,marginBottom:6,letterSpacing:-0.8}}>Creator Studio</div>
          <div style={{fontSize:14,color:C.grey2}}>{channel?.display_name ? `Managing ${channel.display_name}` : `Welcome back, ${user?.full_name||'Creator'}.`}</div>
        </div>
        <div style={{display:'flex',gap:10,alignItems:'center',flexWrap:'wrap'}}>
          {studioMessage && <div style={{fontSize:12,color:C.grey2,padding:'10px 14px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:999}}>{studioMessage}</div>}
          <button onClick={onUpload} style={{padding:'12px 18px',background:'linear-gradient(135deg,#66b2ff,#2f8fff)',color:C.white,border:'none',borderRadius:999,fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'inherit',boxShadow:'0 12px 24px rgba(75,163,255,0.22)'}}>+ Upload Video</button>
        </div>
      </div>

      <div style={{padding:'28px 4% 100px'}}>
        <div style={{background:'linear-gradient(135deg,rgba(75,163,255,0.22),rgba(16,29,46,0.92) 55%,rgba(241,198,109,0.08) 100%)',border:`1px solid ${C.blueB}`,borderRadius:28,padding:'30px 32px',display:'flex',justifyContent:'space-between',alignItems:'center',gap:20,flexWrap:'wrap',marginBottom:24,boxShadow:'0 18px 40px rgba(0,0,0,0.2)'}}>
          <div>
            <div style={{fontSize:12,fontWeight:800,letterSpacing:1.8,textTransform:'uppercase',marginBottom:8,color:'#f3dfb4'}}>Creator business snapshot</div>
            <div style={{fontSize:56,fontWeight:900,color:C.white,lineHeight:0.94,letterSpacing:-1.8,marginBottom:8}}>R{Math.round(estimatedMonthlyValue + paidTipValue).toLocaleString()}</div>
            <div style={{fontSize:14,color:'rgba(215,221,232,0.92)',maxWidth:480,lineHeight:1.7}}>Estimated active creator revenue across memberships and paid tips recorded so far.</div>
          </div>
          <div style={{display:'grid',gap:10,minWidth:260}}>
            <div style={{padding:'13px 16px',background:'rgba(255,255,255,0.06)',border:`1px solid ${C.border}`,borderRadius:18}}>
              <div style={{fontSize:11,letterSpacing:1.4,textTransform:'uppercase',color:C.grey2,marginBottom:4}}>Membership pipeline</div>
              <div style={{fontSize:18,fontWeight:800,color:C.white}}>{activeMembers} active · {pendingMembers} pending</div>
            </div>
            <div style={{padding:'13px 16px',background:'rgba(255,255,255,0.06)',border:`1px solid ${C.border}`,borderRadius:18}}>
              <div style={{fontSize:11,letterSpacing:1.4,textTransform:'uppercase',color:C.grey2,marginBottom:4}}>Tip handoff readiness</div>
              <div style={{fontSize:18,fontWeight:800,color:C.white}}>{pendingTips.length} pending · {paidTips.length} paid</div>
            </div>
          </div>
        </div>

        <div className='dashboard-grid' style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:24}}>
          {metricCards.map((k,i)=>(
            <div key={i} style={{background:'linear-gradient(180deg,rgba(255,255,255,0.055),rgba(255,255,255,0.028))',border:`1px solid ${C.border}`,borderRadius:22,padding:20,backdropFilter:'blur(12px)',boxShadow:'0 16px 32px rgba(0,0,0,0.12)'}}>
              <div style={{fontSize:20,marginBottom:10}}>{k.icon}</div>
              <div style={{fontSize:9,fontWeight:700,letterSpacing:1.5,textTransform:'uppercase',color:C.grey,marginBottom:4}}>{k.label}</div>
              <div style={{fontSize:26,fontWeight:900,color:C.white,marginBottom:6}}>{k.value}</div>
              <div style={{fontSize:12,color:C.grey2,lineHeight:1.5}}>{k.sub}</div>
            </div>
          ))}
        </div>

        <div className='studio-main-grid' style={{display:'grid',gridTemplateColumns:'minmax(0,1fr) minmax(320px,0.92fr)',gap:16,alignItems:'start'}}>
          <div style={{display:'grid',gap:16}}>
            <div style={studioPanel}>
              <div style={{display:'flex',justifyContent:'space-between',gap:14,alignItems:'center',marginBottom:16,flexWrap:'wrap'}}>
                <div>
                  <div style={{fontSize:12,fontWeight:800,letterSpacing:1.7,textTransform:'uppercase',color:'#f3dfb4',marginBottom:6}}>Channel profile</div>
                  <div style={{fontSize:22,fontWeight:800,color:C.white,marginBottom:4}}>Creator identity</div>
                  <div style={{fontSize:13,color:C.grey2}}>This is what viewers see on your creator channel.</div>
                </div>
                <button onClick={saveChannel} disabled={savingChannel} style={{padding:'11px 18px',background:'linear-gradient(135deg,#66b2ff,#2f8fff)',color:C.white,border:'none',borderRadius:999,fontSize:12,fontWeight:700,cursor:savingChannel?'not-allowed':'pointer',fontFamily:'inherit',opacity:savingChannel?0.7:1}}>
                  {savingChannel ? 'Saving...' : channel?.id ? 'Save channel' : 'Create channel'}
                </button>
              </div>
              <div className='studio-form-two' style={{display:'grid',gridTemplateColumns:'minmax(0,1fr) minmax(0,1fr)',gap:12,marginBottom:12}}>
                <input value={channelForm.display_name} onChange={(e)=>setChannelForm((prev)=>({...prev,display_name:e.target.value}))} placeholder='Creator name' style={{...studioField,minWidth:0}} />
                <input value={channelForm.tagline} onChange={(e)=>setChannelForm((prev)=>({...prev,tagline:e.target.value}))} placeholder='Short tagline' style={{...studioField,minWidth:0}} />
              </div>
              <textarea value={channelForm.bio} onChange={(e)=>setChannelForm((prev)=>({...prev,bio:e.target.value}))} placeholder='Tell viewers what your channel is about.' rows={4} style={{...studioField, resize:'vertical'}} />
            </div>

            <div style={studioPanel}>
              <div style={{display:'flex',justifyContent:'space-between',gap:14,alignItems:'center',marginBottom:16,flexWrap:'wrap'}}>
                <div>
                  <div style={{fontSize:12,fontWeight:800,letterSpacing:1.7,textTransform:'uppercase',color:C.blue,marginBottom:6}}>Monetization</div>
                  <div style={{fontSize:22,fontWeight:800,color:C.white,marginBottom:4}}>Membership tiers</div>
                  <div style={{fontSize:13,color:C.grey2}}>Edit pricing, perks and tier messaging directly in VAULTT.</div>
                </div>
                <button onClick={createTier} disabled={creatingTier || !channel?.id} style={{padding:'10px 16px',background:'rgba(255,255,255,0.05)',color:C.white,border:`1px solid ${C.border}`,borderRadius:999,fontSize:12,fontWeight:700,cursor:creatingTier||!channel?.id?'not-allowed':'pointer',fontFamily:'inherit',opacity:creatingTier||!channel?.id?0.7:1}}>
                  {creatingTier ? 'Creating...' : '+ New tier'}
                </button>
              </div>

              {loadingStudio ? (
                <div style={{fontSize:13,color:C.grey2}}>Loading creator tiers...</div>
              ) : tiers.length > 0 ? (
                <div style={{display:'grid',gap:14}}>
                  {tiers.map((tier) => (
                    <div key={tier.id} style={{padding:18,background:'linear-gradient(180deg,rgba(255,255,255,0.045),rgba(255,255,255,0.022))',border:`1px solid ${C.border}`,borderRadius:20}}>
                      <div className='studio-form-three' style={{display:'grid',gridTemplateColumns:'minmax(0,1.3fr) minmax(0,0.7fr) minmax(0,0.7fr)',gap:12,marginBottom:12}}>
                        <input value={tier.name || ''} onChange={(e)=>updateTierField(tier.id,'name',e.target.value)} placeholder='Tier name' style={{...studioField,minWidth:0}} />
                        <input value={tier.price_zar ?? ''} onChange={(e)=>updateTierField(tier.id,'price_zar',e.target.value)} placeholder='49' type='number' min='0' step='1' style={{...studioField,minWidth:0}} />
                        <select value={tier.billing_interval || 'monthly'} onChange={(e)=>updateTierField(tier.id,'billing_interval',e.target.value)} style={{...studioField,minWidth:0}}>
                          <option value='monthly'>monthly</option>
                          <option value='quarterly'>quarterly</option>
                          <option value='yearly'>yearly</option>
                        </select>
                      </div>
                      <input value={tier.description || ''} onChange={(e)=>updateTierField(tier.id,'description',e.target.value)} placeholder='Describe what this tier unlocks.' style={{...studioField, marginBottom:12}} />
                      <textarea value={tier.perksText || ''} onChange={(e)=>updateTierField(tier.id,'perksText',e.target.value)} placeholder={'One perk per line\nFounder badge\nBonus drops'} rows={4} style={{...studioField, resize:'vertical', marginBottom:12}} />
                      <div style={{display:'flex',justifyContent:'space-between',gap:12,alignItems:'center',flexWrap:'wrap'}}>
                        <label style={{display:'flex',alignItems:'center',gap:10,fontSize:13,color:C.grey2}}>
                          <input type='checkbox' checked={!!tier.is_active} onChange={(e)=>updateTierField(tier.id,'is_active',e.target.checked)} />
                          Tier is active on the channel
                        </label>
                        <button onClick={()=>saveTier(tier)} disabled={savingTierId===tier.id} style={{padding:'10px 16px',background:C.blue,color:C.white,border:'none',borderRadius:999,fontSize:12,fontWeight:700,cursor:savingTierId===tier.id?'not-allowed':'pointer',fontFamily:'inherit',opacity:savingTierId===tier.id?0.7:1}}>
                          {savingTierId===tier.id ? 'Saving...' : 'Save tier'}
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{fontSize:13,color:C.grey2,lineHeight:1.6}}>No membership tiers yet. Create one to start selling direct supporter access.</div>
              )}
            </div>

            <div style={studioPanel}>
              <div style={{display:'flex',justifyContent:'space-between',gap:14,alignItems:'center',marginBottom:16,flexWrap:'wrap'}}>
                <div>
                  <div style={{fontSize:12,fontWeight:800,letterSpacing:1.7,textTransform:'uppercase',color:'#f3dfb4',marginBottom:6}}>Publishing</div>
                  <div style={{fontSize:22,fontWeight:800,color:C.white,marginBottom:4}}>Publish bonus drop</div>
                  <div style={{fontSize:13,color:C.grey2}}>Create a founder update, premium post or member-only link directly from Studio.</div>
                </div>
                <button onClick={publishBonusDrop} disabled={savingBonus || !channel?.id} style={{padding:'10px 16px',background:'linear-gradient(135deg,#66b2ff,#2f8fff)',color:C.white,border:'none',borderRadius:999,fontSize:12,fontWeight:700,cursor:savingBonus||!channel?.id?'not-allowed':'pointer',fontFamily:'inherit',opacity:savingBonus||!channel?.id?0.7:1}}>
                  {savingBonus ? 'Publishing...' : 'Publish drop'}
                </button>
              </div>
              <div className='studio-form-two' style={{display:'grid',gridTemplateColumns:'minmax(0,1.1fr) minmax(0,0.9fr)',gap:12,marginBottom:12}}>
                <input value={bonusDraft.title} onChange={(e)=>setBonusDraft((prev)=>({...prev,title:e.target.value}))} placeholder='Founder update title' style={{...studioField,minWidth:0}} />
                <input value={bonusDraft.content_type} onChange={(e)=>setBonusDraft((prev)=>({...prev,content_type:e.target.value}))} placeholder='founder update' style={{...studioField,minWidth:0}} />
              </div>
              <input value={bonusDraft.description} onChange={(e)=>setBonusDraft((prev)=>({...prev,description:e.target.value}))} placeholder='Short description for supporters' style={{...studioField, marginBottom:12, minWidth:0}} />
              <div className='studio-form-three' style={{display:'grid',gridTemplateColumns:'minmax(0,0.8fr) minmax(0,0.8fr) minmax(0,1fr)',gap:12,marginBottom:12}}>
                <select value={bonusDraft.access_type} onChange={(e)=>setBonusDraft((prev)=>({...prev,access_type:e.target.value}))} style={{...studioField,minWidth:0}}>
                  <option value='creator_member'>creator_member</option>
                  <option value='public'>public</option>
                  <option value='paid_bonus'>paid_bonus</option>
                </select>
                <select value={bonusDraft.membership_tier_id} onChange={(e)=>setBonusDraft((prev)=>({...prev,membership_tier_id:e.target.value}))} style={{...studioField,minWidth:0}}>
                  <option value=''>Any membership tier</option>
                  {tiers.map((tier) => (
                    <option key={tier.id} value={tier.id}>{tier.name}</option>
                  ))}
                </select>
                <input value={bonusDraft.external_url} onChange={(e)=>setBonusDraft((prev)=>({...prev,external_url:e.target.value}))} placeholder='Optional external link' style={{...studioField,minWidth:0}} />
              </div>
              <textarea value={bonusDraft.body_markdown} onChange={(e)=>setBonusDraft((prev)=>({...prev,body_markdown:e.target.value}))} placeholder={'Write the founder note or premium update here.\n\nYou can use this for member briefings, early links or drop copy.'} rows={5} style={{...studioField, resize:'vertical', marginBottom:12}} />
              <label style={{display:'flex',alignItems:'center',gap:10,fontSize:13,color:C.grey2}}>
                <input type='checkbox' checked={!!bonusDraft.is_published} onChange={(e)=>setBonusDraft((prev)=>({...prev,is_published:e.target.checked}))} />
                Publish immediately on the creator channel
              </label>
            </div>

            <div style={studioPanel}>
              <div style={{display:'flex',justifyContent:'space-between',gap:14,alignItems:'center',marginBottom:16,flexWrap:'wrap'}}>
                <div>
                  <div style={{fontSize:12,fontWeight:800,letterSpacing:1.7,textTransform:'uppercase',color:C.blue,marginBottom:6}}>Live scheduling</div>
                  <div style={{fontSize:22,fontWeight:800,color:C.white,marginBottom:4}}>Schedule creator room</div>
                  <div style={{fontSize:13,color:C.grey2}}>Set up a watch-along, founder briefing or live community event for the Live tab.</div>
                </div>
                <button onClick={scheduleLiveEvent} disabled={savingEvent || !channel?.id} style={{padding:'10px 16px',background:'linear-gradient(135deg,#66b2ff,#2f8fff)',color:C.white,border:'none',borderRadius:999,fontSize:12,fontWeight:700,cursor:savingEvent||!channel?.id?'not-allowed':'pointer',fontFamily:'inherit',opacity:savingEvent||!channel?.id?0.7:1}}>
                  {savingEvent ? 'Scheduling...' : 'Schedule room'}
                </button>
              </div>
              <div className='studio-form-two' style={{display:'grid',gridTemplateColumns:'minmax(0,1fr) minmax(0,0.9fr)',gap:12,marginBottom:12}}>
                <input value={eventDraft.title} onChange={(e)=>setEventDraft((prev)=>({...prev,title:e.target.value}))} placeholder='PSL live watch-along' style={{...studioField,minWidth:0}} />
                <input value={eventDraft.starts_at} onChange={(e)=>setEventDraft((prev)=>({...prev,starts_at:e.target.value}))} type='datetime-local' style={{...studioField,minWidth:0}} />
              </div>
              <input value={eventDraft.description} onChange={(e)=>setEventDraft((prev)=>({...prev,description:e.target.value}))} placeholder='What will viewers experience in this room?' style={{...studioField, marginBottom:12, minWidth:0}} />
              <div className='studio-form-three' style={{display:'grid',gridTemplateColumns:'minmax(0,0.8fr) minmax(0,0.8fr) minmax(0,1fr)',gap:12,marginBottom:12}}>
                <select value={eventDraft.access_type} onChange={(e)=>setEventDraft((prev)=>({...prev,access_type:e.target.value}))} style={{...studioField,minWidth:0}}>
                  <option value='public'>public</option>
                  <option value='creator_member'>creator_member</option>
                  <option value='ticket_holder'>ticket_holder</option>
                </select>
                <input value={eventDraft.ticket_price_zar} onChange={(e)=>setEventDraft((prev)=>({...prev,ticket_price_zar:e.target.value}))} type='number' min='0' step='1' placeholder='Ticket price (optional)' style={{...studioField,minWidth:0}} />
                <label style={{display:'flex',alignItems:'center',gap:10,fontSize:13,color:C.grey2,padding:'0 4px'}}>
                  <input type='checkbox' checked={!!eventDraft.is_watch_along} onChange={(e)=>setEventDraft((prev)=>({...prev,is_watch_along:e.target.checked}))} />
                  Mark as watch-along
                </label>
              </div>
            </div>
          </div>

          <div style={{display:'grid',gap:16}}>
            <div style={studioPanel}>
              <div style={{fontSize:12,fontWeight:800,letterSpacing:1.7,textTransform:'uppercase',color:'#f3dfb4',marginBottom:6}}>Live pipeline</div>
              <div style={{fontSize:22,fontWeight:800,color:C.white,marginBottom:12}}>Scheduled rooms</div>
              {liveEvents.length > 0 ? (
                <div style={{display:'grid',gap:10}}>
                  {liveEvents.slice(0,4).map((event) => (
                    <div key={event.id} style={{padding:'14px 16px',background:'linear-gradient(180deg,rgba(255,255,255,0.045),rgba(255,255,255,0.02))',border:`1px solid ${C.border}`,borderRadius:18}}>
                      <div style={{display:'flex',justifyContent:'space-between',gap:10,alignItems:'center',marginBottom:6,flexWrap:'wrap'}}>
                        <div style={{fontSize:14,fontWeight:700,color:C.white}}>{event.title}</div>
                        <div style={{fontSize:10,fontWeight:800,letterSpacing:1.2,textTransform:'uppercase',color:event.status === 'live' ? C.red : '#f3dfb4'}}>
                          {event.status}
                        </div>
                      </div>
                      <div style={{fontSize:12,color:C.grey2,marginBottom:6}}>{formatDateTimeShort(event.starts_at)}</div>
                      <div style={{fontSize:12,color:C.grey2,lineHeight:1.5}}>
                        {event.description || 'Creator-led room ready for audience discovery, reactions and future payment gating.'}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{fontSize:13,color:C.grey2,lineHeight:1.6}}>No live rooms scheduled yet. Use the scheduler on the left to seed the Live tab and your channel.</div>
              )}
            </div>

            <div style={studioPanel}>
              <div style={{fontSize:12,fontWeight:800,letterSpacing:1.7,textTransform:'uppercase',color:C.blue,marginBottom:6}}>Live view</div>
              <div style={{fontSize:22,fontWeight:800,color:C.white,marginBottom:14}}>Studio activity</div>
              <div style={{display:'grid',gap:12}}>
                <div style={studioInset}>
                  <div style={{fontSize:11,letterSpacing:1.4,textTransform:'uppercase',color:C.grey2,marginBottom:4}}>Latest support</div>
                  <div style={{fontSize:20,fontWeight:800,color:C.white,marginBottom:4}}>{tips[0] ? `R${Number(tips[0].amount_zar || 0).toFixed(0)}` : 'No tips yet'}</div>
                  <div style={{fontSize:12,color:C.grey2}}>{tips[0] ? `Status: ${tips[0].status}` : 'Creator tipping is ready when viewers start supporting.'}</div>
                </div>
                <div style={studioInset}>
                  <div style={{fontSize:11,letterSpacing:1.4,textTransform:'uppercase',color:C.grey2,marginBottom:4}}>Uploads ready</div>
                  <div style={{fontSize:20,fontWeight:800,color:C.white,marginBottom:4}}>{shows.length}</div>
                  <div style={{fontSize:12,color:C.grey2}}>{shows[0] ? `Latest: ${shows[0].title}` : 'Upload your first show to populate your channel.'}</div>
                </div>
                <div style={studioInset}>
                  <div style={{fontSize:11,letterSpacing:1.4,textTransform:'uppercase',color:C.grey2,marginBottom:4}}>Bonus content</div>
                  <div style={{fontSize:20,fontWeight:800,color:C.white,marginBottom:4}}>{bonusItems.length}</div>
                  <div style={{fontSize:12,color:C.grey2}}>{bonusItems[0] ? `Latest drop: ${bonusItems[0].title}` : 'Bonus content can now be added for members and future premium drops.'}</div>
                </div>
              </div>
            </div>

            <div style={studioPanel}>
              <div style={{fontSize:22,fontWeight:800,color:C.white,marginBottom:12}}>Recent uploads</div>
              {shows.length > 0 ? (
                <div style={{display:'grid',gap:10}}>
                  {shows.slice(0,4).map((show) => (
                    <div key={show.id} style={{display:'flex',justifyContent:'space-between',gap:12,alignItems:'center',padding:'14px 16px',background:'linear-gradient(180deg,rgba(255,255,255,0.045),rgba(255,255,255,0.02))',border:`1px solid ${C.border}`,borderRadius:18}}>
                      <div>
                        <div style={{fontSize:14,fontWeight:700,color:C.white,marginBottom:4}}>{show.title}</div>
                        <div style={{fontSize:12,color:C.grey2}}>{show.category || show.type || 'VAULTT upload'}</div>
                      </div>
                      <div style={{fontSize:11,fontWeight:800,letterSpacing:1.2,textTransform:'uppercase',color:show.mux_playback_id ? C.green : C.gold}}>
                        {show.mux_playback_id ? 'Live' : 'Processing'}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{fontSize:13,color:C.grey2,lineHeight:1.6}}>No creator uploads yet. Your first upload will appear here and feed your creator channel immediately.</div>
              )}
            </div>

            <div style={studioPanel}>
              <div style={{fontSize:22,fontWeight:800,color:C.white,marginBottom:12}}>Latest bonus drops</div>
              {bonusItems.length > 0 ? (
                <div style={{display:'grid',gap:10}}>
                  {bonusItems.slice(0,4).map((item) => (
                    <div key={item.id} style={{padding:'14px 16px',background:'linear-gradient(180deg,rgba(255,255,255,0.045),rgba(255,255,255,0.02))',border:`1px solid ${C.border}`,borderRadius:18}}>
                      <div style={{display:'flex',justifyContent:'space-between',gap:10,alignItems:'center',marginBottom:6}}>
                        <div style={{fontSize:14,fontWeight:700,color:C.white}}>{item.title}</div>
                        <div style={{fontSize:10,fontWeight:800,letterSpacing:1.2,textTransform:'uppercase',color:item.is_published ? C.green : C.gold}}>
                          {item.is_published ? 'Published' : 'Draft'}
                        </div>
                      </div>
                      <div style={{fontSize:12,color:C.grey2,marginBottom:6}}>{item.content_type || 'bonus drop'} · {item.access_type}</div>
                      <div style={{fontSize:12,color:C.grey2,lineHeight:1.5}}>{item.description || item.body_markdown || 'Bonus update ready for supporters.'}</div>
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{fontSize:13,color:C.grey2,lineHeight:1.6}}>No bonus drops yet. Publish your first founder note, premium link or member-only update from the form on the left.</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  const [user,setUser]=useState(null);
  const [screen,setScreen]=useState('home');
  const [activeShow,setActiveShow]=useState(null);
  const [activeChannel,setActiveChannel]=useState(null);
  const [loading,setLoading]=useState(true);
  const [toast,setToast]=useState(null);
  const [showUpload,setShowUpload]=useState(false);
  const [showApply,setShowApply]=useState(false);
  const [showLanding,setShowLanding]=useState(true);
  const [showAdmin,setShowAdmin]=useState(false);
  const [myList,setMyList]=useState([]);
  const [showPaywall,setShowPaywall]=useState(false);
  const [searchQuery,setSearchQuery]=useState('');
  const [allDbShows,setAllDbShows]=useState([]);
  const [continueWatching,setContinueWatching]=useState(()=>{
    try{return JSON.parse(localStorage.getItem('vaultt_continue')||'[]');}catch(e){return [];}
  });
  const [showSearch,setShowSearch]=useState(false);
  const [paywallShow,setPaywallShow]=useState(null);
  const [episodesWatched,setEpisodesWatched]=useState(()=>{try{return parseInt(localStorage.getItem('vaultt_eps')||'0');}catch(e){return 0;}});

  useEffect(()=>{
    const check=async()=>{
      try{
        const res=await supabase.auth.getSession();
        const session=res.data.session;
        if(session?.user){
          const pr=await supabase.from('profiles').select('*').eq('id',session.user.id).single();
          setUser(pr.data||{id:session.user.id,email:session.user.email,role:'viewer',full_name:session.user.email});
        }
      }catch(e){console.log('Session:',e);}
      setLoading(false);
    };
    check();
  },[]);

  const handleNav=(dest)=>{
    if(dest==='dashboard'&&user?.role!=='creator'){setToast({message:'Creator Studio is for approved creators only.',type:'error'});return;}
    if(dest==='nightdrop-admin'&&user?.email!=='creators@vaultt.co.za'){setToast({message:'NightDrop Admin is restricted right now.',type:'error'});return;}
    setScreen(dest);window.scrollTo(0,0);
  };
  const handleLogout=async()=>{await supabase.auth.signOut();setUser(null);setScreen('home');setToast({message:'Signed out.',type:'info'});};
  const handleAddList=(id)=>{setMyList(prev=>prev.includes(id)?prev.filter(x=>x!==id):[...prev,id]);setToast({message:'My List updated',type:'success'});};
  const handleWatch=(show)=>{
    const isAdmin=user?.email==='creators@vaultt.co.za';
    const isDemoCreator=user?.id?.startsWith('demo-creator');
    const isFree=!isAdmin&&!isDemoCreator&&(user?.subscription_status==='free'||!user?.subscription_status);
    if(isFree&&episodesWatched>=2){setPaywallShow(show);setShowPaywall(true);return;}
    setEpisodesWatched(prev=>{const n=prev+1;try{localStorage.setItem('vaultt_eps',n);}catch(e){}return n;});
    setContinueWatching(prev=>{
      const filtered=prev.filter(s=>s.id!==show.id);
      const updated=[show,...filtered].slice(0,10);
      try{localStorage.setItem('vaultt_continue',JSON.stringify(updated));}catch(e){}
      return updated;
    });
    setActiveShow(show);setScreen('watch');window.scrollTo(0,0);
  };
  const handleOpenChannel=(channel)=>{
    setActiveChannel(channel);
    setScreen('creator-channel');
    window.scrollTo(0,0);
  };
  const handleJoinMembership = async (tier, channel) => {
    if (!user?.id) {
      setToast({ message: 'Please sign in to join memberships.', type: 'error' });
      return null;
    }

    const paymentReference = `mbr-${channel.id.slice(0,6)}-${tier.id.slice(0,6)}-${Date.now()}`;

    const { data: existing } = await supabase
      .from('creator_memberships')
      .select('id,status,payment_reference,payment_provider')
      .eq('tier_id', tier.id)
      .eq('viewer_id', user.id)
      .maybeSingle();

    if (existing?.status === 'active' || existing?.status === 'pending') {
      setToast({ message: existing.status === 'active' ? 'Your membership is already active.' : 'Your membership request is already pending.', type: 'info' });
      return {
        status: existing.status,
        paymentReference: existing.payment_reference || paymentReference,
        paymentProvider: existing.payment_provider || 'payfast_pending',
      };
    }

    let result;
    if (existing?.id) {
      result = await supabase
        .from('creator_memberships')
        .update({
          status: 'pending',
          payment_provider: 'payfast_pending',
          payment_reference: paymentReference,
          updated_at: new Date().toISOString(),
        })
        .eq('id', existing.id)
        .select('status,payment_reference,payment_provider')
        .single();
    } else {
      result = await supabase
        .from('creator_memberships')
        .insert({
          tier_id: tier.id,
          creator_channel_id: channel.id,
          viewer_id: user.id,
          status: 'pending',
          payment_provider: 'payfast_pending',
          payment_reference: paymentReference,
        })
        .select('status,payment_reference,payment_provider')
        .single();
    }

    if (result.error) {
      setToast({ message: 'We could not save your membership yet. Please try again.', type: 'error' });
      return null;
    }

    setToast({ message: 'Membership saved. Checkout handoff is prepared for this tier.', type: 'success' });
    return {
      status: result.data?.status || 'pending',
      paymentReference: result.data?.payment_reference || paymentReference,
      paymentProvider: result.data?.payment_provider || 'payfast_pending',
    };
  };
  const handleCreateTip = async ({ channel, amount, message, viewerId }) => {
    if (!viewerId) {
      setToast({ message: 'Please sign in to send a tip.', type: 'error' });
      return null;
    }

    const paymentReference = `tip-${channel.id.slice(0,6)}-${Date.now()}`;

    const { data, error } = await supabase
      .from('tip_transactions')
      .insert({
        creator_channel_id: channel.id,
        viewer_id: viewerId,
        amount_zar: amount,
        currency: 'ZAR',
        status: 'pending',
        payment_provider: 'payfast_pending',
        payment_reference: paymentReference,
        message: message || null,
      })
      .select('id,amount_zar,status,message,created_at,payment_reference,payment_provider')
      .single();

    if (error) {
      setToast({ message: 'We could not save your tip yet. Please try again.', type: 'error' });
      return null;
    }

    setToast({ message: `Tip of R${amount} saved for ${channel.display_name}.`, type: 'success' });
    return data;
  };

  if(loading)return <div style={{minHeight:'100vh',background:C.bg,display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',gap:16}}><div style={{fontFamily:'Arial',fontSize:32,fontWeight:900,letterSpacing:8,color:C.blue}}>VAULTT</div><div style={{fontSize:13,color:C.grey}}>Loading...</div></div>;
  if(showApply)return <ApplyScreen onBack={()=>setShowApply(false)} onSuccess={()=>setShowApply(false)}/>;
  if(!user&&showLanding)return <LandingPage onSignIn={()=>setShowLanding(false)} onApply={()=>{setShowLanding(false);setShowApply(true);}}/>;
  if(showAdmin)return <AdminDashboard user={user} onBack={()=>setShowAdmin(false)} onHome={()=>{setShowAdmin(false);setScreen('home');}}/>;
  if(!user)return <LoginScreen onLogin={u=>{setUser(u);setToast({message:`Welcome to VAULTT!`,type:'success'});}} onApply={()=>setShowApply(true)}/>;
  if(screen==='dashboard'&&user.role==='creator'){
    if(showUpload)return <UploadScreen user={user} onBack={()=>setShowUpload(false)} onHome={()=>{setShowUpload(false);setScreen('home');}}/>;
    return <DashboardScreen user={user} onUpload={()=>setShowUpload(true)} onAdmin={()=>setShowAdmin(true)} onBackHome={()=>setScreen('home')} onOpenChannel={handleOpenChannel}/>;
  }
  return (
    <div style={{fontFamily:'-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Arial,sans-serif',background:C.bg,minHeight:'100vh',color:C.white}}>
      <style>{`*{box-sizing:border-box;margin:0;padding:0;}::-webkit-scrollbar{width:4px;height:4px;}::-webkit-scrollbar-thumb{background:#404040;border-radius:2px;}body{background:#141414;overflow-x:hidden;}button:focus{outline:none;}@media(max-width:768px){.mobile-menu-btn{display:block!important;}.nav-links{display:none!important;}}
@media(max-width:768px){
  .nav-links{display:none!important;}
  .hero-text{padding:0 16px 60px!important;}
  .hero-title{font-size:clamp(28px,8vw,48px)!important;}
  .hero-desc{display:none!important;}
  .shelf-pad{padding:4px 16px!important;}
  .shelf-title{padding:0 16px!important;}
  .category-grid{grid-template-columns:repeat(2,1fr)!important;padding:16px!important;}
  .watch-grid{grid-template-columns:1fr!important;}
  .watch-details-grid{grid-template-columns:1fr!important;}
  .dashboard-grid{grid-template-columns:repeat(2,1fr)!important;}
  .dashboard-earn{flex-direction:column!important;gap:16px!important;}
  .studio-main-grid{grid-template-columns:1fr!important;}
  .studio-form-two{grid-template-columns:1fr!important;}
  .studio-form-three{grid-template-columns:1fr!important;}
  .studio-action-row{flex-direction:column!important;align-items:stretch!important;}
}
@media(max-width:480px){
  .category-grid{grid-template-columns:repeat(2,1fr)!important;}
  .dashboard-grid{grid-template-columns:1fr 1fr!important;}
}
@media(max-width:1180px){
  .studio-main-grid{grid-template-columns:1fr!important;}
  .studio-form-three{grid-template-columns:1fr!important;}
}
@media(max-width:900px){
  .studio-form-two{grid-template-columns:1fr!important;}
}`}</style>

      {showPaywall && (
        <PaywallModal
          onClose={() => setShowPaywall(false)}
          onSubscribe={() => {
            setShowPaywall(false);
            setToast({
              message:'Viewer subscriptions are not open yet. You have joined early access for launch updates.',
              type: 'info'
            });
          }}
          show={paywallShow}
        />
      )}
      {toast&&<Toast {...toast} onClose={()=>setToast(null)}/>}
      <TopNav user={user} screen={screen} onNav={handleNav} onLogout={handleLogout} onSearch={()=>setShowSearch(true)}/>
      <LeftRail user={user} current={screen} onNav={handleNav} onLogout={handleLogout} />
      {showSearch&&(
        <div style={{position:'fixed',inset:0,background:'rgba(4,7,12,0.92)',zIndex:600,paddingTop:68,backdropFilter:'blur(18px)'}}>
          <div style={{padding:'24px 4%'}}>
            <div style={{background:'radial-gradient(circle at 84% 16%, rgba(241,198,109,0.08) 0%, transparent 18%), linear-gradient(135deg,rgba(18,28,42,0.94),rgba(13,20,30,0.96) 58%,rgba(20,30,44,0.98) 100%)',border:`1px solid ${C.border}`,borderRadius:28,padding:'26px 26px 22px',boxShadow:'0 20px 48px rgba(0,0,0,0.24)',marginBottom:24}}>
              <div style={{fontSize:12,fontWeight:800,letterSpacing:2,textTransform:'uppercase',color:'#f3dfb4',marginBottom:10}}>Search VAULTT</div>
              <div style={{display:'flex',gap:12,alignItems:'center',marginBottom:10}}>
                <input autoFocus value={searchQuery} onChange={e=>setSearchQuery(e.target.value)} placeholder="Search shows, creators and categories..." style={{flex:1,padding:'16px 18px',background:'rgba(255,255,255,0.05)',border:`1px solid ${C.border}`,borderRadius:18,fontSize:16,color:C.white,outline:'none',fontFamily:'inherit'}}/>
                <button onClick={()=>{setShowSearch(false);setSearchQuery('');}} style={{padding:'16px 18px',background:'rgba(255,255,255,0.04)',border:`1px solid ${C.border}`,borderRadius:18,color:C.white,cursor:'pointer',fontFamily:'inherit',fontSize:14,fontWeight:700}}>Close</button>
              </div>
              <div style={{fontSize:14,color:C.grey2,lineHeight:1.7}}>
                Find the next show, creator channel or category worth watching.
              </div>
            </div>
            {searchQuery.length>0&&(()=>{
              const q=searchQuery.toLowerCase();
              const realFS=allDbShows.map(s=>({...s,g:'135deg,#27384d,#4d6079',emoji:'X',match:99,cat:s.category||s.type,creator:'VAULTT Creator',desc:s.description||s.title,eps:s.episode_count||1}));
              const results=[...realFS,...DEMO_SHOWS].filter(s=>(s.title&&s.title.toLowerCase().includes(q))||(s.creator&&s.creator.toLowerCase().includes(q))||(s.cat&&s.cat.toLowerCase().includes(q))||(s.desc&&s.desc.toLowerCase().includes(q)));
              return results.length>0?(
                <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(220px,1fr))',gap:16}}>
                  {results.map(s=>(
                    <div key={s.id} onClick={()=>{setShowSearch(false);setSearchQuery('');handleWatch(s);}} style={{cursor:'pointer',borderRadius:24,overflow:'hidden',background:'linear-gradient(180deg,rgba(20,26,36,0.94),rgba(14,20,28,0.94))',border:`1px solid ${C.border}`,boxShadow:'0 14px 32px rgba(0,0,0,0.18)'}}>
                      <div style={{aspectRatio:'16/9',background:`linear-gradient(${s.g})`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:34,position:'relative'}}>
                        <PosterArtwork show={s} size='search' rank={s.top10} />
                      </div>
                      <div style={{padding:'14px 14px 16px'}}>
                        <div style={{fontSize:15,fontWeight:800,color:C.white,marginBottom:4,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{s.title}</div>
                        <div style={{fontSize:12,color:C.grey2,marginBottom:8}}>{s.creator}</div>
                        <div style={{fontSize:12,color:C.green,fontWeight:700}}>{s.match}% match</div>
                      </div>
                    </div>
                  ))}
                </div>
              ):(
                <div style={{textAlign:'center',padding:'48px 0',color:C.grey}}>
                  <div style={{fontSize:40,marginBottom:12}}>🔍</div>
                  <div style={{fontSize:16,fontWeight:700,color:C.white,marginBottom:6}}>No results for "{searchQuery}"</div>
                  <div style={{fontSize:13}}>Try searching for a show title, creator name or category</div>
                </div>
              );
            })()}
            {searchQuery.length===0&&(
              <div>
                <div style={{fontSize:13,fontWeight:700,color:C.grey,letterSpacing:1.4,textTransform:'uppercase',marginBottom:14}}>Popular searches</div>
                <div style={{display:'flex',gap:10,flexWrap:'wrap'}}>
                  {['PSL','Amapiano','Comedy','Business','Drama','Sports','Podcast','Talk Show'].map(t=>(
                    <button key={t} onClick={()=>setSearchQuery(t)} style={{padding:'10px 16px',background:'rgba(255,255,255,0.06)',border:`1px solid ${C.border}`,borderRadius:999,color:C.white,cursor:'pointer',fontFamily:'inherit',fontSize:13,fontWeight:700}}>{t}</button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {screen==='home'&&<HomeScreen user={user} onWatch={handleWatch} onNav={handleNav} myList={myList} onAddList={handleAddList} onDbShowsLoaded={setAllDbShows} continueWatching={continueWatching} onOpenChannel={handleOpenChannel} />}
      {screen==='nightdrop'&&<NightDropScreen user={user} onNav={handleNav} onWatch={handleWatch} setToast={setToast} />}
      {screen==='nightdrop-admin'&&user?.email==='creators@vaultt.co.za'&&<NightDropAdminScreen onBack={()=>setScreen('nightdrop')} setToast={setToast} onOpenPublic={()=>setScreen('nightdrop')} />}
      {screen==='creator-channel'&&activeChannel&&<CreatorChannelScreen user={user} channel={activeChannel} onBack={()=>setScreen('home')} onJoinMembership={handleJoinMembership} onWatch={handleWatch} onCreateTip={handleCreateTip} />}
      {screen==='watch'&&activeShow&&<WatchScreen show={activeShow} onBack={()=>setScreen('home')} onHome={()=>setScreen('home')} myList={myList} onAddList={handleAddList} onWatch={handleWatch}/>}
      {screen==='live'&&<LiveScreen onNav={handleNav} user={user} />}
      {(screen==='originals'||screen==='sports'||screen==='talkshows'||screen==='podcasts')&&<CategoryScreen category={screen} title={screen==='originals'?'SA Originals':screen==='sports'?'Sports':screen==='talkshows'?'Talk Shows':'Podcasts'} onWatch={handleWatch} onAddList={handleAddList} myList={myList} onNav={handleNav} user={user}/>}

      <div style={{padding:'24px 4%', textAlign:'center', fontSize:12, color:'#9CA3AF'}}>
        <a href="/VAULTT_Terms_of_Service.pdf" target="_blank" rel="noreferrer" style={{color:'#0071EB', marginRight:16}}>
          Terms of Service
        </a>
        <a href="/VAULTT_Privacy_Policy.pdf" target="_blank" rel="noreferrer" style={{color:'#0071EB'}}>
          Privacy Policy
        </a>
      </div>
    </div>
  );
}
